var modal; /* LGCOMSPEED-6 */

/* LGCOMSPEED-6 */
var vendersGP = $('#gpuVenders').val(); 
var venders = [];
if(!!vendersGP){
    venders = vendersGP.split(','); 
}
var canvas = document.createElement("canvas")
var webgl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl")
var debugInfo = webgl.getExtension("webgl_debug_renderer_info")
var gpuVendor = webgl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
var gpuRenderer = webgl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
var availableGPU = function(vs, gv, gr) {
    var result = false;
    vs.forEach(function(v) {
        if (gv.toUpperCase().indexOf(v) > -1 || gr.toUpperCase().indexOf(v) > -1) {
            result = true
            return;
        }
    })
    return result;
}(venders, gpuVendor, gpuRenderer);
/* // LGCOMSPEED-6 */

//LGEITF947-2 Start
var videoIdxGPC0009 = 0;
//LGEITF947-2 End

/* LGCOMSPEED-6(5th), LGEBR-1251 Start */
var vipCheckGPC0009;
function priceSyncLazyloadGPC0009(){
	var $obj=$('.GPC0009');
	/* LGCOMSPEED-6, LGEITF-604 Start */
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === 'data-is-vip') {
				vipCheckGPC0009 = mutation.target.getAttribute('data-is-vip');
				priceSyncSet(mutation.target.getAttribute('data-is-vip'))
				preShipmentHide(); //LGEAU-644
		    	observer.disconnect();		
				// LGENL-276
				promotionTagTextSet();
			}
		});
	});
	observer.observe(document.querySelector('.GPC0009'), {
		attributes: true, childList: false, characterData: false
	});
	
	/* PJTSUMMARY-1 정인혁 delivery-list, file-list 없을때 영역 display- none 처리 start*/
	if($('.file-list').html().replace(/\n/gi,'').replace(/\t/gi,'')==''){
		$('.downFiles').addClass('d-none');
	}
	if($(".delivery-list").find("li").length == 0){
		$(".delivery-area").addClass('d-none');
	}
	/* PJTSUMMARY-1 정인혁 delivery-list, file-list 없을때 영역 display- none 처리 end*/

	if($obj.attr('data-is-vip') != 'NULL'){
		vipCheckGPC0009 = $obj.attr('data-is-vip');
		priceSyncSet($obj.attr('data-is-vip'))
		preShipmentHide(); ////LGEAU-644
		observer.disconnect();		
		
		// LGENL-276
		promotionTagTextSet();
	}
	
	//LGEAU-644 START
	function preShipmentHide(){
		var obsGroupCheck;
		var $preOrderArea = $obj.find('.pre-order-area .pre-order-inner');
		 if ( COUNTRY_CODE.toLowerCase()=='au' ) {
			 obsGroupCheck = $('.navigation').attr('data-obs-group');
			 if ( obsGroupCheck == "B2E" ) {
				 $preOrderArea.find('.free-delivery').addClass('d-none');
	         } else {
	        	 $preOrderArea.find('.free-delivery').removeClass('d-none');
	         } 
		 }
	}
	//LGEAU-644 END
	
	function priceSyncSet(flag){
		if(flag == 'false'){
			var submodel = $obj.data('default-model');
			if(!submodel) {
				priceSyncGPC0009.init();
			}
		}else{ // ISVIP
			$(priceSyncGPC0009.el).find('.price-area:not(.ru-ver)').removeClass('d-none');
			$(priceSyncGPC0009.el).find('.price-pdp-Installment').removeClass('d-none');
			$('.GPC0011').find('.product-selling-price').removeClass('d-none');

			// LGCOMSPEED-6, LGEITF-853(LGECZ-424), LGEPL-697, LGCOMMON-54 Start
			// for only improve type - GPC0102 price (B2C/B2B2C)
			const fetchedSummaryPriceInfo = $obj.find('.product-box:first');
			const directFromGpc0102 = $('.GPC0102').find('.directFrom .price-area[data-lazyload-vip]');
			const lazyLoadVipPriceTemplate = $('#lazyLoadVipPriceTemplate').clone().html();
			$('#lazyLoadVipPriceTemplate').remove();
			if(fetchedSummaryPriceInfo.length && directFromGpc0102.length && lazyLoadVipPriceTemplate != undefined){
				const fetchedPriceBox = fetchedSummaryPriceInfo.find('.price-box:not(.d-none) .price-d');
				const directDelPriceFlag = fetchedPriceBox.find('.price-del').length && !fetchedPriceBox.find('.price-del').hasClass('d-none') ? true : false;

				directFromGpc0102.html(lazyLoadVipPriceTemplate);

				// price
				let directVipPrice = fetchedPriceBox.find('.price-won').clone().html();
				directVipPrice = directVipPrice.replace('<span>','<span class="number">');
				directFromGpc0102.find('.purchase-price .price').html(directVipPrice);

				// discount price info
				if(directDelPriceFlag){
					let directDelPriceLabel = fetchedPriceBox.find('.price-del').attr('aria-label');
					let directDelPrice = fetchedPriceBox.find('.price-del').clone().html();
					directDelPrice = directDelPrice.replace('<span>','<span class="number">');
					let directLegal = fetchedPriceBox.find('.sub-d span').text();
					
					//[Start] LGEDE-1151 "has-uvp" 추가
					if(COUNTRY_CODE.toLowerCase() == 'de'){
						if(directFromGpc0102.find('.product-price .price.has-uvp').length>0) {
							directFromGpc0102.find('.product-price .price.has-uvp .number').text(directLegal);
						};
						directFromGpc0102.find('.product-price').removeClass('d-none');
					}else{
						directFromGpc0102.find('.product-price .price').attr('aria-label', directDelPriceLabel).html(directDelPrice);
						directFromGpc0102.find('.product-price .legal').text(directLegal);
						directFromGpc0102.find('.product-price').removeClass('d-none');
					}
					//[End] LGEDE-1151
				}
			}
			// LGCOMSPEED-6, LGEITF-853(LGECZ-424), LGEPL-697, LGCOMMON-54 End

			/*PJTSUMMARY-1 START*/
			if($('.GPC0009.improve').find('.component-rPrice').val()!=''){
				$(priceSyncGPC0009.el).find('.price-pdp-area').removeClass('d-none');
				//LGCOMNL-486 START
				var regularPriceText = $(priceSyncGPC0009.el).find('.price-pdp-area').find('.regular-price-text');
				regularPriceText.removeClass('d-none');
				if(regularPriceText.find('.price-d').val() != ''){
					regularPriceText.addClass('d-none');
				}
				//LGCOMNL-486 END
			}
			if($(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){
				$('.GPC0009.improve').find('.fixed-price').removeClass('d-none');
			}
			/*PJTSUMMARY-1 END*/
    	}
	}
	/* LGCOMSPEED-6, LGEITF-604 End */
	
	/* PJTSUMMARY-1 모바일 가격영역 없을시 display- none 처리 start */
    if($('.price-area').length != 0){
        if($('.price-area').html().replace(/\n/gi,'').replace(/\t/gi,'')==''){
            $('.simple-price-area').addClass('d-none');
        }
    }
	/* PJTSUMMARY-1 모바일 가격영역 없을시 display- none 처리 end */

    // LGENL-276
	function promotionTagTextSet(){
		if( vipCheckGPC0009 == "true" && $obj.find(".promotionTagText").length > 0){
			$obj.find(".promotionTagText").hide();
			$obj.find(".promotionTagOut").show("");
		}else if($(".promotionTagText").length > 0){
			$obj.find(".promotionTagText").show("");
			$obj.find(".promotionTagOut").hide();
		}
	}	
}
window.addEventListener("load", function(event) {
	//LGEGMC-177
	var $obj=$('.GPC0009');
	if($obj.find('input[name=priceSyncLazyload]').val() !== 'N') priceSyncLazyloadGPC0009();	
});
/* LGCOMSPEED-6(5th), LGEBR-1251 End */

$(document).ready(function() {
    if(!document.querySelector('.GPC0009')) return false;
    
    //LGEGMC-177
    var $obj=$('.GPC0009');
    var common = {
        breakpointMaxMd: mql.maxMd,
        breakpointMaxSm: mql.maxSm,
        p: null
    };

    /* LGEBR-1251 Start */
    if($obj.find('input[name=priceSyncLazyload]').val() == 'N') priceSyncLazyloadGPC0009();
    /* LGEBR-1251 End */
    
    /* LGEPA-84 20200806 add */
    (function($){
        var $tmpl = $('#pdpFloatingIconTemplate');
        $tmpl.length && $($tmpl[0].innerHTML).find('.btn-whatsapp').click(function(e){
            var $this = $(this);
            var btnLink = $this.data('float-btn-link');
            btnLink && openWin(btnLink, '', $this.data('width') , $this.data('height'));
        }).end().appendTo('body').show();
    }(jQuery));
    /* //LGEPA-84 20200806 add */
    
    var $snsArea = $('.pdp-summary-area .sns-area');
    $snsArea.find('.sns').on('click', function(e){
        e.preventDefault();
        // 20200319 START 9번 컴포넌트 share 에서 쿠키 설정 제거
        //if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_SOCIAL_MEDIA')) {
                var $snsLayer = $(this).closest('.sns-area').find('.list');
                if($snsLayer.hasClass('active')) {
                    $snsLayer.removeClass('active');
                } else {
                    $snsLayer.addClass('active');
                }
        //} else {
        //  ePrivacyCookies.view('click');
        //}
        // 20200319 END
    });

    // LGEGMC-3074 Start
    var urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) return null
        else return decodeURI(results[1]) || 0
    };

    var clickReveiw = function(InfoDivByDevice){
        var $reviewBtn = $obj.find(InfoDivByDevice).find('.bv_button_component_container #WAR');
        if($reviewBtn.length > 0) { // bv load 완료 체크
            $reviewBtn.trigger('click');
            clearInterval(bvLoadCheck);
        }
    };

    if(urlParam('writeReview') != '' && urlParam('writeReview') == 'click'){
        var InfoDivByDevice = isMobile ? '.mobile-top-info' : '.desktop-info';
        var bvLoadCheck = setInterval(clickReveiw, 500, InfoDivByDevice);
    }
    // LGEGMC-3074 End

    // in house review (go to review area)
    // 20200421 START 박지영
    $('.GPC0009').on('click', '.rating.inhouse-review a', function(e) {
        
        /* LGECN-214 Start */
        if(COUNTRY_CODE.toLowerCase() == 'cn'){
            var star_level = $(this).find('.star-area').data('model-overallscore');
            baiduTrackEvent('rating', $(this).closest('.GPC0009'), 'PDP', { list_name:$lg_cggroup, 'star_level': star_level});
        }
        /* LGECN-214 End */
        
    // 20200421 END
        e.preventDefault();
        var $target = $('#pdp_review');
        var $trigger = $('.GPC0011 .tab-menu a[href="#pdp_review"]');
        if($target.length>0 && $trigger.length>0) {
            $trigger.trigger('click');
        }
        if($(this).hasClass('write-a-review')) {
            var button = $('.GPC0103 .write-button > a').trigger('click');
        }
    });

    modal = { /* LGCOMSPEED-6 */
        ready: true,
        el: {
            /* PJTSUMMARY-4_krchoi MODIFY */
            /*
             *  || document.getElementById('modal_pdp_detail_gallery_improve' 추가
            */
            gallery: document.getElementById('modal_pdp_detail_gallery') || document.getElementById('modal_pdp_detail_gallery_improve')
        },
        is360VR : null,
        /* LGEGMC-849 : 20201104 add */
        isVR : null,
        /*// LGEGMC-849 : 20201104 add */
        /* LGEGMC-1632 add */
        isAR : null,
        /*//LGEGMC-1632 add */
        /* LGEGMC-3124 add*/
        is3603D : null,
        /* //LGEGMC-3124 add*/
        iframe: {
            target: null,
            code: null, 
            get360viewCode: function(t){
                var url = t.getAttribute('data-href'),
                    title = t.getAttribute('data-title');
                var iframe;

                /* LGCOMSPEED-6 Start */
                var dnone = '';
                if(t.dataset.type == '3603D'){
                    dnone = 'class="d-none"'
                }
                iframe = '<iframe src="'+xssfilter(url)+'" title="'+xssfilter(title)+'" '+dnone+'></iframe>';
                /* PJTSUMMARY-4_krchoi REMOVE */
                //alert(iframe);
                /* LGCOMSPEED-6 End */
                return iframe;
            }
        },
        slick: {
            el : {
                nav: null,
                visual: null
            },
            opt : {
                nav: {
                    /* LGEUS-11794 : 20190813 modify */
                    listStyle:true, // WA-Common-Slick
                    lazyLoad: 'progressive',
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    //asNavFor: '#modal_detail_target',
                    dots: true,
                    focusOnSelect: true,
                    vertical: false,
                    dotsClass: 'pdp-pagination',
                    swipeToSlide : true,
                    defaultFocus : true
                    /* //LGEUS-11794 : 20190813 modify */
                },
                visual: {
                    listStyle:true, // WA-Common-Slick
                    swipe: false,
                    infinite: false,
                    lazyLoad: 'progressive',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '#modal_thumbnail_target',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                swipe: true
                            }
                        }
                    ]
                }
            },
            setIdx: function(){
                var _this = modal,
                    _slick = modal.slick,
                    _idx = _this.el.gallery.getAttribute('data-current-idx');

                if(_idx && typeof Number(_idx) == 'number') {
                    $(_slick.el.visual)
                        .slick('slickGoTo', _idx).slick('slickSetOption', {speed:300});
                    $(_slick.el.nav).slick('slickGoTo', _idx);
                }
            },
            init: function(e){
                //console.log(e.type);

                var _this = modal,
                    _slick = modal.slick,
                    init = _this.el.gallery.getAttribute('data-initialized');

                if(e.type == 'shown' && !init) {
                    $(_slick.el.visual).on({
                        init: function(){
                            setTimeout(function(){
                                $(_slick.el.visual).slick('slickSetOption', {speed:10});
                                _slick.setIdx();
                            }, 10);
                        }
                    });
                    for( var key in _slick.el ) {
                        var _curSlick = _slick.el[key];
                        if(!$(_curSlick).is('.slick-initialized')){
                            $(_curSlick).slick(_slick.opt[key]);
                        }
                    }
                    _slick.filterBranch(common.breakpointMaxSm, [true]);
                    _this.el.gallery.setAttribute('data-initialized', true);
                }else if(e.type == 'shown' && init){
                    // setPosition inside modal Slicks
                    setTimeout(function(){
                        $(_slick.el.visual).slick('setPosition');
                        $(_slick.el.nav).slick('setPosition');
                    },10);

                }else if(e.type == 'show' && init) {
                    _slick.setIdx();
                }

                _slick.addEvent();
            },
            filterBranch: function(e, firstCheck){
                var _this = modal,
                    _slick = modal.slick;

                if(!firstCheck) {
                    $(_this.el.gallery).modal('hide');
                }

                if (e.matches) { // mobile;
                    if(!$(_slick.el.nav).is('.slick-initialized')){
                        $(_slick.el.nav).slick(_slick.opt.nav);
                    }
                    /* LGEGMC-849 : 20201030 modify */
                    $(_slick.el.nav).slick('slickFilter', ':not(.view, .viewVr, .viewAr, .view360_v2)'); //LGEGMC-1632
                    $(_slick.el.visual).slick('slickFilter', ':not(.view, .viewVr, .viewAr, .view360_v2)'); //LGEGMC-1632
                    /*// LGEGMC-849 : 20201030 modify */
                    var $navItem = $(_slick.el.nav).find('.item');
                    var $visItem = $(_slick.el.visual).find('.item');

                    for (var i = 0; i < $navItem.length; i++) {
                        var idx = $navItem.eq(i).attr('data-slick-index');
                        // 20200608 START 박지영 - 오타로 인해 잘못 반영된 부분 수정
                        if(_this.is360VR || _this.is3603D) {
                        // 20200608 END
                            $navItem.eq(i).attr('data-slick-index', idx-1);
                            $visItem.eq(i).attr('data-slick-index', idx-1);
                        } else {
                            $navItem.eq(i).attr('data-slick-index', idx);
                            $visItem.eq(i).attr('data-slick-index', idx);
                        }
                    }
                } else {
                    // WA-GPC0009-04
                    $(_slick.el.nav).slick('slickUnfilter').slick('unslick').find('.item');
                    $(_slick.el.visual).slick('slickUnfilter');
                }
            },
            addEvent: function(){
                var _this = modal,
                    _slick = modal.slick;
                /* LGEUS-11794 : 20190813 modify */
                $(_slick.el.nav).find(".slick-list .slick-slide").on("click", function(e) {
                    e.preventDefault();
                    var idx = $(e.currentTarget).closest(".slick-slide").index();
                    $(_slick.el.visual).slick('slickGoTo', idx).slick('slickSetOption', {speed:300});
                    // 20200601 START 박지영 - 모바일 버그 수정 (slick-active 컨트롤 하는 부분 제거)
                    $(e.currentTarget).addClass('slick-current').siblings().removeClass('slick-current');
                    // 20200601 END
                });
                /* //LGEUS-11794 : 20190813 modify */
                $(_slick.el.visual).off().on({
                    init: function(event, slick){
                        //console.log(slick.$slides);
                        // setTimeout(function(){
                            $(_slick.el.visual).trigger('beforeChange', [slick, 0, 0]);
                            $(_slick.el.visual).trigger('afterChange', [slick, 0]);
                        // },100);
                    },
                    afterChange: function(event, slick, currentSlide){
                        var $this = slick.$slides.eq(currentSlide);
                        slick.$slides.eq(currentSlide).find('a').focus();
                        //var setidx =_this.el.gallery.getAttribute('data-current-idx');
                        //(_this.isAR)? $('#modal_thumbnail_target').find('.viewAr').hide():'';
                        var idx = currentSlide;
                        
                        /* LGEUS-11794 : 20190813 modify */
                        // 20200601 START 박지영 - 모바일 버그 수정 (slick-active 컨트롤 하는 부분 제거)
                        // 20200608 START 박지영 - 시간차를 두어 최초 로딩시에도 정상 반영되도록 수정
                        setTimeout(function() {
                            $(_this.el.gallery.querySelector(".thumbnail.slider-nav")).find(".slick-slide").eq(currentSlide).addClass('slick-current').siblings().removeClass('slick-current');
                        }, 200);
                        // 20200608 END
                        // 20200601 END
                        /* //LGEUS-11794 : 20190813 modify */
                        // 20200608 START 박지영 - 가끔 01로 출력되는 버그 수정
                        $(_this.el.gallery.querySelector('.pdp-visual-pagination .current')).text(parseInt(currentSlide)+1);
                        // 20200608 END

                        // iframe item check;
                        var _iframe = $this.find('.iframe-area')[0];
                        if(_iframe){
                            var i = $(_iframe).data(),
                                html;
                            /* LGEGMC-849 : 20201030 modify */
                            /*LGEGMC-1632*/
                            if(i.type == '360' || i.type == 'vr' || i.type == 'ar') { /* LGCOMSPEED-6 */
                            /*// LGEGMC-849 : 20201030 modify */
                                /*if(i.type == 'ar'&& $(".modal-pdp-gallery #modal_detail_target").find(".slick-list .slick-slide").eq(setidx).hasClass('viewAr')){
                                    setTimeout(function() {
                                        $(".modal-pdp-gallery #modal_detail_target").find(".slick-list .slick-slide").eq(idx).width($(_this.el.gallery).find(".modal-pdp-gallery").find('.modal-content').width());
                                    }, 200);
                                }*/
                                /*LGEGMC-1632*/
                                html = modal.iframe.get360viewCode(_iframe);
                                $(_iframe).html(html);
                            /* LGCOMSPEED-6 Start */
                            }else if(i.type == '3603D'){
                                _iframe = $this.find('.iframe-area[data-type=3603D]')[0];
                                if(!!!$(_iframe).html()){ 
                                    html = modal.iframe.get360viewCode(_iframe);
                                    $(_iframe).html(html);
                                }
                                $(_iframe).find('iframe').removeClass('d-none');
                            /* LGCOMSPEED-6 End */
                            }else if(i.type == 'youtube'){
                                if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
                                    $(_iframe).html('<div id="videoPlayerCode"></div>');
                                    setTimeout(function() {
                                        /* LGCOMSPEED-6(4th) Start */
                                        let timerVideo = null;
                                        
                                        function lazyloadJsVideo() {
                                            if(typeof YT == 'undefined') {
                                                timerVideo = setTimeout(lazyloadJsVideo, 100);
                                            } else {
                                                if(typeof YT.Player == 'undefined') setTimeout(lazyloadJsVideo, 100);
                                                if(timerVideo !== null) clearTimeout(timerVideo);
                                        /* LGCOMSPEED-6(4th) End */
                                        var player = new YT.Player('videoPlayerCode', {
                                            height: '360',
                                            width: '640',
                                            videoId: _iframe.getAttribute('data-href').split('watch?v=')[1],
                                            host: 'https://www.youtube.com',
                                            events: {
                                                'onReady': onPlayerReady,
                                                'onStateChange': onPlayerStateChange
                                            }
                                        });

                                        function onPlayerReady(event) {
                                            event.target.playVideo();
                                        }
                                        function onPlayerStateChange(event) {
                                            if (event.data == YT.PlayerState.PLAYING) {
                                                console.log('adobe-video', video.getTitle('youtube', player), 'play');
                                                adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'play'});
                                            }
                                            if (event.data == YT.PlayerState.PAUSED) {
                                                console.log('adobe-video', video.getTitle('youtube', player), 'pause');
                                                adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'pause'});
                                            }
                                        }
                                        
                                        var videoStatus = [0, 0, 0, 0];
                                        videoInterval = setInterval(function() {
                                            // console.log(player.getVideoData().title);
                                            if(typeof player == 'object' && typeof player.getDuration == 'function') {
                                                var a = player.getDuration();
                                                var c = player.getCurrentTime();
                                                var p = parseInt((c*100)/a);
                                                for(var i=1;i<=4;i++) {
                                                    if(p>=(25*i) && videoStatus[i-1]==0) {
                                                        videoStatus[i-1] = 1;
                                                        console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*i));
                                                        adobeSatellite('video_track',{name:video.getTitle('youtube', player), event:'ratio_'+(25*i)});
                                                    }
                                                }
                                                if(p>=99 && videoStatus[3]==0) {
                                                    videoStatus[3]=1;
                                                    console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*4));
                                                    adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'ratio_'+(25*4)});
                                                }
                                            }
                                        }, 2000);
                                        /* LGCOMSPEED-6(4th) Start */
                                            }
                                        }
                                        lazyloadJsVideo();
                                        /* LGCOMSPEED-6(4th) End */
                                    }, 10);
                                } else {
                                    ePrivacyCookies.view('load', 'small', $(_iframe));
                                }
                            }else if(i.type == 'brightcove'){
                                if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
                                $(_iframe).html('<div id="videoPlayerCode"></div>');
                                    var myPlayer,
                                        playerHTML,
                                        playerData = {
                                            accountId: _iframe.getAttribute('data-account'),
                                            playerId: _iframe.getAttribute('data-player'),
                                            videoId: _iframe.getAttribute('data-video-id')
                                        };

                                    playerHTML = '<video-js id="brightCovePlayer" data-video-id="' +playerData.videoId +'"  data-account="' +playerData.accountId +'" data-player="' +playerData.playerId +'" data-embed="default" data-application-id autoplay class="video-js" controls></video-js>';
                                    setTimeout(function() {
                                        
                                        document.getElementById("videoPlayerCode").innerHTML = playerHTML;
                                        var s = document.createElement("script");
                                        s.src = "https://players.brightcove.net/" + playerData.accountId + "/" + playerData.playerId + "_default/index.min.js"; 
                                        document.body.appendChild(s);
                                        s.onload = callback;
                                        function callback() {
                                            if($('#brightCovePlayer').length>0) {
                                                myPlayer = bc(document.getElementById('brightCovePlayer'));
                                                myPlayer.on("loadedmetadata", function() {
                                                    myPlayer.muted(false);
                                                    myPlayer.play();
                                                });
                                                myPlayer.on("pause", function() {
                                                    console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'pause');
                                                    adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'pause'});
                                                });
                                                myPlayer.on("play", function() {
                                                    console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'play');
                                                    adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'play'});
                                                });
                                            }
                                        }
                                        
                                        /* LGCOMSPEED-6(4th) Start */
                                        let timerVideo = null;
                                        
                                        function lazyloadJsVideo() {
                                            if(typeof video == 'undefined') {
                                                timerVideo = setTimeout(lazyloadJsVideo, 100);
                                            } else {
                                                if(timerVideo !== null) clearTimeout(timerVideo);
                                        /* LGCOMSPEED-6(4th) End */     
                                        var videoStatus = [0, 0, 0, 0];
                                        videoInterval = setInterval(function() {
                                            //console.log(myPlayer.mediainfo.name);
                                            if($('#brightCovePlayer').length>0) {
                                                var a = myPlayer.mediainfo.duration;
                                                var c = myPlayer.currentTime();
                                                var p = parseInt((c*100)/a);
                                                for(var j=1;j<=4;j++) {
                                                    if(p>=(25*j) && videoStatus[j-1]==0) {
                                                        videoStatus[j-1] = 1;
                                                        console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*j));
                                                        adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*j)});
                                                    }
                                                }
                                                if(p>=99 && videoStatus[3]==0) {
                                                    videoStatus[3]=1;
                                                    console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*4));
                                                    adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*4)});
                                                }
                                            }
                                        }, 2000);
                                        /* LGCOMSPEED-6(4th) Start */
                                            }
                                        }
                                        lazyloadJsVideo();
                                        /* LGCOMSPEED-6(4th) End */
                                    }, 10);
                                } else {
                                    ePrivacyCookies.view('load', 'small', $(_iframe));
                                }
                            }
                        }
                    },
                    beforeChange: function(event, slick, currentSlide, nextSlide){
                        var $this = slick.$slides.eq(currentSlide),
                            $next = slick.$slides.eq(nextSlide);

                        
                        /* LGCOMSPEED-6 Start */
                        $('#modal_pdp_detail_gallery').removeClass('invisible');

                        var _thisIframe3D = $this.find('.iframe-area[data-type=3603D]')[0];
                        if(_thisIframe3D) {
                            if (availableGPU) {
                                $(_thisIframe3D).find('iframe').addClass('d-none');
                            } else {
                                $(_thisIframe3D).find('iframe').remove();
                            }
                        }
                        
                        var _thisIframe = $this.find('.iframe-area:not([data-type=3603D])')[0];
                        /* LGCOMSPEED-6 End */
                        if(_thisIframe) {
                            $(_thisIframe).html('');
                        }

                        var _iframe = $next.find('.iframe-area')[0];
                        if(_iframe){
                            $(_this.el.gallery).addClass('loaded-iframe');
                        }else {
                            $(_this.el.gallery).removeClass('loaded-iframe');
                        }
                    }
                });

                $(_this.el.gallery).off('click.nav, keydown').on({
                    'click.nav, keydown': function(e){
                        e.preventDefault(); //LGCOMSPEED-6(gallery)
                        if((e.type == 'keydown' && e.keyCode == 13) || e.type == 'click') {
                            var idx = $(e.currentTarget).index();
                            //console.log(e.type, idx);
                            $(_slick.el.visual)
                                .slick('slickGoTo', idx).slick('slickSetOption', {speed:300});
                            $(e.currentTarget).addClass('slick-current slick-active').siblings().removeClass('slick-current slick-active');
                        }
                    }
                }, '#modal_thumbnail_target:not(.slick-initialized) .item');
                common.breakpointMaxSm.addListener(_slick.filterBranch);
            }
        },
        zoom: {
            _opt : {
                mobile : {
                    transition: true,
                    cursor: 'inherit',
                    disablePan: false,
                    disableZoom: false,
                    disableXAxis: false,
                    disableYAxis: false,
                    which: 1,
                    increment: 0.2,
                    linearZoom: false,
                    panOnlyWhenZoomed: true,
                    minScale: 1,
                    maxScale: 2,
                    rangeStep: 0.05,
                    duration: 200,
                    contain: false,
                    onPan: function(){
                        $(this).addClass('dragged');
                    },
                    onZoom: function(){
                        var $n = $(this);
                        var matrix = $n.panzoom("getMatrix");
                        if(matrix[0] <= "1.1") {
                            if(matrix[4] != 0 && matrix[5] != 0){
                                $n.panzoom("reset");
                            }
                        }
                    }
                },
                pc: {
                    transition: true,
                    cursor: 'inherit',
                    disablePan: false,
                    disableZoom: false,
                    disableXAxis: false,
                    disableYAxis: false,
                    which: 1,
                    increment: 0.2,
                    linearZoom: false,
                    panOnlyWhenZoomed: true,
                    minScale: 1,
                    maxScale: 2,
                    rangeStep: 0.05,
                    duration: 200,
                    contain: false,
                    onPan: function(){
                        $(this).addClass('dragged');
                    },
                    onZoom: function(){
                        var $n = $(this);
                        var matrix = $n.panzoom("getMatrix");
                        if(matrix[0] <= "1.1") {
                            if(matrix[4] != 0 && matrix[5] != 0){
                                $n.panzoom("reset");
                            }
                        }
                    }
                }
            },
            init: function(){
                var _this = modal;
                var _zoom = this;
                var zoomImg = _this.el.gallery.querySelectorAll('.zoom-area img');

                if(!_this.el.gallery.getAttribute('data-zoom-event')){
                    _this.el.gallery.setAttribute('data-zoom-event', true);
                    _zoom.addEvent();
                }
                
            },
            zoomin: function($target, opt, max){
                $target.panzoom("zoom", false, {
                    increment: max ? opt.maxScale : opt.increment,
                    animate: true
                });
                if(opt.maxScale == $target.panzoom("getMatrix")[0]){
                    $target.parent('.zoom-area').addClass('zoomout');
                }else {
                    $target.parent('.zoom-area').removeClass('zoomout');
                }
            },
            zoominpos: function(e,$target, opt, max){
                $target.panzoom("zoom", false, {
                    increment: max ? opt.maxScale : opt.increment,
                    animate: true,
                    focal:e
                });
                if(opt.maxScale == $target.panzoom("getMatrix")[0]){
                    $target.parent('.zoom-area').addClass('zoomout');
                }else {
                    $target.parent('.zoom-area').removeClass('zoomout');
                }
            },
            zoomout: function($target, opt){
                if($target.panzoom("getMatrix")[0] <= (1+opt.increment)) {
                    $target.panzoom("reset");
                }else {
                    $target.panzoom("zoom", true, {
                        increment: opt.increment,
                        animate: true
                    });
                }
                $target.parent('.zoom-area').removeClass('zoomout');
            },
            clickAction: function(e){
                var _this = modal,
                    _zoom = _this.zoom,
                    currentTarget = e.currentTarget ? e.currentTarget : e.target,
                    $target = $(currentTarget),
                    opt;

                if($target.is('.pc')) {
                    $target.panzoom(_zoom._opt.pc);
                }else {
                    $target.panzoom(_zoom._opt.mobile);
                }
                opt = $target.panzoom("option");

                if(!$target.is('.dragged')) {
                    var $area = $target.parent('.zoom-area');
                    if(!$area.is('.zoomout')) {
                        if(e.type == 'doubletap') {
                            //_zoom.zoomin($target, opt, true); // maximum zoomin
                            _zoom.zoominpos(e,$target, opt, true); // maximum zoomin
                        }else {
                            //_zoom.zoomin($target, opt);
                            _zoom.zoominpos(e,$target, opt);
                        }
                    }else {
                        $target.panzoom('reset');
                        $area.removeClass('zoomout');
                    }
                }

                $target.removeClass('dragged');
            },
            addEvent: function(){
                var _this = modal,
                    _zoom = this;
                $(_this.el.gallery).on({
                    'click.panzoom': function(e){
                        var $target = $(_this.el.gallery).find('.slick-active .zoom-area img');
                        var opt;
                        var $btn = $(e.currentTarget);

                        if(common.breakpointMaxSm.matches) {
                            $target = $target.filter('.mobile');
                        }else {
                            $target = $target.filter('.pc');
                        }

                        if($target.is('.pc')) {
                            $target.panzoom(_zoom._opt.pc);
                        }else {
                            $target.panzoom(_zoom._opt.mobile);
                        }
                        opt = $target.panzoom("option");

                        opt = $target.panzoom("option");

                        if($btn.is('.plus')){
                            _zoom.zoomin($target, opt);
                        }else if($btn.is('.minus')){
                            _zoom.zoomout($target, opt);
                        }
                    }
                }, '.control button');

                if ('ontouchstart' in window){
                    // in touch device
                    var $target = $(_this.el.gallery).find('.zoom-area img');
                    if(common.breakpointMaxSm.matches) {
                        $target = $target.filter('.mobile');
                    }else {
                        $target = $target.filter('.pc');
                    }
                    for (var i = 0; i < $target.length; i++) {
                        var _target = $target.eq(i)[0];
                        var hammer = new Hammer(_target).on('doubletap', _zoom.clickAction);
                        /*
                        hammer.on('pinch pinchend', function(e) {
                            _target.panzoom("setMatrix", '1, 0, 0, 1, 0, 0');
                            alert('1, 0, 0, 1, 0, 0');
                        });
                        */
                    }
                }else {
                    $(_this.el.gallery).on({
                        click: _zoom.clickAction,
                        wheel: function(e){
                            var $target = $(e.currentTarget);
                            if($target.is('.pc')) {
                                $target.panzoom(_zoom._opt.pc);
                            }else {
                                $target.panzoom(_zoom._opt.mobile);
                            }
                            opt = $target.panzoom("option");
                            var opt = $target.panzoom("option");
                            if(e.originalEvent.deltaY < 0) {
                                // zoom in
                                _zoom.zoomin($target, opt);
                            }else {
                                // zoom out
                                _zoom.zoomout($target, opt);
                            }
                        }
                    }, '.zoom-area img');
                }
            }
        },
        init: function(){
            var _this = this,
                _slick = _this.slick;

            // 20200608 START 박지영 - 360 vr 다음에 이미지가 출력되는 경우 모바일 디바이스 접속시 레이어 팝업 첫번째 썸네일에 +/- 버튼 출력되지 않았던 버그 수정
            _slick.el.nav = _this.el.gallery.querySelector('#modal_thumbnail_target');
            _slick.el.visual = _this.el.gallery.querySelector('#modal_detail_target');
            /* LGEGMC-849 : 20201030 modify */
            if(isMobile) {
                $('#modal_detail_target .item.view, #modal_detail_target .item.viewVr, #modal_detail_target .item.viewAr').remove(); /*LGEGMC-1632*/
                $('#modal_thumbnail_target .item.view, #modal_thumbnail_target .item.viewVr, #modal_thumbnail_target .item.viewAr').remove(); /*LGEGMC-1632*/
            }
            /*// LGEGMC-849 : 20201030 modify */
            if($('#base_desktop_target ul li.view.iframe').length>0) _this.is360VR = true;
            else _this.is360VR = false;
            // 20200608 END
            /* LGEGMC-849 : 20201104 add */
            if($('#base_desktop_target ul li.viewVr.iframe').length>0) _this.isVR = true;
            else _this.isVR = false;
            /*// LGEGMC-1632 add */
            if($('#base_desktop_target ul li.viewAR.iframe').length>0) _this.isAR = true;
            else _this.isAR = false;
            /*// LGEGMC-1632 add */
            if($('#base_desktop_target ul li.view360_v2.iframe').length>0) _this.is3603D = true;
            else _this.is3603D = false;
            _this.addEvent();
        },
        showDetailModal: function(idx){
            if($('.eprivacy-layer').length>0) $('.eprivacy-layer').remove();
            var _this = this;
            /*$('#modal_detail_target').removeClass('viewAR');
            $('#modal_thumbnail_target').show();
            $(modal.slick.el.nav).find('.item.viewAr').hide();
            if($(modal.slick.el.nav).find('.item').eq(idx).hasClass('viewAr')){
                $('#modal_detail_target').addClass('viewAR');
                $('#modal_thumbnail_target').hide();
            }*/
            console.log("1231236128361" , idx)
            _this.el.gallery.setAttribute('data-current-idx', idx);
            if($(modal.slick.el.visual).is('.slick-initialized')) {
                $(modal.slick.el.visual).trigger('afterChange', [$(modal.slick.el.visual).slick('getSlick'), idx]);

            }
            $(modal.slick.el.nav).find('.item').eq(idx).addClass('slick-active slick-current').siblings().removeClass('slick-active slick-current');
            $(modal.slick.el.nav).find('img').each(function() {
                $(this).attr('data-src', $(this).attr('data-lazy')).addClass('lazyload').removeAttr('data-lazy');
            });
            bindImgError();
            setTimeout(function() {
                $(_this.el.gallery).modal('show');
                _this.zoom.init();
            }, 100);
        },
        addEvent: function(){
            var _this = this,
                _slick = _this.slick;
            $(_this.el.gallery).on({
                'shown.bs.modal': _slick.init,
                'show.bs.modal': _slick.init,
                'hidden.bs.modal': function(){
                    if($('#videoPlayerCode .vjs-control-bar button.vjs-playing').length>0) {
                        $('#videoPlayerCode .vjs-control-bar button.vjs-playing').trigger('click');
                    }
                    /* LGCOMSPEED-6 Start */                    
                    $(this).find('.iframe-area:not([data-type=3603D])').find('iframe').remove();

                    var _thisIframe3D = $(this).find('.iframe-area[data-type=3603D]')[0];
                    if(_thisIframe3D) {
                        if (availableGPU) {
                            $(_thisIframe3D).find('iframe').addClass('d-none');
                        } else {
                            $(_thisIframe3D).find('iframe').remove();
                        }
                    }
                    /* LGCOMSPEED-6 End */
                }
            });
        }
    };

    var summaryGallery = {
        breakpoint: mql.maxMd, // ~ 991
        d: {
            el: document.getElementById('desktop_summary_gallery'),
            els: {
                nav: null,
                visual: null,
                objet: null
            },
            init: function(){
                var _d = this;
                _d.els.visual = _d.el.querySelector('.pdp-visual-image');
                _d.els.nav = _d.el.querySelector('.pdp-thumbnail-nav');
                _d.els.objet = _d.el.querySelector('.pdp-other-info');

                _d.setThumbnailsIdx();
                _d.addEvent();
                _d.el.setAttribute('data-initialized', true);
            },
            setThumbnailsIdx: function(){
                var _d = this;
                if(!_d.els.nav) _d.init();

                var lis = _d.els.nav.querySelectorAll('ul li');
                for (var i = 0; i < lis.length; i++) {
                    var _li = lis[i];
                    _li.setAttribute('data-idx', i);
                }

                var defaultIdx = $(_d.els.nav.querySelector('ul .thumbnail')).index();
                _d.els.visual.querySelector('img').setAttribute('data-idx', defaultIdx);
            },
            setImage: function(e){
                var _d = this,
                    _img = _d.els.visual.querySelector('img'),
                    /* 20190917 : LGEUS-12203 add */
                    img = e.target.tagName == 'IMG'?e.target:e.target.children[0],
                    /* //20190917 : LGEUS-12203 add */
                    anchor = e.currentTarget,
                    del = $(anchor).closest('li')[0],
                    src = img.getAttribute('data-medium'),
                    alt = img.getAttribute('data-large-alt') ? img.getAttribute('data-large-alt') : img.getAttribute('alt');

                _img.setAttribute('data-idx', del.getAttribute('data-idx'));
                _img.setAttribute('src', src);
                _img.setAttribute('alt', alt);

                $(del).addClass('active').siblings().removeClass('active');
            },
            addEvent: function(){
                var _d = this;
                $(_d.els.nav).on({
                    click: function(e){
                        e.preventDefault();
                        var del = $(this).closest('li')[0];
                        if($(del).is('.thumbnail') && !$(del).is('.more')){ // thumbnail button
                            $(".pdp-visual").removeClass("objet-kang");
                            _d.setImage(e);
                        }else if($(del).is('.more') || $(del).is('.iframe')){ // more button
                            $(".pdp-visual").removeClass("objet-kang");
                            if($(del).is('.video')) {
                                if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
                                    var idx = del.getAttribute('data-idx');
                                    modal.showDetailModal(idx ? idx : 0);
                                    $(modal.el.gallery).data('beforeFocus', e.currentTarget);
                                } else {
                                    ePrivacyCookies.view('click');
                                }
                            }else {
                                    var idx = del.getAttribute('data-idx');
                                    modal.showDetailModal(idx ? idx : 0);
                                    $(modal.el.gallery).data('beforeFocus', e.currentTarget);
                            }
                        }else if($(del).is('.view_objet')){
                            $(".pdp-visual").addClass("objet-kang");
                            $(del).addClass('active').siblings().removeClass('active');
                        }
                        //LGEITF-947-2 Start
                        else if ($(del).is('.video')) {
                            videoIdxGPC0009 = Number(del.getAttribute('data-idx'));
                        }
                        //LGEITF-947-2 End
                    }
                }, 'a');
                if($(_d.els.nav).find('ul li').length>0) {
                    $(_d.els.visual).on({
                        click: function(e){
                            e.preventDefault(); //LGCOMSPEED-6(gallery)
                            var idx = e.target.getAttribute('data-idx');
                            modal.showDetailModal(idx ? idx : 0);
                            $(modal.el.gallery).data('beforeFocus', e.currentTarget);
                        }
                    }, 'a');
                }
                $(_d.els.objet).on({
                    click: function(e){
                            e.preventDefault();
                            var del = $(this).closest('li')[0];
                            if($(del).is('.view_objet')){
                                $(".pdp-visual").addClass("objet-kang");
                                $(del).addClass('active');
                            }
                        }
                }, 'a'); 
            }
        },
        m: {
            el: document.getElementById('mobile_summary_gallery'),
            slick: {
                el: null,
                page: null,
                opt: {
                    listStyle:true, // WA-Common-Slick
                    infinite:false, // WA-Common-Slick
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows : true,
                    dots: false,
                    initialSlide: 0,
                    adaptiveHeight: true,
                    prevArrow: carouselOptions.bigAnglePrev, // common.js variable
                    nextArrow: carouselOptions.bigAngleNext, // common.js variable
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: true
                            }
                        }
                    ],
                }
            },
            init: function(){
                var _m = this;
                _m.slick.el = _m.el.querySelector('.pdp-carousel');
                _m.slick.page = _m.el.querySelector('.pdp-visual-pagination');
                _m.setThumbnailsIdx();
                /*LGEITF-424 start*/
                _m.baseMobileImg = _m.el.querySelector('#baseMobileImg');
                var mHeight=$(_m.el).height();
                $(_m.slick.el).on('init', function(event, slick){
                    $(_m.el).css({
                        height:mHeight+'px'
                    })
                    $(_m.slick.page).css({
                        visibility:'visible'
                    })
                     var baseMobileImgWidth = $(_m.baseMobileImg).width();
                     var baseMobileImgHeight = $(_m.baseMobileImg).height();
                     $(_m.baseMobileImg).css({
                            position:'absolute',
                            width:baseMobileImgWidth+'px'
                        })
                    setTimeout(function() {
                        $("#mobile_summary_gallery").css({
                            height:'auto'
                        })
                        if($("#baseMobileImg").length){
                            $("#baseMobileImg").css({
                                width:'0px'
                            })
                        }
                    }, 1000);
                });
                /*LGEITF-424 end*/
                if(_m.slick.el.querySelectorAll('.default').length > 0) {
                    // LGETR-136 start
                    var _currentPage = 1;
                    var sIdx = $($(_m.slick.el).find(".thumbnail:eq(0)")).data("idx");
                    if( sIdx > 0){
                        _m.slick.opt.initialSlide = sIdx;
                        _currentPage = sIdx+1;
                    }
                    // pagination max setting
                    $(_m.slick.page.querySelector('.current')).text(_currentPage);
                    // LGETR-136 end
                    $(_m.slick.page.querySelector('.length')).text(_m.slick.el.querySelectorAll('.default').length);

                    $(_m.slick.el).slick(_m.slick.opt);

                    _m.addEvent();
                }
                _m.el.setAttribute('data-initialized', true);
            },
            setThumbnailsIdx: function(){
                var _m = this;
                var lis = _m.slick.el.querySelectorAll('.default');
                for (var i = 0; i < lis.length; i++) {
                    var _li = lis[i];
                    _li.setAttribute('data-idx', i);
                }
            },
            addEvent: function(){
                var _m = this;
                
                $(_m.slick.el).on({
                    beforeChange: function(event, slick, currentSlide, nextSlide){
                        modal.ready = false;
                    },
                    afterChange: function(event, slick, currentSlide){
                        modal.ready = true;
                        slick.$slides.eq(currentSlide).find('a').focus();

                        //LGEITF-947-2 Start
                        videoIdxGPC0009 = currentSlide;
                        //LGEITF-947-2 Start
                        
                        // 20200601 START 박지영 - 가끔 01로 출력되는 버그 수정
                        $(_m.slick.page.querySelector('.current')).text(parseInt(currentSlide)+1);
                        // 20200601 END
                    }
                });

                $(_m.slick.el).on({
                    click: function(e){
                        e.preventDefault(); //LGCOMSPEED-6(gallery)
                        var _del = e.delegateTarget,
                            //idx = e.delegateTarget.getAttribute('data-idx');
                            idx = $(this).closest('li').attr('data-slick-index');
                        /* LGEGMC-849 : 20201104 add */
                        if($('.desktop-info').is(':visible')){
                            if(modal.is360VR) idx = Number(idx)+1;
                            if(modal.isVR) idx = Number(idx)+1;
                            if(modal.isAR) idx = Number(idx)+1; /*LGEGMC-1632*/
                            if(modal.is3603D) idx = Number(idx)+1; /*LGEGMC-3124*/
                        }
                        /*// LGEGMC-849 : 20201104 add */
                        //console.log(idx);
                        if(modal.ready == true) {
                            //LGEITF-947-2 Start
//                            modal.showDetailModal(idx ? idx : 0);
                            videoIdxGPC0009 = Number(idx);
                            //LGEITF-947-2 End
                            
                            modal.showDetailModal(idx ? idx : 0);	//LGCOMIS-312 추가
                            
                            $(modal.el.gallery).data('beforeFocus', e.currentTarget);
                        }
                    }
                }, '.default a');
            }
        },
        init: function(){
            var _this = this;

            _this.addEvent();
            _this.mediaBranch(common.breakpointMaxMd);
        },
        mediaBranch: function(e, rebuild) {
            var _this = summaryGallery;

            if (e.matches) { // mobile;
                _this = _this.m;
            } else { 
                _this = _this.d;
            }

            if(_this.el.getAttribute('data-initialized') != 'true') {
                _this.init();
            }
        },
        addEvent: function(){
            var _this = this;
            common.breakpointMaxMd.addListener(_this.mediaBranch);
        }
    };

    // right pdp Summary 
    var detach = {
        id: null,
        els: {}
    };
    var info = {
        // group: typeof groupModelInfo != 'undefined'?groupModelInfo:null,
        // price: typeof priceModelInfo != 'undefined'?priceModelInfo:null
        group: null,
        price: null,
        productPrice:null,
        memberPrice:null
    };
    var summary = {
        el: document.querySelector('.pdp-summary-area'),
        forms: document.querySelectorAll('.search-common'),
        els: {
            modal: {
                thumbnails: {
                    target: document.getElementById('modal_thumbnail_target'),
                    template: $('#modal_thumbnail_template').clone(),
                },
                detail: {
                    target: document.getElementById('modal_detail_target'),
                    template: $('#modal_detail_template').clone(),
                }
            },
            base: {
                mobile: {
                    target: document.getElementById('base_mobile_target'),
                    template: $('#base_mobile_template').clone(),
                },// thumbnail
                desktop: {
                    target: document.getElementById('base_desktop_target'),
                    template: $('#base_desktop_template').clone(),
                },
                detail: {
                    target: document.getElementById('base_detail_target'),
                }
            }
        },
        create: {
            temp: null,
            desktopThumbnail: function(imgList){
                var _this = summary,
                    _els = _this.els,
                    // template = $(_els.base.desktop.template).clone().html(),
                    // $desktopThumbnail = $(_els.base.desktop.target).find('.thumbnail img');
                    /* LGEGMC-849 : 20201030, LGCOMSPEED-6 modify */
                    $desktopThumbnail = $(_els.base.desktop.target).find('li:not(.view, .viewVr, .viewAr, .view360_v2)'),
                    /*// LGEGMC-849 : 20201030, LGCOMSPEED-6 modify */
                    length = 6,
                    current, template,
                    html = [];

                    if(_this.create.temp == null) {
                        _this.create.temp = $(_els.base.desktop.template).clone().html();
                        $(_els.base.desktop.template).remove();
                    }
                    template = _this.create.temp;
                    

                    $desktopThumbnail.remove();

                for (var i = 0; i < length; i++) {
                    var curData = imgList[i];
                    // if(i < $desktopThumbnail.length) {
                    //  var $current = $desktopThumbnail.eq(i);
                    //  $current[0].setAttribute('src', curData.smallImageAddr);
                    //  $current[0].setAttribute('data-medium', curData.largeImageAddr);
                    //  $current[0].setAttribute('alt', curData.alt);

                    //  if(i == $desktopThumbnail.length-1) {
                    //      var moreLength = imgList.length - $desktopThumbnail.length;
                    //      $current.siblings('.count').text("+"+moreLength);
                    //  }
                    // }

                    try {
                        if(curData.videoId){
                            current = $(template).filter('.video').clone()[0];
                            current.querySelector('img').setAttribute('src', curData.videoThumbnailImage);
                            current.querySelector('img').setAttribute('alt', curData.videoDesc);
                        }else if(i == (length-1)) {
                            current = $(template).filter('.more').clone()[0];
                            current.querySelector('img').setAttribute('src', curData.smallImageAddr);
                            current.querySelector('img').setAttribute('data-medium', curData.largeImageAddr);
                            var moreLength = imgList.length - length;
                                $(current.querySelector('.count')).text("+"+moreLength);
                        }else {
                            current = $(template).filter('.thumbnail:not(.more)').clone()[0];
                            current.querySelector('img').setAttribute('src', curData.smallImageAddr);
                            current.querySelector('img').setAttribute('data-medium', curData.largeImageAddr);
                        }
                    } catch (e) {
                            
                    }
                    current.setAttribute('data-idx', i+1);
                    current.setAttribute('data-link-name', common.p.modelName);
                    html[i] = current;
                }
                $(_els.base.desktop.target.querySelector('ul')).append(html);
            },
            elements: function(imgList, el, key){
                var _this = summary;
                var template = $(el.template).html(),
                    html = [];

                for (var i = 0; i < imgList.length; i++) {
                    var curData = imgList[i],
                        condition = false,
                        current, img;

                    if(curData.videoId) {
                        if($(template).filter('.video').length > 1) {
                            // is zoom (detaill) image
                            current = $(template).filter('.'+curData.videoType.toLowerCase()).clone()[0];
                            if(curData.videoType.toLowerCase() == 'youtube') {
                                current.querySelector('.iframe-area').setAttribute('data-href', 'https://www.youtube.com/watch?v='+curData.videoId);
                            }else {
                                current.querySelector('.iframe-area').setAttribute('data-video-id', curData.videoId);
                            }
                            current.querySelector('.iframe-area').setAttribute('data-title', curData.videoDesc);
                            current.querySelector('.iframe-area').setAttribute('data-type', curData.videoType.toLowerCase());
                        }else {
                            // thumbnail (nav)
                            current = $(template).filter('.video').clone()[0];
                            img = current.querySelector('img');
                            img.setAttribute('src', curData.videoThumbnailImage);
                            img.setAttribute('alt', curData.videoDesc);
                        }
                        condition = true;
                    }else {
                        current = $(template).filter('.image').clone()[0];
                    }

                    if(!condition) { // is not video contents
                        img = current.querySelectorAll('img');
                        if(img.length > 1) {
                            // is zoom image
                            $(img).filter('.pc')[0].setAttribute('data-lazy', curData.zoomImageAddr);
                            $(img).filter('.mobile')[0].setAttribute('data-lazy', curData.zoomMobImageAddr);
                        }else {
                            // is thumbnail image
                            img = img[0];
                            if(key) {
                                img.setAttribute('src', curData[key]);
                            }else {
                                img.setAttribute('src', curData.smallImageAddr);
                            }
                        }
                        $(img).attr('alt', curData.imageAltText);
                    }
                    //  current = $(template).clone()[0],
                    
                    html[i] = current;
                }

                return html;
            }
        },
        summaryTemplate: null,
        init: function(){
            var _this = this;
            _this.addEvent();
            _this.addAriaDescribedby();
            //OBSLGECZ-291 START
            if (COUNTRY_CODE.toLowerCase()=='cz') {
            _this.addMarketplaceName();
            }
            //OBSLGECZ-291 END
            _this.summaryTemplate = $('#summaryTemplate').clone();
            $('#summaryTemplate').remove();

            var href = location.search ? location.search : location.hash,
                param = href.indexOf('=') > -1 ? href.split('=')[1] : href;
            param = param.indexOf('#') > -1 ? param.split('#')[0] : param;
            if(param) {
                $('a[data-sub-model-id="'+param+'"]').eq(0).trigger('click');
            }
            $('#modal_thumbnail_template, #modal_detail_template, #base_mobile_template, #base_desktop_template').remove();

            // 20200421 START 박지영 : siblings 클릭시 in house review 업데이트
            if($('.GPC0009 .rating.inhouse-review').length>0) {
                var reviewArea = $('.GPC0009 .pdp-info:visible .rating.inhouse-review .star-area');
                summary.defaultReview = {
                    rating : parseFloat(reviewArea.find('.review-number').text()),
                    count : parseFloat(reviewArea.find('.review-number').text().split('(')[1])
                }
                summary.defaultReview.width = parseInt(summary.defaultReview.rating * 100 / 5);
            }
            // 20200421 END
            
        },
        addAriaDescribedby: function(){
            var els = document.querySelectorAll('.GPC0009');
            var waNumber = 0;
            var $target;
            if($(els).find('.model-title') && !$(els).find('.model-title').is(':empty')) {
                $target = $(els).find('.model-title');
            }
            if($target) {
                $target.eq(0).attr('id', 'waGPC0009_'+waNumber);
                $(els).find('a.btn').attr('aria-describedby', 'waGPC0009_'+waNumber);
                $(els).find('a.js-compare').attr('aria-describedby', 'waGPC0009_'+waNumber).attr('role', 'button');
                waNumber++;
            }
        },
        //OBSLGECZ-291 START
        addMarketplaceName: function(){
            var els = document.querySelectorAll('.GPC0009');
            if(document.referrer != ''){
            	$(els).find('a.btn.btn-primary.btn-lg.add-to-cart').attr('marketplaceName', getMktDomainUrl(document.referrer));
            }
        },
        //OBSLGECZ-291 END
        changeSubModelInfo: function(id, subid){
            var _this = this,
                url = _this.el.getAttribute('data-sibling-url'),
                templateUrl = _this.el.getAttribute('data-template-url'),
                param = {
                    modelId: id,
                    subModelId: subid
                };
                param['v'] = $('#v').val();
            var originalModelId = $('.GPC0009').attr('data-product-id');

            ajax.call(url, param, 'json', function(data){
                if(data.status == 'success' && data.data){
                    // PJTEXTENDEDWTY2-4 model price 초기화
                    info.price=null;
                    var p = data.data[0];
                    common.p = p;
                    html = summary.summaryTemplate.clone().html();
                    if(html) {
                        var pdpUrl = location.href;
                        var afterPayMsg = $('#afterPayMsg').val();
                        // simple data
                        html = html
                            .replace(/\*pdpUrl\*/g, pdpUrl)
                            // 20200325 START 박지영 - ufn 따옴표 처리
                            .replace(/\*userFriendlyName\*/g, (p.userFriendlyName!=null) ? p.userFriendlyName.replace(/\"/g, "''") : '')
                            // 20200325 END
                            .replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
                            .replace(/\*productTag1\*/g, p.productTag1)
                            .replace(/\*productTag2\*/g, p.productTag2)
                            .replace(/\*productTag1UserType\*/g, p.productTag1UserType) /* LGEDE-354 */
                            .replace(/\*productTag2UserType\*/g, p.productTag2UserType) /* LGEDE-354 */
                            .replace(/\*modelName\*/g, p.modelName)
                            .replace(/\*salesModelCode\*/g, p.salesModelCode)
                            .replace(/\*modelId\*/g, p.modelId)
                            .replace(/\*whereToBuyUrl\*/g, p.whereToBuyUrl)
                            .replace(/\*inquiryToBuyUrl\*/g, p.inquiryToBuyUrl)
                            .replace(/\*findTheDealerUrl\*/g, p.findTheDealerUrl)
                            .replace(/\*deliveryMessage\*/g, p.deliveryMessage)
                            .replace(/\*installMessage\*/g, p.installMessage)
                            .replace(/\*warrantyMessage\*/g, p.warrantyMessage)
                            .replace(/\*defaultMessage\*/g, nvl(p.defaultMessage, '')) //LGEGMC-1777 : 20210621 modify
                            // compatible
                            .replace(/\*compatibleCount\*/g, p.compatibleCount)
                            .replace(/\*compatibleModelsValidateUrl\*/g, p.compatibleModelsValidateUrl)
                            .replace(/\*compatibleModelsPredictiveUrl\*/g, p.compatibleModelsPredictiveUrl)
                            // PJTOBS 20200703 Start 
                            .replace(/\*reStockAlertUrl\*/g, p.reStockAlertUrl ? p.reStockAlertUrl : "")
                            .replace(/\*obsRewardPointText\*/g, p.obsRewardPointText ? p.obsRewardPointText : "")
                            // PJTOBS 20200703 End
                            // price
                            // 20200316 START 박지영 : price format 함수 적용
                            .replace(/\*rPrice\*\.\*rPriceCent\*/g, p.rPrice ? changeFormatFullPrice(p.rPrice, p.rPriceCent) : 'null')
                            // 20200421 START 박지영 : 오타 수정
                            .replace(/\*rPromoPrice\*\.\*rPromoPriceCent\*/g, p.rPromoPrice ? changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent) : 'null')
                            // 20200421 END
                            // 20200316 END
                            .replace(/\*rPrice\*/g, p.rPrice ? changeFormatPrice(p.rPrice) : 'null')
                            .replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatPrice(p.rPromoPrice) : 'null')
                            // 20200325 START 박지영 : price format 수정
                            .replace(/\*rPriceCent\*/g, p.rPriceCent ? (p.rPriceCent) : 'null')
                            .replace(/\*rPromoPriceCent\*/g, p.rPromoPriceCent ? (p.rPromoPriceCent) : 'null')
                            // 20200325 END
                            .replace(/\*discountedRate\*/g, p.discountedRate)
                            .replace(/\*discountMsg\*/g, p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'))      // LGEIS-229 change how discounts are shown
                            /* LGEUS-12083 : 20190826 modify */
                            .replace(/\*rDiscountedPrice\*/g, p.rDiscountedPrice ? changeFormatPrice(p.rDiscountedPrice) : 'null')
                            .replace(/\*rDiscountedPriceCent\*/g, p.rDiscountedPriceCent)
                            /* //LGEUS-12083 : 20190826 modify */
                            /* in-house review rating add */
                            // 20200421 START 박지영 리뷰 데이터 수정
                            .replace(/\*reviewRatingStar2\*/g, summary.defaultReview ? summary.defaultReview.rating.toFixed(1) : p.sRating2)
                            .replace(/\*reviewRating\*/g, summary.defaultReview ? summary.defaultReview.count : p.pCount)
                            .replace(/\*reviewRatingPercent\*/g, summary.defaultReview ? summary.defaultReview.width : p.ratingPercent)
                            // 20200421 END
                            /* // in-house review rating add */
                            //.replace(/\*promotionText\*/g, p.promotionText)
                            .replace(/\*retailerPricingText\*/g, p.retailerPricingText)
                            .replace(/\*salesSuffixCode\*/g, (p.salesSuffixCode || ''))/* LGEGMC-455 20200717 add */
                            .replace(/\*modelYear\*/g, (nvl(p.modelYear,'') || '')) /* LGEGMC-1279 : 2021.03.12 add */
                            .replace(/\*buName1\*/g, (p.buName1 || ''))
                            .replace(/\*buName2\*/g, (p.buName2 || ''))
                            .replace(/\*buName3\*/g, (nvl(p.buName3,'') || ''))
                            .replace(/\*bizType\*/g, (p.bizType || ''))
                            .replace(/\*superCategoryName\*/g, (p.superCategoryEngName || ''))
                            .replace(/\*priceValue\*/g, (nvl(p.rPrice,'')+'.'+nvl(p.rPriceCent,'00') || ''))/* LGEGMC-712 20201102 add */
                            /* PJTPLP-10 (황규하) wish 기능 추가 START */
                            .replace(/\*wishTotalCnt\*/g, p.wishTotalCnt)
                            .replace(/\*pdFav\*/g, p.myWishCnt == 'Y' ? 'pd-fav on' : 'pd-fav')
                            .replace(/\*icoFav\*/g, p.myWishCnt == 'Y' ? 'ico-fav on' : 'ico-fav')
                            .replace(/\*ariaChecked\*/g, p.myWishCnt == 'Y' ? 'true' : 'false')
                            .replace(/\*modelCopyUrl\*/g, p.modelUrlPath)
                            .replace(/\*obsPreOrderValidDateFlag\*/g, p.obsPreOrderValidDateFlag)
                            .replace(/\*obsPreOrderEndDate\*/g, p.obsPreOrderEndDate)
                            .replace(/\*emiMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')
                            .replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode) // LGEGMC-2589
                            //LGEGMC-1406
                            .replace(/\*specMsg\*/g, p.specMsgFlag == 'Y' ? "<p>"+specMsg+"</p>" : '')
                            //LGEDE-220
                            .replace(/\*shippingMessage\*/g, nvl(p.shippingMessage,''))
                            .replace(/\*deliveryMsg\*/g, nvl(p.deliveryMsg,''))
                            .replace(/\*installationMessage\*/g, nvl(p.installationMessage,''))
                            //LGEPA-783
                            .replace(/\*shippingTargetLink\*/g, nvl(p.shippingTargetLink,''))
                            .replace(/\*shippingTargetFlag\*/g, nvl(p.shippingTargetFlag,''))
                            .replace(/\*deliveryTargetLink\*/g, nvl(p.deliveryTargetLink,''))
                            .replace(/\*deliveryTargetFlag\*/g, nvl(p.deliveryTargetFlag,''))
                            .replace(/\*installationTargetLink\*/g, nvl(p.installationTargetLink,''))
                            .replace(/\*installationTargetFlag\*/g, nvl(p.installationTargetFlag,''))
                            // PJTLIMITQTY-5
                            .replace(/\*obsProductCount\*/g, nvl(p.obsProductCount, '0'))
                            /* LGEGMC-1777 : 20210615 add */
                            .replace(/\*obsLeadTimeMin\*/g, nvl(p.obsLeadTimeMin, '0'))
                            .replace(/\*obsLeadTimeMax\*/g, nvl(p.obsLeadTimeMax, '0'))
                            .replace(/\*msrp\*/g, nvl(p.msrp, '0'))
                            /*// LGEGMC-1777 : 20210615 add */
                            .replace(/\*membershipPrice\*/g, changeFormatFullPrice(p.rMembershipPrice, p.rMembershipPriceCent)) /* PJTMEMBERSHIP-1 */
                            .replace(/\*obsPincodeFlag\*/g, nvl(p.obsPincodeFlag, '')) /* LGEGMC-1914 */
                            .replace(/\*cheaperPrice\*/g, changeFormatFullPrice(p.rObsCheaperPrice, p.rObsCheaperPriceCent)) /* LGEGMC-1973 */
                            .replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEAU-378 add */
                            .replace(/\*afterPayMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? afterPayMsg : '')/* LGEAU-378 add */
                            .replace(/\*afterPayDot\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? '' : 'Not')/* LGEAU-378 add */
                            .replace(/\*wtbClass\*/g, (p.wtbExternalLinkUseFlag =="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') ? 'in-buynow' : 'where-to-buy') //LGEGMC-2202
                            .replace(/\*obsPartnerUrl\*/g, nvl(p.obsPartnerUrl, '')) //LGEEG-154
                            .replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEGMC-3167 add, OBSLGEAU-749 (5000 -> 10000) */
                            .replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')/* LGEGMC-3167 add */
                            .replace(/\*featureActive\*/g, p.featureUseFlag == 'Y'?'active':'')/* LGEAU-802 add */
                            .replace(/\*featureLinkUrl\*/g, p.featureLinkUrl)/* LGEAU-802 add */
                            .replace(/\*featureTarget\*/g, p.featureTarget)/* LGEAU-802 add */
                            .replace(/\*no-link\*/g, p.featureLinkUrl == '#'?'no-link':'')/* LGEAU-802 add */
                            .replace(/\*featurePcPreviewUrl\*/g, p.featurePcPreviewUrl)/* LGEAU-802 add */
                            .replace(/\*featureMcPreviewUrl\*/g, p.featureMcPreviewUrl)/* LGEAU-802 add */
                            .replace(/\*featureAltText\*/g, p.featureAltText)/* LGEAU-802 add */
                            .replace(/\*featureTitle\*/g, p.featureTitle)/* LGEAU-802 add */
                            ;
                            /* PJTPLP-10 (황규하) wish 기능 추가 END */
                            /* LGEGMC-712 20201102 add */
                        
                        //LGEPL-655 Start
                        if(p.obsSubscriptionCtaUseFlag && null != p.obsSubscriptionCtaUseFlag) {
                        	if("Y" == p.obsSubscriptionCtaUseFlag && "Y" == p.obsSubscriptionEnableFlag) {
                        		html = html.replace(/\*obsSubscriptionLandingPageUrl\*/g, p.obsSubscriptionLandingPageUrl)
                        		.replace(/\*obsSubscriptionCtaLinkTarget\*/g, p.obsSubscriptionCtaLinkTarget)
                        		.replace(/\*obsSubscriptionMonthlyCost\*/g, changeFormatFullPrice(p.obsConvertSubscriptionMonthlyCost, p.obsConvertSubscriptionMonthlyCostCent))
                        		.replace(/\*obsSubscriptionMaxMonth\*/g, p.obsSubscriptionMaxMonth)
                        		.replace(/\*obsSubscriptionDisclaimer\*/g, p.obsSubscriptionDisclaimer);
                        	} 
                        }  
                        //LGEPL-655 End  
                        
                        /* LGEGMC-849 : 20201030 add */
                        if(p.modelVrImage && p.modelVrImage != null) {
                            html = html.replace(/\*iframeUrl\*/g, p.modelVrImage)
                                    .replace(/\*iframeTitle\*/g, p.modelVrTitle);
                            if(!!p.modelName){
                                html = html.replace(/\*modelNameSpecial\*/g, p.modelName.replace(/\"/g, '').replace(/\s/g,'_').toLowerCase())
                            }
                        }
                        /*// LGEGMC-849 : 20201030 add */
                        /*LGEGMC-1632*/
                        if(p.modelArImage && p.modelArImage != null) {
                            html = html.replace(/\*iframeArUrl\*/g, p.modelArImage)
                                    .replace(/\*iframeArTitle\*/g, p.modelArTitle);
                            if(!!p.modelName){
                                html = html.replace(/\*modelNameSpecial\*/g, p.modelName.replace(/\"/g, '').replace(/\s/g,'_').toLowerCase())
                            }
                        }
                        /*LGEGMC-1632*/
                        /*LGEGMC-3056*/
                        if(p.modelArMobileImage && p.modelArMobileImage != null){
                            html = html.replace(/\*aRImageURLMobile\*/g, p.modelArMobileImage);
                            if(!!p.modelName){
                                html = html.replace(/\*modelNameSpecial\*/g, p.modelName.replace(/\"/g, '').replace(/\s/g,'_').toLowerCase())
                            }
                        }
                        //LGEGMC-1914 START
                        //LGEGMC-1914 START
                        if(p.obsPinCodeList && p.obsPinCodeList != null){
                                
                                var pinOption = '';
                                for (var i  in p.obsPinCodeList) {
                                    pinOption += '<option value="' + p.obsPinCodeList[i].commonCodeId + '">' + p.obsPinCodeList[i].commonCodeName + '</option>';
                                }
                                
                                html = html.replace(/\*pinOption\*/g, pinOption);
                                $('#pinCodeList').trigger('chosen:updated');
                                //LGEITF-676
                                $('#pinCodeList_chosen .chosen-drop').mCustomScrollbar();
                                
                        };
                        if(p.obsComunaRegionList && p.obsComunaRegionList != null){

                            var comunaOption = '';
                            for (var i  in p.obsComunaRegionList) {
                                comunaOption += '<option value="' + p.obsComunaRegionList[i].value + '">' + p.obsComunaRegionList[i].code + '</option>';
                            }
                            
                            html = html.replace(/\*comunaOption\*/g, comunaOption)
                               .replace(/\*comunaChekcUrl\*/g, nvl(p.comunaChekcUrl, ''))
                               .replace(/\*comunaChangeUrl\*/g, nvl(p.comunaChangeUrl, ''));
                            
                            $('#comunaRegionId').trigger('chosen:updated');
                            //LGEITF-676
                            $('#comunaRegionId_chosen .chosen-drop').mCustomScrollbar();
                        }
                        //LGEGMC-1914 END
                        //OBSLGEPE-142
                        if(p.obsComunaRegionInfoList && p.obsComunaRegionInfoList != null){

                            var comunaRegionOption = '';
                            for (var i  in p.obsComunaRegionInfoList) {
                            	comunaRegionOption += '<option value="' + p.obsComunaRegionInfoList[i].value + '">' + p.obsComunaRegionInfoList[i].code + '</option>';
                            }
                            
                            html = html.replace(/\*comunaRegionOption\*/g, comunaRegionOption)
                               .replace(/\*comunaChekcUrl\*/g, nvl(p.comunaChekcUrl, ''))
                               .replace(/\*comunaChangeUrl\*/g, nvl(p.comunaChangeUrl, ''));
                            
                            $('#comunaRegionId').trigger('chosen:updated');
                            //LGEITF-676
                            $('#comunaRegionId_chosen .chosen-drop').mCustomScrollbar();
                        }
                        
                        //LGEAU-783
                        if(p.labelIconList && p.labelIconList != null){
                            var iconLinkHtml = '';
                            var iconImageHtml = '';
                            var iconTextHtml = '';
                            var iconLiHtml = '';
                            var iconHtml = '';
                            var target = '';                            
                            var textType= '';
                            var divHtml = '<div class="ch-recommended-area">';
                                var ulHtml = '<ul class="ch-recommended-list">';
                                var $div = $(html).find('.feature-area');
                            for (var i  in p.labelIconList) {
                                if(p.labelIconList[i].cssFontBold=='Y' && p.labelIconList[i].cssFontItalic =='Y'){
                                    textType='ch-recommended-labelicon text-all';
                                } else if(p.labelIconList[i].cssFontItalic =='Y'){
                                    textType='ch-recommended-labelicon text-italic';
                                } else if(p.labelIconList[i].cssFontBold =='Y'){
                                    textType='ch-recommended-labelicon text-bold';
                                }
                                iconLiHtml += '<li class="' + textType +'">'
                                if(p.labelIconList[i].linkUrl != null && p.labelIconList[i].linkUrl != ''){
                                    if(p.labelIconList[i].linkOpt == 'S'){
                                        target='_self';
                                    } else if(p.labelIconList[i].linkOpt == 'B'){
                                        target='_blank';
                                    }
                                    iconLinkHtml += '<a href="' + p.labelIconList[i].linkUrl +'" target="'+target+'"data-adobe-tracking-wish="Y" data-page-event="plp_labelicon">';
                                    iconTextHtml += '<p>'+p.labelIconList[i].shortDesc +'</p></a></li></ul></div>';
                                } else{
                                    iconTextHtml += '<p>'+p.labelIconList[i].shortDesc +'</p></li></ul></div>';
                                }
                                if(p.labelIconList[i].imagePathAddr!= null &&p.labelIconList[i].imagePathAddr != ''){
                                    iconImageHtml+='<img src"' +p.labelIconList[i].imagePathAddr+ '" alt="' +p.labelIconList[i].altText+'"aria-hidden="true">';
                                }
                                
                                iconHtml += divHtml+ulHtml+iconLiHtml+iconLinkHtml+iconImageHtml+iconTextHtml;
                            }
                            $div.html(iconHtml);
                            
                        }

						//LGEFR-640
						if(p.labelUseFlag == 'Y' && p.repairabilityIndexFlag == 'Y' && p.repairIconList != null){
							var repairabilityArea = $(html).find('.repairability-index');
							var repairabilityMsg = repairabilityArea.attr('data-repairability-msg');
							var targetBlankMsg = repairabilityArea.attr('data-target-blank-msg');
							
							if(p.labelRepairMap.length > 0){	
								var repairMapData = p.labelRepairMap[0];
								var repairAbilityHtml  = "<div class='score'>";
								    repairAbilityHtml  += "<span class='txt'>"+repairabilityMsg+"</span>";
								if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
									repairAbilityHtml  += "<a href='"+repairMapData.linkUrl+"'";
									if(repairMapData.linkOpt =='S'){
										repairAbilityHtml  += " target='_self'";
									}else if(repairMapData.linkOpt =='B'){
										repairAbilityHtml  += " target='_blank'";
									}
									repairAbilityHtml  += " title='"+targetBlankMsg+"' class='link-pdf'>";
								}else{
				                    repairAbilityHtml += "<span class='link-pdf'>";
				                }
								if(repairMapData.imagePathAddr != 'null' && repairMapData.imagePathAddr != ''){
									repairAbilityHtml  += "<img src='"+repairMapData.imagePathAddr+"' alt='"+repairMapData.altText+"' area-hidden='true' />";
								}
								if(repairMapData.linkUrl != 'null' && repairMapData.linkUrl != ''){
									repairAbilityHtml  += "</a></div>";
								}else{
				                    repairAbilityHtml  += "</span></div>";
				                }
								//template = template.replace(/\*repairabilityIndex\*/g, repairAbilityHtml);
								repairabilityArea.html(repairAbilityHtml);
							}else{
								//template = template.replace(/\*repairabilityIndex\*/g, "");
								repairabilityArea.html('');
							}
						}
						//LGEFR-640
                        
                        /* LGEIN-546 Start */
                        if(p.obsKeyFeatureUesFlag == 'Y' && !!p.obsKeyFeature.length){
                            html = html.replace(/\*obsKeyFeatureText\*/g, p.obsKeyFeature[0].obsKeyFeatureText);
                            if(p.obsKeyFeature[0].obsKeyFeatureBoldFlag == 'Y'){
                                html = html.replace(/\*obsKeyFeatureBoldFlag\*/g, 'font-bold');
                            }else{
                                html = html.replace(/\*obsKeyFeatureBoldFlag\*/g, '');
                            }
                            if(p.obsKeyFeature[0].obsKeyFeatureItalicFlag == 'Y'){
                                html = html.replace(/\*obsKeyFeatureItalicFlag\*/g, 'font-italic');
                            }else{
                                html = html.replace(/\*obsKeyFeatureItalicFlag\*/g, '');
                            }
                        }
                        /* LGEIN-546 End */
                        
                        /* LGEPA-783 START */
                        var title = $("#openTarget").val();
                        p.shippingTargetFlag == '_blank' ? title : title = "";
                        p.deliveryTargetFlag == '_blank' ? title : title = "";
                        p.installationTargetFlag == '_blank' ? title : title = "";
                        var shippingTargetLinkStartHtml = "";
                        var shippingTargetLinkEndHtml = "";
                        var deliveryTargetLinkStartHtml = "";
                        var deliveryTargetLinkEndHtml = "";
                        var installationTargetLinkStartHtml = "";
                        var installationTargetLinkEndHtml = "";
                        if(p.shippingFlag == "Y" && p.shippingMessage != '' && p.shippingTargetLink != '' && p.shippingTargetLink != null){
                            shippingTargetLinkStartHtml = "<a href='"+ p.shippingTargetLink +"' target='"+ p.shippingTargetFlag +"' title='" +title+ "'>";
                            shippingTargetLinkEndHtml = "</a>";
                        }
                        if(p.deliveryFlag == "Y" && p.deliveryMsg != '' && p.deliveryTargetLink != '' && p.deliveryTargetLink != null){
                            deliveryTargetLinkStartHtml = "<a href='"+ p.deliveryTargetLink +"' target='"+ p.deliveryTargetFlag +"' title='" +title+ "'>";
                            deliveryTargetLinkEndHtml = "</a>";
                        }
                        if(p.installationFlag == "Y" && p.installationMessage != '' && p.installationTargetLink != '' && p.installationTargetLink != null){
                            installationTargetLinkStartHtml = "<a href='"+ p.installationTargetLink +"' target='"+ p.installationTargetFlag +"' title='" +title+ "'>";
                            installationTargetLinkEndHtml = "</a>";
                        }
                        html = html.replace(/\*shippingTargetLinkStart\*/g,shippingTargetLinkStartHtml);
                        html = html.replace(/\*shippingTargetLinkEnd\*/g,shippingTargetLinkEndHtml);
                        html = html.replace(/\*deliveryTargetLinkStart\*/g,deliveryTargetLinkStartHtml);
                        html = html.replace(/\*deliveryTargetLinkEnd\*/g,deliveryTargetLinkEndHtml);
                        html = html.replace(/\*installationTargetLinkStart\*/g,installationTargetLinkStartHtml);
                        html = html.replace(/\*installationTargetLinkEnd\*/g,installationTargetLinkEndHtml);
                        /* LGEPA-783 END */
                        
                        var $html = $(html),
                            $keyBlocks = $html.find('*[data-key]'),
                            $loopBlocks = $html.find('*[data-loop]');
                        
                        for (var i = 0; i < $keyBlocks.length; i++) {
                            var $currentKeyBlock = $keyBlocks.eq(i),
                                key = $currentKeyBlock.get(0).getAttribute('data-key'),
                                val = p[key];
                            if(!val || val == "N" || val == "null") {
                                // discontinued
                                if(key=="productTag1" && p.modelStatusCode=='DISCONTINUED' && $('.GPC0009').attr('data-flag-discontinued')) {
                                    $html.find('.flag span').html($('.GPC0009').attr('data-flag-discontinued'));
                                } else {
                                    $currentKeyBlock.remove();
                                }
                            }
                        }
                        
                        //LGEAU-644 START
                        if ( COUNTRY_CODE.toLowerCase()=='cac_en' ) {
                            /* LGEPA-783 START */
                            if(!!!p.shippingMessage){
                                $html.find('.delivery-list li.delivery').hide();
                            }else {
                                $html.find('.delivery-list li.delivery').show();
                            }
                            if(!!!p.deliveryMsg){
                                $html.find('.delivery-list li.days-delievery').hide();
                            }else {
                                $html.find('.delivery-list li.days-delievery').show();
                            }
                            if(!!!p.installationMessage){
                                $html.find('.delivery-list li.free-installation').hide();
                            }else {
                                $html.find('.delivery-list li.free-installation').show();
                            }
                            /* LGEPA-783 END */
                        }
                        
                        if ( COUNTRY_CODE.toLowerCase()=='au' ) {
                            var obsGroupCheck;
                            obsGroupCheck = $('.navigation').attr('data-obs-group');
                             if ( obsGroupCheck == "B2E" ) {
                                 $html.find('.delivery-list li.delivery').addClass('d-none');
                             } else {
                                 $html.find('.delivery-list li.delivery').removeClass('d-none');
                             } 
                        }
                        //LGEAU-644 END
                        
                        //LGEDE-354 start                   
                        $html.find('.flag').find('[data-user-type=""]').removeClass('d-none');
                        $html.find('.info-top .flag').find('[data-user-type=ALL]').removeClass('d-none');
                        if(SIGN_IN_STATUS == 'Y' && ISVIP){
                            $html.find('.info-top .flag').find('[data-user-type=VIP]').removeClass('d-none');
                        /* LGEDE-422 Start //Non-vip and Non-login */ 
                        }else {
                            $html.find('.info-top .flag').find('[data-user-type=NON_VIP]').removeClass('d-none');
                        }
                        /* LGEDE-422 End */ 
                        //LGEDE-354 end
                        
                        // LGEVN-819 Start
                        switch ($html.find(".flag span").length) {
						case 1:
							if(d.productTag1 != null && d.productTag1ColorFlag == "Y"){
								$($html.find(".flag span")[0]).addClass("flag-gold");
							}
							if(d.productTag2 != null && d.productTag2ColorFlag == "Y"){
								$($html.find(".flag span")[0]).addClass("flag-gold");
							}
							break;
							
						case 2:
							if(d.productTag1 != null && d.productTag1ColorFlag == "Y"){
								$($html.find(".flag span")[0]).addClass("flag-gold");
							}
							if(d.productTag2 != null && d.productTag2ColorFlag == "Y"){
								$($html.find(".flag span")[1]).addClass("flag-gold");
							}
							break;
							
						default:
							break;
						}
                        // LGEVN-819 End

                        // 20200518 START 박지영 - delivery msg 없는 경우  회색 박스 삭제 
                        if(p.deliveryMessage == null || p.deliveryMessage == '') {
                            $html.find('.delivery-list.delivery-bottom').remove();
                        }
                        // 20200518 END
                        

                        if(p.bizType.toUpperCase() == "B2B") {
                            $html.find('.rating-area').remove();
                        }

                        if(p.reviewType == "BV") {
                            $html.find('.rating-area.sp').remove();
                            $html.find('.rating-area.inhouse').remove();
                            $html.find('#BVRRSummaryContainer').remove();
                            $html.find('#BVRRSummaryContainer2').remove();
                            if(p.siblings[0].target && p.siblings[0].target.toUpperCase() == "SELF") {
                                $html.find('.rating-area.bv').replaceWith('<div class="rating-area"><div data-bv-show="rating_summary" data-bv-product-id="'+originalModelId+'"></div></div>');
                            }
                        } else if(p.reviewType == "BV2") {
                            $html.find('.rating-area.sp').remove();
                            $html.find('.rating-area.inhouse').remove();
                            $html.find('.rating-area.bv').remove();
                            // 20200406 START 박지영 : 스크립트 위치 변경 
                            // 20200406 END
                        } else if(p.reviewType == "LGCOM"){
                            $html.find('.rating-area.sp').remove();
                            $html.find('.rating-area.bv').remove();
                            $html.find('#BVRRSummaryContainer').remove();
                            $html.find('#BVRRSummaryContainer2').remove();
                            // in-house reivew rating star - ie fix
                            $html.find('.carmine-star').css({
                                // 20200421 START 박지영 - 리뷰 데이터 수정
                                width: summary.defaultReview ? summary.defaultReview.width + '%' : p.ratingPercent+"%"
                                // 20200421 END
                            });
                        } else if(p.reviewType == "SP"){
                            $html.find('.rating-area.inhouse').remove();
                            $html.find('#BVRRSummaryContainer').remove();
                            $html.find('#BVRRSummaryContainer2').remove();
                        } else if(p.reviewType == "N"){
                            $html.find('.rating-area.sp').remove();
                            $html.find('.rating-area').remove();
                            $html.find('#BVRRSummaryContainer').remove();
                            $html.find('#BVRRSummaryContainer2').remove();
                        }

                        // change 360vr iframe url
                        if(p.model360Image && p.model360Image != null) {
                            $(summary.els.modal.detail.target).find('.iframe-area[data-type="360"]').attr('data-href', p.model360Image);
                            $(summary.els.base.desktop.target).find('.view.iframe').show();
                            $(summary.els.modal.thumbnails.target).find('.item.view').show();
                            /* LGEGMC-849 : 20201030 add */
                            $(summary.els.modal.thumbnails.target).find('.item.view').removeClass('hidden');
                            /*// LGEGMC-849 : 20201030 add */   
                        }else {
                            $(summary.els.base.desktop.target).find('.view.iframe').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.view').hide();
                            /* LGEGMC-849 : 20201030 add */
                            $(summary.els.modal.thumbnails.target).find('.item.view').addClass('hidden');
                            /*// LGEGMC-849 : 20201030 add */
                            /* LGEGMC-605 : 20201110 add */
                            $('.view360').hide();
                            $html.find('.view360ModalOpen').hide();
                            /*// LGEGMC-605 : 20201110 add */
                        }
                        
                        /* LGEGMC-849 : 20201030 add */
                        if(p.modelVrImage && p.modelVrImage != null) {
                            $(summary.els.modal.detail.target).find('.iframe-area[data-type="vr"]').attr('data-href', p.modelVrImage).attr('data-title', p.modelVrTitle);
                            $(summary.els.base.desktop.target).find('.viewVr.iframe').show();
                            $(summary.els.modal.thumbnails.target).find('.item.viewVr').show();
                            $(summary.els.modal.thumbnails.target).find('.item.viewVr').removeClass('hidden');
                            $('.viewVr').show();
                            $html.find('.viewVrModalOpen').show();
                        }else {
                            $(summary.els.base.desktop.target).find('.viewVr.iframe').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.viewVr').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.viewVr').addClass('hidden');
                            $('.viewVr').hide();
                            $html.find('.viewVrModalOpen').hide();
                        }
                        /*// LGEGMC-849 : 20201030 add */
                        
                        /* LGEGMC-1632 : 20210518 add */
                        if(p.modelArImage && p.modelArImage != null) {
                            $(summary.els.modal.detail.target).find('.iframe-area[data-type="ar"]').attr('data-href', p.modelArImage).attr('data-title', p.modelArTitle);
                            $(summary.els.base.desktop.target).find('.viewAr.iframe').show();
                            $(summary.els.modal.thumbnails.target).find('.item.viewAr').show();
                            $(summary.els.modal.thumbnails.target).find('.item.viewAr').removeClass('hidden');
                            $('.viewAr').show();
                            $html.find('.viewArModalOpen').show();
                        }else {
                            $(summary.els.base.desktop.target).find('.viewAr.iframe').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.viewAr').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.viewAr').addClass('hidden');
                            $('.viewAr').hide();
                            $html.find('.viewArModalOpen').hide();
                        }
                        /*// LGEGMC-1632 : 20210518 add */
                        /* LGEGMC-3124 */
                        if(p.model3603dImage && p.model3603dImage != null) {
                            $(summary.els.modal.detail.target).find('.iframe-area[data-type="3603D"]').attr('data-href', p.model360Image);
                            $(summary.els.base.desktop.target).find('.view360_v2.iframe').show();
                            $(summary.els.modal.thumbnails.target).find('.item.view360_v2').show();
                            $(summary.els.modal.thumbnails.target).find('.item.view360_v2').removeClass('hidden');
                        
                        }else {
                            $(summary.els.base.desktop.target).find('.view360_v2.iframe').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.view360_v2').hide();
                            $(summary.els.modal.thumbnails.target).find('.item.view360_v2').addClass('hidden');
                            $('.view360_v2').hide();
                            $html.find('.view3603dModalOpen').hide();
                        }
                        /* LGEGMC-3124 */

                        // price setting
                        var $prices = $html.find('.price-area');
                        for (var i2 = 0; i2 < $prices.length; i2++) {
                            var $this = $prices.eq(i2),
                                $price,
                                $membership = $this.find('.obsMembershipAreaTemplate').clone();/* PJTMEMBERSHIP-1 */
                                
                            if(p.modelStatusCode=='DISCONTINUED') {
                                $price = $this.find('.rPrice').clone();
                                $price.html('');
                            } else if(p.retailerPricingFlag=="Y") {
                                $price = $this.find('.retailer').clone();
                            }else if(p.rPrice && p.rPrice != null) {
                                if(p.rPromoPrice != null && p.rPromoPrice != '') {
                                    $price = $this.find('.rPromoPrice').clone();
                                }else if(p.bizType.toUpperCase() =='B2B' && p.msrpUseFlag=='Y') {
                                    $price = $this.find('.msrp').clone();
                                }else {
                                    $price = $this.find('.rPrice').clone();
                                }
                            }else {
                                $price = $this.find('.rPrice').clone();
                                $price.html('');
                            }
                            $this.html($price.html());
                            /* PJTMEMBERSHIP-1 */
                            if(p.membershipDisplayFlag == 'Y'){
                                $this.append($membership.html()); 
                            }
                            /* PJTMEMBERSHIP-1 */
                        }

                        // compatibleCount type setting
                        if(!p.compatibleCount && p.compatibleCount == 0){
                            // compatible is empty
                            $html.find('.compatible-area').remove();
                        }else if(p.compatibleCount > 6) {
                            // search type
                            // REQ-022 : compatible-list-wrap으로 타깃 변경
                            $html.find('.compatible-list-wrap').remove();
                        }else if(p.compatibleCount <= 6) {
                            // list type
                            $html.find('.search-model').remove();
                        }

                        // loop contents setting
                        for (var i3 = 0; i3 < $loopBlocks.length; i3++) {
                            var $currentLoopBlock = $loopBlocks.eq(i3),
                                _key = $currentLoopBlock.get(0).getAttribute('data-loop'),
                                _val = p[_key];

                            if(_key == 'siblings') {
                                for (var j1 = 0; j1 < _val.length; j1++) {
                                    var siblingGroup = _val[j1],
                                        siblingTemplate, itemTemplate,
                                        type = siblingGroup.siblingType.toUpperCase(),
                                        selectCase = ["CARRIER", "CAPACITY", "COOLING CAPACITY"],
                                        ifSelectCase = selectCase.indexOf(type) > -1,
                                        siblingHtml = [],
                                        itemHtml = [],
                                        currentColor = '';

                                    if(type == "COLOR") {
                                        siblingTemplate = $currentLoopBlock.find('.template-sibling-color').clone().html();
                                    }else if(ifSelectCase){
                                        siblingTemplate = $currentLoopBlock.find('.template-sibling-option').clone().html();
                                        siblingTemplate = siblingTemplate.replace(/\*siblingType\*/g, type.toLowerCase())
                                                                         .replace(/\*siblingTypeName\*/g, p.productMessages.siblingsMsg[type]);
                                    }else {
                                        siblingTemplate = $currentLoopBlock.find('.template-sibling-size').clone().html();
                                        siblingTemplate = siblingTemplate.replace(/\*siblingType\*/g, type.toLowerCase())
                                                                        .replace(/\*siblingTypeName\*/g, p.productMessages.siblingsMsg[type]);
                                    }

                                    if(siblingGroup.target.toUpperCase() == "NEW"){
                                        itemTemplate = $(siblingTemplate).find('.new').clone().html();
                                    }else {
                                        itemTemplate = $(siblingTemplate).find('.self').clone().html();
                                    }

                                    for (var k = 0; k < siblingGroup.siblingModels.length; k++) {
                                        var model = siblingGroup.siblingModels[k];
                                        itemHtml = itemTemplate;
                                        itemHtml = itemHtml.replace(/\*subModelId\*/g, model.modelId)
                                                        .replace(/\*siblingValue\*/g, model.siblingValue)
                                                        .replace(/\*siblingType\*/g, model.siblingType.toLowerCase())
                                                        .replace(/\*subModelUrl\*/g, model.modelUrl)
                                                        .replace(/\*siblingCode\*/g, model.siblingCode);
                                        if(p.modelId == model.modelId) {
                                            if(ifSelectCase) {
                                                itemHtml = $(itemHtml).attr('selected', 'selected')[0].outerHTML;
                                            }else {
                                                itemHtml = $(itemHtml).attr('aria-checked', 'true').addClass('active')[0].outerHTML;
                                                if(type == "COLOR") {
                                                    currentColor = model.siblingValue;
                                                }
                                            }
                                        }
                                        siblingHtml += itemHtml;
                                    }

                                    var $temp = $(siblingTemplate);
                                    $temp.find(ifSelectCase ? 'select' : 'div').html(siblingHtml);
                                    $temp.find('.color-name').text(currentColor);
                                    
                                    $currentLoopBlock.append($temp);
                                }
                            // PJTEXTENDEDWTY2-4 extendedWtyList loop 추가 START
                            }else if(_key == 'extendedWtyList'){
                                for (var j3 = 0; j3 < _val.length; j3++) {
                                    var extendedWty = _val[j3],
                                        extendedWtyTemplate;
                                    
                                    extendedWtyTemplate = $currentLoopBlock.find('.template-extendedWty').clone().html();
                                    
                                    extendedWtyTemplate = extendedWtyTemplate.replace(/\*extendedWtyCode\*/g, extendedWty.extendedWtyCode)
                                                            .replace(/\*extendedWtyName\*/g, extendedWty.extendedWtyName)
                                                            .replace(/\*displayPrice\*/g, extendedWty.displayPrice)
                                                            .replace(/\*displayPriceCent\*/g, extendedWty.displayPriceCent)
                                                            .replace(/\*displayMonthlyPrice\*/g, extendedWty.displayMonthlyPrice)
                                                            .replace(/\*displayMonthlyPriceCent\*/g, extendedWty.displayMonthlyPriceCent)
                                                            .replace(/\*warrantyPeriod\*/g, extendedWty.warrantyPeriod)
                                                            .replace(/\*extendedWtyDesc\*/g, extendedWty.extendedWtyDesc)
                                                            .replace(/\*extendedWtyDetailDesc\*/g, extendedWty.extendedWtyDetailDesc);
                                    if(extendedWty.bestDeal == null || extendedWty.bestDeal != 'Y'){
                                        $(extendedWtyTemplate).find('.tag-content').remove();
                                    }
                                    $currentLoopBlock.find('.select-care > ul').append(extendedWtyTemplate);
                                    $($currentLoopBlock.get(0)).addClass('act');
                                }
                                // PJTEXTENDEDWTY2-4 extendedWtyList loop 추가 END
                            }else {
                                var template = $currentLoopBlock.find('template').clone().html(),
                                    appendHtml = [];
                                // REQ-022 : 버그 수정 시작 (if문 추가)
                                if(_val) {
                                    for (var j2 = 0; j2 < _val.length; j2++) {
                                        // appendHtml += template.replace(/\*compModelSku\*/g, _val[j2].compModelSku);
                                        // var str = "*"+_val[j2]+"*";
                                        var __val = _val[j2],
                                            htmlLine = template;
                                        for(var __key in __val) {
                                            if(template.indexOf(__key) > -1) {
                                                htmlLine = htmlLine.replace("*"+__key+"*", __val[__key]);
                                            }
                                        }
                                        appendHtml += htmlLine;
                                    }
                                    // REQ-022 : 버그 수정 끝
                                    $currentLoopBlock.html(appendHtml);
                                }
                                
                            }
                        }

                        $html.find('.promotion > li').each(function() {
                            var txt = $.trim($(this).find('>a').text());
                            if(txt == 'undefined' || txt == '' || txt == 'null') {
                            $(this).remove();
                            }
                        });

                        // country list
                        if(p.contryList.length>0){
                            var availableContries1 = $html.find('.available-contries.incount');
                                availableContries2 = $html.find('.available-contries.overcount');
                            var countriesTemplate1 = availableContries1.find('template').clone().html(),
                                countriesTemplate2 = availableContries2.find('template').clone().html();

                            availableContries1.find('template').remove();
                            availableContries2.find('template').remove();

                            if(p.contryList.length <= 7) {
                                $html.find('.available-contries.overcount').remove();
                                var countriesMarkup1 = [];
                                for (var l = 0; l < p.contryList.length; l++) {
                                    var countryInfo1 = p.contryList[l];
                                    var tmpHTML1 = countriesTemplate1.replace(/\*countryName\*/g, countryInfo1.countryName)
                                                                        .replace(/\*nationalIconUrl\*/g, countryInfo1.nationalIconUrl)
                                                                        ;
                                    countriesMarkup1 += tmpHTML1;
                                }
                                availableContries1.find('ul').append(countriesMarkup1);
                            } else if(p.contryList.length > 0) {
                                $html.find('.available-contries.incount').remove();
                                var countriesMarkup2 = '<div class="flag-col-2"><ul>',
                                    halfNumber = Math.round(p.contryList.length / 2);
                                for (var j = 0; j < p.contryList.length; j++) {
                                    var countryInfo2 = p.contryList[j];
                                    var tmpHTML2 = countriesTemplate2.replace(/\*countryName\*/g, countryInfo2.countryName)
                                                                        .replace(/\*nationalIconUrl\*/g, countryInfo2.nationalIconUrl)
                                                                        ;
                                    countriesMarkup2 += tmpHTML2;

                                    if(j == halfNumber-1) {
                                        countriesMarkup2 += '</ul></div><div class="flag-col-2"><ul>';
                                    }
                                }
                                countriesMarkup2 += '</ul></div>';
                                availableContries2.find('.flag-col-2').remove();
                                availableContries2.find('.flag-box').append(countriesMarkup2);
                            } else {
                                $html.find('.available-contries.overcount').remove();
                                $html.find('.available-contries.incount').remove();
                            }
                        }else {
                            $html.find('.available-contries.overcount').remove();
                            $html.find('.available-contries.incount').remove();
                        }

                        // delivery info area delivery-area
                        var $deliveries = $html.find('ul.delivery-list');
                        for(var i4 = 0; i4 < $deliveries.length; i4++) {
                            var markup = $deliveries.eq(0).html();
                            if($.trim(markup) == '') {
                                $deliveries.eq(0).remove();
                            }
                        }

                        // PJTOBS 20200703 Start
                        // re stock alert
                        var $stockArea = $html.find('.stock-area');
                        if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y') && $stockArea.length>0) {
                            $stockArea.removeClass('out-of-stock').empty();
                        }
                        // PJTOBS 20200703 End

                        // buttons
                        /*
                        data-link-area="pdp_main-btn" data-sc-item="where-to-buy"
                        data-link-area="pdp_main-btn" data-link-name="find_a_dealer"
                        */
                        // PJTOBS 20200703 Start
                        if((!p.reStockAlertFlag || p.reStockAlertFlag!='Y') && $html.find('.button a.re-stock-alert').length>0) {
                            $html.find('.button a.re-stock-alert').remove();
                        }
                        
                        // PJTLIMITQTY Start
                        if(p.limitSaleUseFlag == "Y" && p.limitSaleModelViewUseFlag == "Y" && p.obsLimitSale == "Y" && p.obsProductCount == "0" && $html.find('.button a.re-stock-alert').length > 0) {
                            $html.find('.button a.re-stock-alert').remove();
                        }
                        // LGEDE-865 Start : OBS,.COM 태그 동시 노출 조건 추가
                        if(p.obsComTagShowFlag == 'Y') { // LGEDE-865
                            if(p.productTag1Type == 'OBS') {
                                $html.find('.flag span:contains('+p.productTag1+')').addClass("flag-imp");
                            }
                            if(p.productTag2Type == 'OBS') {
                                $html.find('.flag span:contains('+p.productTag2+')').addClass("flag-imp");
                            }
                        } else { // 기존 로직
                            // PJTLIMITQTY SIBLING 누락 추가
                            if(p.obsPreOrderFlag == 'Y' && p.obsPreOrderRSAFlag == 'Y'){
                                $html.find('.flag span').addClass("flag-imp");
                            }
                            if(p.limitSaleUseFlag == "Y" && p.obsLimitSale == "Y"){
                                $html.find('.flag span').addClass("flag-imp");
                            }
                            if(p.obsPreOrderFlag == 'Y' || p.obsPreOrderRSAFlag == 'Y'){
                                $html.find('.flag span').eq(0).addClass("flag-imp");
                            }
                        }
                        // LGEDE-865 END
                        
                        if(p.vipPriceFlag != 'Y' || ISVIP == false) {
                            if(p.limitSaleUseFlag == "Y" && p.obsLimitSale == "Y"){
                                $html.find('.price-limited').show();
                                if(p.obsInventoryFlag == 'Y'){
                                    $html.find('.price-limited .limited-ea').removeClass('zero');
                                    $html.find('.price-limited .limited-ea').addClass('imp');
                                    $html.find('.sold-out').hide();
                                    $html.find('.stock-area.out-of-stock').hide();
                                    $('.pdp-top-banner').show();
                                }else{
                                    $html.find('.price-limited .limited-ea').removeClass('imp');
                                    $html.find('.price-limited .limited-ea').addClass('zero');
                                    $html.find('.sold-out').show();
                                    $html.find('.stock-area.out-of-stock').hide();
                                    $('.pdp-top-banner').hide();
                                }
                            }else if(p.reStockAlertFlag == 'Y' && p.reStockAlertFlag =='Y' && $html.find('.stock-area').length>0 && (p.limitSaleUseFlag != "Y" || p.obsLimitSale != "Y")) {
                                $html.find('.price-limited').hide();
                                $html.find('.price-vip').hide();
                                $html.find('.sold-out').hide();
                                $html.find('.stock-area.out-of-stock').show();
                                $('.pdp-top-banner').hide();
                            }else{
                                $html.find('.price-limited').hide();
                                $html.find('.price-vip').hide();
                                $html.find('.sold-out').hide();
                                $html.find('.stock-area.out-of-stock').hide();
                                $('.pdp-top-banner').hide();
                            }
                        }else{
                            if(p.limitSaleUseFlag == "Y" && p.obsLimitSale == "Y"){
                                $html.find('.price-vip').show();
                                $html.find('.limited-qty').show();
                                $html.find('.price-limited').hide();
                                if(p.obsInventoryFlag == 'Y'){
                                    $html.find('.limited-qty .limited-ea').removeClass('zero');
                                    $html.find('.limited-qty .limited-ea').addClass('imp');
                                    $html.find('.sold-out').hide();
                                    $html.find('.stock-area.out-of-stock').hide();
                                    $('.pdp-top-banner').show();
                                }else{
                                    $html.find('.limited-qty .limited-ea').removeClass('imp');
                                    $html.find('.limited-qty .limited-ea').addClass('zero');
                                    $html.find('.sold-out').show();
                                    $html.find('.stock-area.out-of-stock').hide();
                                    $('.pdp-top-banner').hide();
                                }
                            }else if(p.reStockAlertFlag == 'Y' && p.reStockAlertFlag =='Y' && $html.find('.stock-area').length>0 && (p.limitSaleUseFlag != "Y" || p.obsLimitSale != "Y")) {
                                $html.find('.price-limited').hide();
                                $html.find('.price-vip').show();
                                $html.find('.limited-qty').show();
                                $html.find('.sold-out').hide();
                                $html.find('.stock-area.out-of-stock').show();
                                $('.pdp-top-banner').hide();
                            }else{
                                $html.find('.price-limited').hide();
                                $html.find('.price-vip').show();
                                $html.find('.limited-qty').hide();
                                $html.find('.sold-out').hide();
                                $html.find('.stock-area.out-of-stock').hide();
                                $('.pdp-top-banner').hide();
                            }
                            
                        }
                        // PJTLIMITQTY End
                        // PJTOBS 20200703 End
                        
                        //PJTOBS/2020/PJTOBSB2E-6 GILS
                        var $preOrderAreaTemplate = $html.find('.pre-order-area[data-message-period]');
                        var objPreOrderMessage = $preOrderAreaTemplate.data();
                        var obsPincodeFlag= objPreOrderMessage.obsPincodeFlag;
                        var obsInstallMsg= objPreOrderMessage.obsInstallMsg;
                        var messagePeriod= objPreOrderMessage.messagePeriod;
                        var messageRemaindays= objPreOrderMessage.messageRemaindays;
                        var messageAvailable= objPreOrderMessage.messageAvailable;
                        //var messageAlmost= objPreOrderMessage.messageAlmost;
                        var messageShipment= objPreOrderMessage.messageShipment;
                        var messagePayment= objPreOrderMessage.messagePayment;
                        
                        if(p.obsPreOrderFlag == 'Y' || p.obsPreOrderRSAFlag == 'Y'){
                            $preOrderAreaTemplate.find('[data-message-target="period"]').html(
                                    messagePeriod.replace('{0}',p.obsPreOrderStartDate.substring(0,10))
                                    .replace('{1}',p.obsPreOrderEndDate.substring(0,10))
                            );
                            $preOrderAreaTemplate.find('[data-message-target="remaindays"]').attr('data-message-pre-order-remaindays',messageRemaindays);
                            $preOrderAreaTemplate.find('[data-message-target="available"]').html(messageAvailable.replace('{0}',p.obsPreOrderSalablePreQuantity));
                            //$preOrderAreaTemplate.find('[data-message-target="almost"]').html(messageAlmost);
                            var shipmentMsg='';
                            //LGEGMC-2197 START
                            if(p.obsPreOrderDeliveryStartDate != null){
                                shipmentMsg = messageShipment.replace('{0}',p.obsPreOrderDeliveryStartDate.substring(0,10));
                            }else{
                                $preOrderAreaTemplate.find('.pre-delivery, .pre-shipment').remove();
                            }
                            //LGEGMC-2197 END
                            if(obsPincodeFlag == 'Y'){
                                $preOrderAreaTemplate.find('[data-message-target="payment"]').html(messagePayment);
                                //LGEMS-189 START
                                if(p.obsPreOrderInventoryFlag == 'Y' && COUNTRY_CODE.toLowerCase() != "mx"){
                                    shipmentMsg += obsInstallMsg;
                                }
                                //LGEMS-189 END
                            }
                            $preOrderAreaTemplate.find('[data-message-target="shipment"]').html(shipmentMsg);
                            $html.find('[data-delivery-template]').remove();
                            if(p.obsPreOrderInventoryFlag != 'Y'){
                                $html.find('[delivery-template]').remove();
                                $preOrderAreaTemplate.find('.pre-secure').remove();
                            }
                        }else{
                            $html.find('[data-pre-order-template]').remove();
                        }
                        if(p.obsDisclaimer == null || p.obsDisclaimer == ''){
                            $html.find('.pre-graybox-info').remove();
                        }else{
                            $html.find('.pre-graybox-info').html(p.obsDisclaimer);
                        }
                        if(p.addToCartFlag =="Y" || p.addToCartFlag =="S"){
                            
                        }else{
                            $html.find('[data-delivery-template]').remove();
                        }
                        //LGEVN-587
                        if(p.uspMessageNotUseFlag == 'Y'){
                            $preOrderAreaTemplate.find('.pre-delivery-period').hide();
                            $preOrderAreaTemplate.find('.pre-shipment').hide();
                            $preOrderAreaTemplate.find('.pre-secure').hide();
                        } else{
                            $preOrderAreaTemplate.find('.pre-delivery-period').show();
                            $preOrderAreaTemplate.find('.pre-shipment').show();
                            $preOrderAreaTemplate.find('.pre-secure').show();
                        }
                        
                        //QUICKWIN-4_krchoi Start
                        if(p.obsPreOrderFlag == 'Y'){ 
                            $html.find('.button a.add-to-cart.top-red-btn').data('model-id', p.modelId).attr('href', '#').text(p.productMessages.preOrderBtnNm).attr('role', 'button').removeAttr('target, title')
                            .addClass('pre-order').attr('data-obs-pre-order-start-date',p.obsPreOrderStartDate).attr('data-obs-pre-order-end-date',p.obsPreOrderEndDate)
                            ; 
                        }else if(p.addToCartFlag!="N") {
                            if(p.addToCartFlag == 'Y') {
                                // 통합 OBS
                                $html.find('.button a.add-to-cart.top-red-btn').data('model-id', p.modelId).attr('href', '#').text(p.productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
                            } else if(p.addToCartFlag == 'S') {
                                // Standalone OBS
                                $html.find('.button a.add-to-cart.top-red-btn').data('model-id', p.modelId).attr('href', '#').text(p.productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
                            }
                        } else if(p.buyNowFlag=="Y" || p.buyNowFlag=="L") {
                            if(p.ecommerceTarget == '_blank') {
                                $html.find('.button a.add-to-cart.top-red-btn').data('model-id', p.modelId).attr('href', p.buyNowURL).text(p.productMessages.buyNowBtnNm).removeAttr('role').attr('target', '_blank').attr('title', p.productMessages.btnNewLinkTitle);
                            }else {
                                $html.find('.button a.add-to-cart.top-red-btn').data('model-id', p.modelId).attr('href', p.buyNowURL).text(p.productMessages.buyNowBtnNm).removeAttr('role').removeAttr('target, title');
                            }
                        // 20200506 START 박지영 - flag 명 변경
                        } else if (p.resellerBtnFlag=="Y") {
                        // 20200506 END
                            $html.find('.button a.add-to-cart.top-red-btn').addClass('active').data('model-id', p.modelId).attr('href', p.resellerLinkUrl).text(p.productMessages.resellerBtnNm).removeAttr('role').attr('target', '_blank').attr('title', p.productMessages.btnNewLinkTitle);
                        } else {
                            $html.find('.button a.add-to-cart.top-red-btn').remove();
                        }
                        // WTB btn, Recommanded Products btn, CTA btn
                        //WTB btn이 없을 시
                        if(p.whereToBuyFlag!="Y" || p.whereToBuyUrl == null || p.whereToBuyUrl == ''){
                            // Recommanded Products btn
                            if(null != p.recommendedProducts && p.recommendedProducts.length > 0 && ('DISCONTINUED' == p.modelStatusCode || ('ACTIVE' == p.modelStatusCode && 'Y' == p.obsSellFlag && 'N' == p.obsInventoryFlag))){
                                //이미 빨간 버튼이 있으면 하얀색 버튼으로 출력
                                if($html.find('.button a.re-stock-alert').length > 0 || $html.find('.button a.add-to-cart.top-red-btn').length > 0){
                                    $html.find('.button a.recommended-products.top-red-btn').remove();
                                }else{
                                    $html.find('.button a.recommended-products.bottom-white-btn').remove();                             
                                }
                            }else{
                                $html.find('.button a.recommended-products.top-red-btn').remove();
                                $html.find('.button a.recommended-products.bottom-white-btn').remove();                                 
                            }
                            
                            if(p.wtbExternalLinkUseFlag=="Y" && p.wtbExternalLinkUrl != null && p.wtbExternalLinkUrl != '' && p.wtbExternalLinkName != null && p.wtbExternalLinkName != '') {
                                // go to external link
                                //LGEGMC-2202 START
                                // PRE-ORDER, BUY NOW 선택시에는 Red 버튼
                                // TROUVER UN DETAILLANT, NOTIFY ME, Where to buy, DEMANDER UN DEVIS 선택시에는 White 버튼
                                $html.find('.button a.in-buynow').attr('href', p.wtbExternalLinkUrl).text(p.wtbExternalLinkName).attr('data-link-name', 'buy_now').removeAttr('data-sc-item');
                                if(p.wtbExternalLinkSelfFlag == 'Y') {
                                    $html.find('.button a.in-buynow').removeAttr('target, title');
                                } else {
                                    $html.find('.button a.in-buynow').attr('target', '_blank').attr('title', p.productMessages.btnNewLinkTitle);
                                }
                                $html.find('.button a.in-buynow').attr('data-link-area', 'pdp_main-btn').attr('data-link-name', 'buy_now');
                                
                                if('PRE-ORDER' == p.wtbExternalLinkName || 'BUY NOW' == p.wtbExternalLinkName){
                                    if($html.find('.button a.re-stock-alert').length > 0 || $html.find('.button a.add-to-cart.top-red-btn').length > 0 || $html.find('.button a.recommended-products.top-red-btn').length > 0){
                                        $html.find('.button a.in-buynow.top-red-btn').remove();
                                    }else{
                                        $html.find('.button a.in-buynow.bottom-white-btn').remove();                                            
                                    }           
                                }else if('TROUVER UN DETAILLANT' == p.wtbExternalLinkName || 'NOTIFY ME' == p.wtbExternalLinkName || 'Where to buy' == p.wtbExternalLinkName || 'DEMANDER UN DEVIS' == p.wtbExternalLinkName){
                                    $html.find('.button a.in-buynow.top-red-btn').remove(); 
                                }else{
                                    $html.find('.button a.in-buynow.bottom-white-btn').remove();
                                    $html.find('.button a.in-buynow.top-red-btn').remove();     
                                }
                            }else{
                                $html.find('.button a.where-to-buy.bottom-white-btn').remove();
                                $html.find('.button a.where-to-buy.top-red-btn').remove();                          
                            }
                        }else if(p.whereToBuyFlag=="Y" && p.whereToBuyUrl != null && p.whereToBuyUrl != '') {
                            // Recommanded Products btn
                            if(null != p.recommendedProducts && p.recommendedProducts.length > 0 && ('DISCONTINUED' == p.modelStatusCode || ('ACTIVE' == p.modelStatusCode && 'Y' == p.obsSellFlag && 'N' == p.obsInventoryFlag))){
                                //WTB btn이 있어도 무조건 Red btn으로 노출
                                //QUICKWIN-4_whereToBuy Modify(.top-red-btn -> .bottom-white-btn)
                                $html.find('.button a.recommended-products.bottom-white-btn').remove();     
                            }else{
                                $html.find('.button a.recommended-products.top-red-btn').remove();
                                $html.find('.button a.recommended-products.bottom-white-btn').remove();                                 
                            }
                            
                            // WTB btn
                            $html.find('.button a.where-to-buy').attr('href', p.whereToBuyUrl).text(p.productMessages.whereToBuyBtnNm);
                            $html.find('.button a.where-to-buy').removeAttr('target, title');
                            $html.find('.button a.where-to-buy').attr('data-link-area', 'pdp_main-btn').attr('data-sc-item', 'where-to-buy').attr('data-link-name', 'where_to_buy');
                            //QUICKWIN-4_whereToBuy Start
                            $html.find('.button a.where-to-buy.top-red-btn').remove();
                            //QUICKWIN-4_whereToBuy End
                        }else{
                            $html.find('.button a.where-to-buy.bottom-white-btn').remove();
                            $html.find('.button a.where-to-buy.top-red-btn').remove();                          
                        // 20200410 END
                        } 
                        //LGEEG-154
                        if(p.buyNowUnionStoreBtnFlag =="Y"){
                            $html.find('.button a.buyNowUnionBtn').addClass('active');
                        } else{
                            $html.find('.button a.buyNowUnionBtn').removeClass('active');
                            //QUICKWIN-4_whereToBuy ADD
                            $html.find('.button a.buyNowUnionBtn').remove();    
                        }
                        
                        //Product support btn
                        if (p.productSupportFlag=="Y") {
                            $html.find('.button a.add-to-cart.bottom-white-btn').addClass('active').data('model-id', p.modelId).attr('href', p.productSupportUrl).text(p.productMessages.productSupportBtnNm).removeAttr('role').removeAttr('target, title');
                        }else{
                            $html.find('.button a.add-to-cart.bottom-white-btn').remove();
                        }
                        
                        // product enquiry (IN Only) btn
                        if(p.productEnquiryUrl && p.productEnquiryUrl != null && p.productEnquiryUrl != '') {
                            $html.find('.button a.product-enquiry').attr('href', p.productEnquiryUrl);
                        } else {
                            $html.find('.button a.product-enquiry').remove();
                        }
                        
                        // inquiry to buy btn
                        if(p.inquiryToBuyFlag=="Y" && p.inquiryToBuyUrl != null && p.inquiryToBuyUrl != '') {
                            $html.find('.button a.inquiry-to-buy').attr('href', p.inquiryToBuyUrl).text(p.productMessages.inquiryToBuyBtnNm);
                            if($html.find('.button a.re-stock-alert').length > 0 || $html.find('.button a.add-to-cart.top-red-btn').length > 0 || $html.find('.button a.where-to-buy.top-red-btn').length > 0){
                                $html.find('.button a.inquiry-to-buy.top-red-btn').remove();
                            }else{
                                $html.find('.button a.inquiry-to-buy.bottom-white-btn').remove();                               
                            }
                        } else {
                            $html.find('.button a.inquiry-to-buy.top-red-btn').remove();
                            $html.find('.button a.inquiry-to-buy.bottom-white-btn').remove();       
                        }
                        
                        // Find a dealer btn
                        if(p.findTheDealerFlag=="Y" && p.findTheDealerUrl != null && p.findTheDealerUrl != '') {
                            if($html.find('.button a.inquiry-to-buy').length > 0){
                                $html.find('.button a.find-a-dealer.top-red-btn').remove();
                            }else{
                                $html.find('.button a.find-a-dealer.bottom-white-btn').remove();
                            }
                            $html.find('.button a.find-a-dealer').attr('href', p.findTheDealerUrl).text(p.productMessages.findTheDealerBtnNm);
                            $html.find('.button a.find-a-dealer').attr('data-link-area', 'pdp_main-btn').attr('data-link-name', 'find_a_dealer');
                        } else {
                            $html.find('.button a.find-a-dealer').remove();
                        }
                        // QUICKWIN-4_krchoi End 
                        
                        //PJTPDR-1 START
                        if(p.pdrCompareUseFlag == "N") {
                            $html.find('.wishlist-compare').hide();
                        } else {
                            $html.find('.wishlist-compare').show();
                        }
                        //PJTPDR-1 END
                        
                        //LGEPL-655 Start
                        if(p.obsSubscriptionCtaUseFlag && null != p.obsSubscriptionCtaUseFlag) {
                        	if("Y" == p.obsSubscriptionCtaUseFlag && "Y" == p.obsSubscriptionEnableFlag) {
                        		$html.find('.button').find('a.subscribe-box').show();
                        	} else {
                        		$html.find('.button').find('a.subscribe-box').hide();
                        	}
                        }  else {
                        	$html.find('.button').find('a.subscribe-box').hide();
                        }
                        //LGEPL-655 End   
                        
                        // set add to compare button
                        if(getCookie(compareCookie.name) != undefined) {
                            // console.log(getCookie(compareCookie.name), getCookie(compareCookie.name).indexOf(p.modelId))
                            if(p.modelId && getCookie(compareCookie.name).indexOf(p.modelId) != -1) {
                                // If compare cookie has this product
                                $html.find('.js-compare').addClass('added');
                            } else {
                                $html.find('.js-compare').removeClass('added');
                            }
                        } else {
                            $html.find('.js-compare').removeClass('added');
                        }
                        
                        /* LGEIN-546 Start */
                        if(p.obsKeyFeatureUesFlag == 'Y' && !!p.obsKeyFeature.length){
                            $html.find('.pre-key-feature').show();
                        }else{
                            $html.find('.pre-key-feature').hide();
                        }
                        /* LGEIN-546 End */

                        // console.log($html.filter(''));
                        $(summary.el).find('.mobile-top-info').html(xssfilter($html.filter('.mobile-top-info').html(), true));
                        $(summary.el).find('.mobile-bottom-info').html(xssfilter($html.filter('.mobile-bottom-info').html(), true));
                        // PJTQUICKWIN-4_whereToBuy Start
                        if (p.productSupportFlag != "Y" && p.resellerBtnFlag != "Y" && p.addToCartFlag != "Y" && p.addToCartFlag != "S" && p.buyNowFlag != "Y" && p.buyNowFlag != "L" && p.wtbExternalLinkUseFlag != "Y" && p.reStockAlertFlag != "Y" && p.obsPreOrderFlag != "Y" && p.buyNowUnionStoreBtnFlag != "Y"){
                            $(summary.el).find('.mobile-bottom-info').find('.button a.where-to-buy.bottom-white-btn').attr('no-red-btn', true);
                            $(summary.el).find('.mobile-bottom-info').find('.button a.where-to-buy.bottom-white-btn').hide();
                        }else{
                            $(summary.el).find('.mobile-bottom-info').find('.button a.where-to-buy.bottom-white-btn').attr('no-red-btn', false);
                        }
                        // PJTQUICKWIN-4_whereToBuy End
                        $(summary.el).find('.desktop-info').html(xssfilter($html.filter('.desktop-info').html(), true));
                        siteTimeInit(p.preOrderDiffDate);
                        // 20200406 START 박지영 : siblings 클릭시 리뷰 
                        if(p.siblings[0].target && p.siblings[0].target.toUpperCase() == "SELF") {
                            if(typeof setBVRatingsPDP == 'function') setBVRatingsPDP();
                        }
                        // 20200406 END

                        // change gallery image (modelId, baseProductimage, baseProductAlttext, galleryImgList)
                        var galleryList;
                        if(p.videos) {
                            galleryList = p.videos.concat(p.galleryImages);
                        }else {
                            galleryList = p.galleryImages;
                        }
                        
                        // change right main visual area change
                        summary.changeSubModelImage(id, p.galleryImages[0].largeImageAddr, p.imageAltText, galleryList);
                        
                        // LGEGMC-3294
                        if ($html.find('.view-button-area a').length > 0) {
                            $(summary.el).find('.pdp-visual-area.visible-sm').addClass('sm-mt-0');
                        } else {
                            $(summary.el).find('.pdp-visual-area.visible-sm').removeClass('sm-mt-0');
                        }
                        // LGEGMC-3294 End

                        bindImgError();
                        searchInit(); // common.js
                        scrollDesign(); // mCustomScrollbar.js
                        runChosen(); // chosen.js
                        tooltipActive(); // common.js
                        chosenScrollInit(); //LGEGMC-1914 mCustomScrollbar.js
                        //if(typeof runEcorebates !== "undefined") { // ecorebates
                        //  if($.isFunction(runEcorebates)) runEcorebates();
                        //}

                        // adobe
                        if(p.modelName != null && p.modelName != "undefined") {
                            $(summary.el).closest('.GPC0009').attr('data-adobe-modelname', p.modelName);
                        } else {
                            $(summary.el).closest('.GPC0009').attr('data-adobe-modelname', '');
                        }
                        if(p.salesModelCode != null && p.salesModelCode != "undefined") {
                            $(summary.el).closest('.GPC0009').attr('data-adobe-salesmodelcode', p.salesModelCode);
                        } else {
                            $(summary.el).closest('.GPC0009').attr('data-adobe-salesmodelcode', '');
                        }
                        
                        $(summary.el).closest('.GPC0009').attr('data-adobe-salessuffixcode',  (p.salesSuffixCode || '') ); /* LGEGMC-455 20200717 add */

                        // main visual image thumbnail activate
                        $(summary.els.base.desktop.target.querySelectorAll(".thumbnail")[0]).addClass("active");

                        summary.addAriaDescribedby();

                        // sns share
                        $('.pdp-summary-area .sns-area').find('.sns').on('click', function(e){
                            e.preventDefault();
                            // 20200406 START 박지영 : siblings 클릭 후에도 sns 클릭시 배너 영향 안 받도록 수정
                            //if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_SOCIAL_MEDIA')) {
                                    var $snsLayer = $(this).closest('.sns-area').find('.list');
                                    if($snsLayer.hasClass('active')) {
                                        $snsLayer.removeClass('active');
                                    } else {
                                        $snsLayer.addClass('active');
                                    }
                            //} else {
                            //  ePrivacyCookies.view('click');
                            //}
                            // 20200406 END
                        });
                        
                        /* LGEIS-443 : 20210514 add */
                        if(p.obsShippingInfoIconFlag == 'Y' && ( p.reStockAlertFlag == 'Y' || p.addToCartFlag == 'Y') ){
                            $('.pre-order-area[data-obs-shipping-info-icon]').show();
                        }else{
                            $('.pre-order-area[data-obs-shipping-info-icon]').hide();
                        }
                        /*// LGEIS-443 : 20210514 add */
                        
                        /* LGEGMC-1777 : 20210615 add */
                        if(p.obsShippingUseFlag != 'Y'){
                            $html.find('.delivery-list.delivery-bottom-obs-shipping').remove();
                        }
                        $('[data-obs-lead-time]').hide();
                        if(( p.reStockAlertFlag == 'Y' || p.addToCartFlag == 'Y' || p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y" || p.obsShippingUseFlag == 'Y' ) && p.obsLeadTimeFlag == 'Y' && !!p.obsLeadTimeMax && !!p.obsLeadTimeMin){
                            if(p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y"){
                                $('[data-obs-lead-time="preOrder"]').show();
                            }else if(p.obsPincodeFlag == "Y" && p.addToCartFlag == "Y"){
                                $('[data-obs-lead-time="obsPincode"]').show();
                            }else if(p.obsShippingInfoIconFlag == 'Y' && ( p.reStockAlertFlag == 'Y' || p.addToCartFlag == 'Y')){
                                $('[data-obs-lead-time="obsShippingInfoIcon"]').show();
                            }else if(p.obsShippingUseFlag == 'Y'){
                                $('[data-obs-lead-time="obsShipping"]').show();
                            /* LGEGMC-2521 Start */
                            }else if(p.obsLeadTimePlaceChange == 'Y'){
                                $('[data-obs-lead-time="obsLeadTimePlaceChange"]').show();
                            /* LGEGMC-2521 End */
                            }else{
                                $('[data-obs-lead-time="obsOther"]').show();
                            }
                        }
                        
                        if(( p.reStockAlertFlag == 'Y' || p.addToCartFlag == 'Y' || p.obsPreOrderFlag == "Y" || p.obsPreOrderRSAFlag == "Y" ) && p.obsLeadTimeFlag == 'Y' && !!p.obsLeadTimeMax && !!p.obsLeadTimeMin && p.obsLeadTimeInfoFlag == 'Y'){
                            $('.delivery-info.marked').not(".mileage").show(); // LGEGMC-2424
                        }else{
                            $('.delivery-info.marked').not(".mileage").hide(); // LGEGMC-2424
                        }
                        /*// LGEGMC-1777 : 20210615 add */
                        // LGEGMC-2424 start
                        if( p.obsMileageInfoUseFlag == 'Y'){
                            $('.delivery-info.marked.mileage').show();
                        }else{
                            $('.delivery-info.marked.mileage').hide();
                        }
                        // LGEGMC-2424 end
                        //LGESA-268, LEGEG-159 START
                        if(p.obsPreOrderFlag == 'N' && ( p.reStockAlertFlag == 'Y' || p.addToCartFlag == 'Y') && (COUNTRY_CODE == 'sa' || COUNTRY_CODE == 'sa_en')){
                            $('.pre-order-area[data-obs-shipping-distinct]').show();    
                        }else {
                            $('.pre-order-area[data-obs-shipping-distinct]').hide();
                        }
                        //LGESA-268, LEGEG-159 END
                        /* PJTMEMBERSHIP-1 */
                        if(p.membershipPointDisplayFlag =="Y" && ($html.find('[data-delivery-template]').length > 0 || $html.find('[data-pre-order-template]').length > 0 || $('.pre-order-area[data-obs-shipping-info-icon]').css('display') != 'none')){
                            $('[membership-template]').remove();
                        }
                        /* PJTMEMBERSHIP-1 */
                    }

                    // PJTOBS-32 Start
                    var $priceArea = $('.GPC0009 .pdp-summary-area .price-area');
                    if(ISVIP) $priceArea.addClass('vip-price-area');
                    //PJTLIMITQTY_EXTEND
                    var limitSaleConditionFlag =  p.vipPriceFlag == 'N' && p.obsLimitSale == 'Y' && p.limitSaleUseFlag == 'Y' ? 'Y' : 'N';
                    if(p.vipPriceFlag == 'Y') {
                        var priceOrg = changeFormatFullPrice(p.rPrice, p.rPriceCent);
                        var pricePromo = changeFormatFullPrice(p.rPromoPrice, p.rPromoPriceCent);
                        var legal = p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');       // LGEIS-229 change how discounts are shown
                        var vipPriceText = p.productMessages.vipPriceMessage;
                        //LGEMS-432 Start
						if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
							vipPriceText = p.productMessages.b2bVipPriceMessage;
						}
						//LGEMS-432 End
                        var previousPriceText = p.productMessages.previousPriceText;
                        var emiMsgText = p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '';
                        setVipPrice($priceArea, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, p.modelId + '/' + 'GPC0009.js',emiMsgText,p.afterPay, limitSaleConditionFlag, p.limitSaleTitle); // LGCOMMON-54 :: LGEPL-697 소스 rollback
                    }else if(SIGN_IN_STATUS == 'Y' && p.emiMemberMsg != null && p.emiMemberMsg != ''){
                        //LGCOMSM-51 START
                        setInstallmentMember($priceArea,p.emiMemberMsg);
                        //LGCOMSM-51 END
                    }
                    // PJTOBS-32 End
                    if($('.GPC0007,.GPC0026,.GPC0132,.GPC0009').length>0) {
                        if($priceArea.siblings( '.price-vip-Installment,.price-pdp-Installment').length > 0){
                            $priceArea.removeClass('vip-price-area');   
                        }
                    }

                    var $stickyBar = $('.GPC0011');
                    if($stickyBar.get(0)) {
                        // change GPC0011 product info
                        $stickyBar.trigger('changeSubModel', [p]);
                    }

                    // PJTOBS-31 Start
                    if($('.GPC0010').length>0) {
                        packageComponent.changeSubModel(p.modelId);
                        var price = 0;
                        if(p.rPromoPrice == null) {
                            if(p.rPriceCent == null) {
                                price = parseInt(p.rPrice);
                            } else {
                                price = parseFloat(p.rPrice +'.'+ p.rPriceCent);
                            }
                        } else {
                            if(p.rPromoPriceCent == null) {
                                price = parseInt(p.rPromoPrice);
                            } else {
                                price = parseFloat(p.rPromoPrice +'.'+ p.rPromoPriceCent);
                            }
                        }
                        packageComponent.initialPrice = price;
                    }
                    // PJTOBS-31 End

                    // where to buy  (GPC0009, GPC0102, GPC0114)
                    // 20200408 START 박지영 : 9번 컴포넌트에서 Siblings 클릭시 하단의 WTB 영역 업데이트
                    var currModel = p.modelId;
                    if($('.GPC0102').length>0) {
                        if($('.GPC0102 .find-online').length>0) {
                            var list = $('.GPC0102 .find-online .list');
                            var changeHTML = function(displayType, data, template, i) {
                                if(!template) return '';
                                if(displayType=='ru') {
                                    var cid = decodeURI(getCookie('cid'));
                                    txt = template.replace(/\*url1\*/g, (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
                                            .replace(/\*url2\*/g,  (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
                                            .replace(/\*img\*/g, data.logo)
                                            .replace(/\*txt\*/g, data.name)
                                            .replace(/\*idx\*/g, i)
                                            ;
                                } else if(displayType=='lg') {
                                    txt = template.replace(/\*url1\*/g, data.deeplink_url)
                                            .replace(/\*url2\*/g,  data.deeplink_url)
                                            .replace(/\*img\*/g, data.logo_url)
                                            .replace(/\*txt\*/g, data.name)
                                            .replace(/\*idx\*/g, i)
                                            ;
                                } else {
                                    txt = template.replace(/\*url1\*/g, (data.homepage_url ? data.homepage_url : data.deeplink_url))
                                            .replace(/\*url2\*/g,  (data.deeplink_url ? data.deeplink_url : data.homepage_url))
                                            .replace(/\*img\*/g, data.logo_url)
                                            .replace(/\*txt\*/g, (displayType) ? data.display_name : data.name)
                                            .replace(/\*idx\*/g, i)
                                            ;
                                }
                                return txt;
                            };
                            if(list.hasClass('stock-list-ajax')) {
                                // 20200408 START 박지영 : 쿠키 배너 체크 하지 않도록 수정, dataType 수정
                                //if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
                                    var url = list.data('url').replace(originalModelId, currModel);
                                    var _this = list;
                                    var isDisplayName = _this.data("display-name");

                                    var dataType = 'json';
                                    var res = 'retailers';
                                    if(url.indexOf('lgwtb.lv') >=0) {
                                        dataType = 'jsonp';
                                        res = 'shops'
                                    }
                                    ajax.call(String(url), {}, dataType, function(data){
                                        var html = '';
                                        if(data) {
                                            // 아래 내용 수정 시, (GPC0009, GPC0102, GPC0114) 함께 수정 필요
                                            // GPC0009 클릭시 GPC0102 수정됨
                                            var r = '';
                                            if(res == 'retailers') {
                                                // Channel Advisor, Intellibrand
                                                r = data.products[0].retailers;
                                            } else {
                                                // lgwtb.lv (ee, lt, lv)
                                                r = data.shops;
                                            }
                                            if(r.length>0) {
                                                for(i=0;i<r.length;i++) {
                                                    if(data.products && data.products[0].model_code) _this.attr('data-model', data.products[0].model_code);
                                                    if(r[i].instock != 'false') {
                                                        html = html + changeHTML(isDisplayName, r[i], _this.data('template'), i);
                                                    }
                                                }
                                                if(html!='') {
                                                    _this.find('ul').remove();
                                                    _this.append('<ul>'+xssfilter(html, 'html')+'</ul>');
                                                    _this.find('.no-items').removeClass('active');
                                                } else {
                                                    _this.find('ul').remove();
                                                    _this.find('.no-items').addClass('active');
                                                }
                                            } else {
                                                _this.find('ul').remove();
                                                _this.find('.no-items').addClass('active');
                                            }

                                        } else {
                                            // error
                                            _this.find('ul').remove();
                                            _this.find('.no-items').addClass('active');
                                        }
                                    }, 'get', null);
                                //}
                                // 20200408 END
                            }
                        }
                        if($('.GPC0102 .find-locally').length>0) {
                            if($('#storeSearchForm input[name=modelId]').length>0) $('#storeSearchForm input[name=modelId]').val(currModel);
                        }
                        if($('.GPC0102 .box-3rd-party').length>0) {
                            $('.GPC0102 .box-3rd-party').each(function() {
                                // 20200406 START 박지영 - obj 위치 수정
                                var obj = $(this);
                                if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
                                    if(obj.find('.list-commerce-connector').length>0 && p.modelEanCode) {
                                        var jsHTML = obj.data('template');
                                        var jsLink = $(jsHTML).data('src');
                                        var dataList = $(jsHTML).data();
                                        var tmpJS = document.createElement('script');
                                        tmpJS.src = jsLink;
                                        for(var key in dataList) {
                                            if(key!='src') {
                                                if(key=='ean') {
                                                    tmpJS.setAttribute('data-ean', p.modelEanCode);
                                                } else {
                                                    tmpJS.setAttribute('data-'+key, dataList[key]);
                                                }
                                            }
                                        }
                                        obj.find('.list-commerce-connector').empty().html($(tmpJS));
                                    }
                                } else {
                                    ePrivacyCookies.view('load', '', obj);
                                }
                                // 20200406 END
                            });
                        }
                    }
                    if($('.GPC0114').length>0) {
                        $('.GPC0114 .stock-list-ajax').each(function() {
                            // 20200408 START 박지영 : ru 추가
                            if(COUNTRY_CODE.toLowerCase() == 'ru') {
                                $(this).attr('data-mpn', (p.salesSuffixCode != null && p.salesSuffixCode != '') ? p.salesModelCode + '.' + p.salesSuffixCode : p.salesModelCode);
                            } else {
                                var url = $(this).data('url').replace(originalModelId, currModel);
                                $(this).data('changedUrl', url);
                            }
                            // 20200408 END
                        });
                        if(typeof GPC0114 == 'function') GPC0114();
                    }

                    // 20200408 START 박지영 : siblings 클릭시, GPC0112 업데이트
                    // where to buy (GPC0112 / ru only)
                    if($('.GPC0112').length>0) {
                        $('.GPC0112 .find-locally').data('mpn', (p.salesSuffixCode != null && p.salesSuffixCode != '') ? p.salesModelCode + '.' + p.salesSuffixCode : p.salesModelCode).trigger("datachange");
                    }
                    // 20200408 END
                    
                    /* LGETR-228 Start */
                    if(p.recommendedRetailRriceInfo == 'Y' && ( !!p.rPromoPrice || !!p.rPrice )){
                        $('.GPC0009 .recommended-retail-price').show();
                    }else{
                        $('.GPC0009 .recommended-retail-price').hide();
                    }
                    /* LGETR-228 End */
                    
                }
            });
        },
        changeSubModelImage: function(id, basicImg, basicAlt, imgList){
            var _this = this,
                _els = _this.els;
                // basicImg = info.group.subModelInfo[id].basicImg,
                // imgList = info.group.subModelInfo[id].galleryImg;
            _els.base.detail.target.setAttribute('src', basicImg);
            _els.base.detail.target.setAttribute('alt', basicAlt);
            _els.base.detail.target.setAttribute('data-src', basicImg);

            // change desktop thumbnails
            _this.create.desktopThumbnail(imgList);

            // reset slicks
            summaryGallery.m.el.removeAttribute('data-initialized');
            modal.el.gallery.removeAttribute('data-initialized');
            var slicks = [
                $(_els.base.mobile.target),
                $(_els.modal.thumbnails.target),
                $(_els.modal.detail.target)
            ];
            for (var i = 0; i < slicks.length; i++) {
                var _curSlick = slicks[i];
                if(_curSlick.is('.slick-initialized')) {
                    _curSlick.slick('unslick');
                }
            }

            $(_els.base.mobile.target).find('.thumbnail, .video').remove();
            $(_els.modal.thumbnails.target).find('.image, .video').remove();
            $(_els.modal.detail.target).find('.image, .video').remove();

            var mobileThumbnail = _this.create.elements(imgList, _els.base.mobile, "largeImageAddr"),
                modalThumbnail = _this.create.elements(imgList, _els.modal.thumbnails, "smallImageAddr"),
                modalDetail = _this.create.elements(imgList, _els.modal.detail);

            $(_els.base.mobile.target).append(mobileThumbnail);
            $(_els.modal.thumbnails.target).find('ul').append(modalThumbnail);
            $(_els.modal.detail.target).append(modalDetail);

            if(modal.el.gallery.getAttribute('data-zoom-initialized')) {
                modal.el.gallery.removeAttribute('data-zoom-initialized');
            }

            summaryGallery.d.setThumbnailsIdx();
            summaryGallery.init();

        },
        addEvent: function(){
            var _this = this;

            // general type Sibling Change fnc
            $(_this.el).on({
                click: function(e){
                    var _anchor = e.currentTarget,
                        id = _anchor.getAttribute('data-model-id'),
                        subId = _anchor.getAttribute('data-sub-model-id');

                    // 20200326 START 박지영 - 현재 선택된 Sibling 클릭하면 동작 안함
                    if($(_anchor).hasClass('active')) return false;
                    // 20200326 END

                    if(subId){
                        e.preventDefault();
                        _this.changeSubModelInfo(id, subId);
                    }
                }
            }, '.sibling-area a');

//LGEITF-947 Start
//            $(modal.el.gallery).on({
//                'hidden.bs.modal': function(e){
//                    $(e.currentTarget).data('beforeFocus').focus();
//                }
//            });
//LGEITF-947 End

            // select type Sibling Change fnc
            // "CARRIER", "CAPACITY", "COOLING CAPACITY"
            $(_this.el).on({
                change: function(e){
                    var id = e.currentTarget.getAttribute('data-model-id'),
                        currentIdx = e.currentTarget.selectedIndex,
                        currentOption = e.currentTarget.options[currentIdx],
                        curreontType = currentOption.getAttribute('data-type');

                    var sub = currentOption.value;

                    if(curreontType && curreontType.toUpperCase() == 'SELF') {
                        _this.changeSubModelInfo(id, sub);
                    }else if(curreontType && curreontType.toUpperCase() == 'NEW'){
                        location.href = sub;
                    }
                }
            }, '.sibling-area select');

            $(_this.el).on({
                change: function(e){
                    var cur = e.currentTarget,
                        $block = $(cur).closest('form').find('.field-block');
                    if(cur.value.length == 0) {
                        $block.removeClass('error pass fail');
                    }
                    $block.find('.search-common-input').val(cur.value);
                }
            }, '.search-common .search-common-input');
            $(_this.el).on({
                click: function(e){
                    e.preventDefault();
                    var cur = e.currentTarget,
                        $input = $(cur).closest('form').find('.search-common-input'),
                        model = $(cur).find('.model-name').text();
                    $(cur).closest('form').find('.search-layer').removeClass('active');
                    $input.val(model).focus();

                    $(cur).closest('form').trigger('submit');
                }
            }, '.search-common a.anchor');
            $(_this.el).on({
                click: function(e){
                    e.preventDefault();
                    var cur = e.currentTarget;
                    var $input = $(cur).closest('form').find('.search-common-input');

                    $input.val('').focus().trigger('change');
                }
            }, '.search-common input.reset');
            $(_this.el).on({
                submit: function(e){
                    e.preventDefault();

                    var _del = $(e.currentTarget).closest('form'),
                        $block = $(_del).find('.field-block'),
                        url = $(_del).attr('action'),
                        param = xssfilter($(_del).serialize());

                    $(_del).find('.search-layer').removeClass('active');

                    if($block.find('.search-common-input').val() != '') {
                        ajax.call(url, param, 'json', function(data){
                            if(data.results == true) {
                                // success
                                $block.addClass('pass').removeClass('error fail');
                                $block.find('.valid').show().siblings().hide();
                            }else {
                                // fail
                                $block.removeClass('pass error').addClass('fail');
                                $block.find('.invalid').show().siblings().hide();
                            }
                        });
                    }else {
                        $block.removeClass('pass fail').addClass('error');
                        $block.find('.required').show().siblings().hide();
                    }
                }
            }, '.search-common');

            /* 불필요
            // in-house review script
            $(_this.el).on({
                click: function(e){
                    e.preventDefault();
                    if($('.GPC0085').get(0)) {
                        if($('#writeReviewButton').attr('href') == '#') {
                            $('html, body').animate({
                                scrollTop: $('.GPC0085').offset().top
                            }, 500);
                        }
                        $('#writeReviewButton').trigger('click');
                    }
                    
                }
            }, '.write-a-review');
            */

            // LGESA-28 start
            // warranty    
            $(_this.el).on({
                click: function(e){
                    e.preventDefault();
                    $('.warranty-area a.active .notice_price').html('<span class="unit">'+$('.warranty-area a.active').data('option-currency')+'</span>&nbsp;<span class="number">'+$('.warranty-area a.active').data('option-price')+'</span>');
                    $('.warranty-area a.active').removeClass('active');
                    
                    $(this).addClass('active');
                    $('.warranty-area a.active .notice_price').html($(this).data('option-include'));
                    $('.button a.add-to-cart').data('model-id', $(this).data('model-id'));
                    
                    $('.purchase-price .price .number').html(changeFormatPrice(Number($(this).data('option-orgprice'))+Number($(this).data('option-price'))));
                }
            }, '.warranty-area a.year');
            // LGESA-28 end
            /* PJTSUMMARY-4_krchoi START */
            $(_this.el).on({
                click: function(e){
                    e.preventDefault();
                    $(this).toggleClass("act");
                    if($(this).hasClass("act")){
                    	$(this).parents(".feature-area").find(".feature-list").addClass("on");
                    } else{
                        $(this).parents(".feature-area").find(".feature-list").removeClass("on");
                    }
                }
            }, '#btn-features');
            /* PJTSUMMARY-4_krchoi END */
        }
    };

    summary.init();
    
    modal.init();
    summaryGallery.init();

    // for submodel
    var submodel = $('.GPC0009').data('default-model');
    if(submodel) {
        $('a[data-sub-model-id="'+submodel+'"]').eq(0).trigger('click');
    }

    // Country
    var countrybox = (function () {
        // Open, Mouse over / Focus
        var open = function ( $container ){
            $(document).on('mouseenter focus', $container, function(e) {
                $(this).siblings('.flag-box')
                .show()
                .attr('aria-hidden', false);
            });
        };
        // Close : Click
        var close = function ( $container ){
            $(document).on('click', $container, function(e) {
                $(this).parent()
                .hide()
                .attr('aria-hidden', true);
            });
        };

        return { open : open, close : close };
    }());

    tinyLayer.initModule('.flag-icon .flag-item');
    countrybox.open('.available-contries.overcount > a');
    countrybox.close('.flag-box > .close-box');


    // find my model
    var mainselect = document.getElementById('mainCategorySelect_fmm');
    var subselect = document.getElementById('subCategorySelect_fmm');
    var modal2 = {
        el: document.getElementById("modal_find_my_model"),
        form: document.getElementById("findMyModelForm"),
        submit: document.getElementById("findMyModelSubmit"),
        init: function(){
            modal2.addEvent();
        },
        addEvent: function(){
            $(modal2.el).on({
                'show.bs.modal': function(e){
                    adobeTrackEvent('find_my_model', {page_event : {find_my_model : true}});
                    $(mainselect).drawAjaxOptions({
                        setTarget: subselect
                    });
                }
            });
            $(modal2.form).on({
                submit: function(e){
                    e.preventDefault();

                    var param = $(this).serializeArray();
                    var url = this.getAttribute('data-url');
                    // var data = ajax.call(url, param, 'html');
                    ajax.call(url, param, 'html', function(data){
                        $(modal2.el).find('.find-model-results').addClass('active').html(data).find('style').remove();
                        $(modal2.el).find('.find-model-default').removeClass('active');
                        $(modal2.el).modalUpdate();
                    });
                }
            });
            $(mainselect).on({
                'change.base': function(){
                    $(modal2.el).find('.find-model-results').removeClass('active');
                    $(modal2.el).find('.find-model-default').addClass('active');
                }
            });
            $(subselect).on({
                'change.sub': function(){
                    $(modal2.form).submit();
                }
            });
        }
    };
    modal2.init();

    $('body').on('click.seemore', '.search-area .search-layer .search-footer-area a.link-more', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var searchTxt = $(this).closest('form').find('.search-input input').val();
        $form = $("<form />", {id: 'tmpForm', action:url, method: 'post'});
        $form.append('<input type="hidden" name="search" value="'+xssfilter(searchTxt)+'">');
        $('body').append($form);
        $("#tmpForm").submit();
    });

    // BV
    /* LGCOMSPEED-6 Start */
    if($('#BVRRSummaryContainer').length>0 || $('#BVRRContainer').length>0) {
        var run = function() {
            console.log('run $BV');
            var d = document,
            s = d.createElement('script'),
            b = d.body || d.getElementsByTagName("body")[0],
            as = {
                "src": '/lg5-common-gp/js/components/pdp-bv-static.min.js'
            };
            for (var i in as) {
                s.setAttribute(i, as[i]);
            }
            b.appendChild(s);
        };
        var check = function() {
            setTimeout(function() {
                if(typeof $BV == 'object') {
                    run();
                } else {
                    check();
                }
            }, 300);
        };
        if(typeof $BV == 'object') {
            run();
        } else {
            check();
        }
    }
    /* LGCOMSPEED-6 End */

    //LGEGMC-177 
    //file download
    var fileDownload = function($link) {
        if($('form#formDown').length>0) $('form#formDown').remove();

        var fileBox = $link.closest('[data-file-download]');
        var flag = fileBox.data('flag').toUpperCase();
        var downtime = fileBox.data('downtime') || null;
        var opentime = fileBox.data('opentime') || null;

        if(flag=='Y') {
            // downtime error
            var $errorPop = $('#htmlOpenError');
            if($errorPop.length>0) {
                $errorPop.modal();
                $errorPop.find('.htmldowntime').text(downtime);
                $errorPop.find('.htmlopentime').text(opentime);
            } else {
                console.log('#htmlOpenError is required in HTML');
            }
        } else {

            var doc = $link.data('doc'),
                file = $link.data('file'),
                original = $link.data('original'),
                category = $link.data('category');

            var input = '<input type="hidden" id="DOC_ID" name="DOC_ID" value="' + doc +'" />';
            input += '<input type="hidden" id="ORIGINAL_NAME_b1_a1" name="ORIGINAL_NAME_b1_a1" value="' + original +'" />';
            input += '<input type="hidden" id="FILE_NAME" name="FILE_NAME" value="' + file +'" />';
            input += '<input type="hidden" id="TC" name="TC" value="DwnCmd" />';
            input += '<input type="hidden" id="GSRI_DOC" name="GSRI_DOC" value="GSRI" />'
            input += '<input type="hidden" id="SPEC_DOWNLOAD" name="SPEC_DOWNLOAD" value="N" />';
            
            /*LGEGMC-1035 start*/
            var openlocale="|AR|AT|BE_FR|BG|CH_DE|CH_FR|CZ|DE|DK|EE|ES|FI|FR|GR|HR|HU|IT|LT|LV|NL|NO|PL|PT|RO|RS|SE|SK|UK|";
            var _target="_self";
            if((original.toLowerCase().indexOf('.pdf')>-1 || original.toLowerCase().indexOf('.bmp')>-1 || original.toLowerCase().indexOf('.jpg')>-1 || original.toLowerCase().indexOf('.jpeg')>-1||original.toLowerCase().indexOf('.png')>-1) && openlocale.indexOf("|"+COUNTRY_CODE.toUpperCase()+"|")>-1){
                _target="_blank";
            }
            
            var form = $('<form />').attr({
                id: 'formDown',
                method: 'get',
                action: fileBox.data('action'),
                target: _target
            }).append(input);
            $('body').append(form);
            /*LGEGMC-1035 end*/

            $('#formDown').submit();
        }
    }
    $obj.find('.file-list a.link-text').on('click', function(e) {
        e.preventDefault();
        fileDownload($(this));
    });
    //LGEGMC-712
    function nvl(str, defaultStr){
        var check = str+"";
        var result = "";
        check = check.trim()
        if(check=="" || check==null || check == "null" || check=="undefined"){
            result = defaultStr;
        }else{
            result = check;
        }
        return result ;
    }

    /* LGEBE-4 : 20200605 add */
    var pdp_where = {
        wtbOfflineCategoryIds : document.querySelectorAll('input[name=wtbOfflineCategoryIds'),
        categoryId : document.querySelectorAll('input[name=categoryId'),        
        aTag : document.querySelectorAll('a[href="#pdp_where"]'),
        init : function(){
            var self = this;
            if($(self.wtbOfflineCategoryIds).val() != undefined && $(self.wtbOfflineCategoryIds).val() != '' && $(self.wtbOfflineCategoryIds).val() != 'component-WtbOfflineCategory'){
                var offline = $(self.wtbOfflineCategoryIds).val().split(',');
                var category = $(self.categoryId).val();
                for(var i=0; i< offline.length; i++){
                    if(category == offline[i]){
                        $(self.aTag).attr('href', '#pdpOfflieWhere');
                        break;
                    }
                }
            }
        }
        
    }
    pdp_where.init();
    /*// LGEBE-4 : 20200605 add */

    /* LGEGMC-849 : 20201030 add, LGEGMC-605 : 20201109 modify */
    // 신규 추가된 Vr View 기능 + 360 모바일 노출 동일 패턴 코드 머지
    $('.mobile-top-info').on('click', '.view-button-area > .view', function(e){
        e.preventDefault();
        var typeFilter = $(this).attr('data-modal-type');
        var $modalType = $('#modal' + typeFilter);
        if(!!$(this).data('iframe-url')){
            $modalType.find('.iframe-area').children().remove();
            $modalType.find('.iframe-area').attr('data-href', $(this).data('iframe-url')).attr('data-title', $(this).data('iframe-title'));
            $modalType.find('.btn-area a').attr('href', $(this).data('iframe-url'));    
        }
        $modalType.modal('show');
        
        setTimeout(function() {
            var _iframe = $modalType.find('.iframe-area')[0];
            if(_iframe){
                var i = $(_iframe).data(),
                    html;
                /* LGCOMSPEED-6 Start */
                if(i.type == '3603D'){
                    $('#modal3603D').removeClass('invisible d-block');
                    if(!!!$(_iframe).html()){
                        html = modal.iframe.get360viewCode(_iframe);
                        $(_iframe).html(html);
                    }
                    $(_iframe).find('iframe').removeClass('d-none');
                }else{
                    html = modal.iframe.get360viewCode(_iframe);
                    $(_iframe).html(html);
                }
                /* LGCOMSPEED-6 End */
            }
        }, 500);
        
    });
    /*LGEGMC-1632*/
    $('.mobile-top-info').on('click', '.view-button-area > .viewObj', function(e){
        e.preventDefault();
        $(this).toggleClass('act');
        if($(this).hasClass('act')){
            $(".pdp-visual-m").addClass("objet-kang")
        } else{
            $(".pdp-visual-m").removeClass("objet-kang");
            $("#mobile_summary_gallery .pdp-carousel").slick('unslick');
            summaryGallery.m.init(); 
        }
    });
    /* // objet si */
    /*LGEGMC-1632*/ 
    $('#modalVr, #modal360, #modalAr').on('click', '.modal-close', function(e){ /* LGCOMSPEED-6 */
        $(this).closest('.modal-pdp-gallery').find('.iframe-area').children().remove();
    });
    /*// LGEGMC-605 : 20201109 modify */

    /* LGCOMSPEED-6 */
    $('#modal3603D').on('click', '.modal-close', function(e){
        var _thisIframe3D = $('#modal3603D').find('.iframe-area[data-type=3603D]')[0];
        if(_thisIframe3D) {
            if (availableGPU) {
                $(_thisIframe3D).find('iframe').addClass('d-none');
            } else {
                $(_thisIframe3D).find('iframe').remove();
            }
        }
    });
    /* // LGCOMSPEED-6 */

    $('.desktop-info').on({
        click: function(e){
            if(modal.ready == true) {
                modal.showDetailModal($('.desktop-info .view-button-area a').index(this));
                $(modal.el.gallery).data('beforeFocus', e.currentTarget);
            }
        }
    }, '.viewVrModalOpen');
    /*// LGEGMC-849 : 20201030 add */

    /*// LGEGMC-605 : 20201109 add */
    $('.desktop-info').on({
        click: function(e){
            if(modal.ready == true) {
                modal.showDetailModal($('.desktop-info .view-button-area a').index(this));
                $(modal.el.gallery).data('beforeFocus', e.currentTarget);
            }
        }
    }, '.view360ModalOpen');
    /*// LGEGMC-605 : 20201109 add */
    $('.desktop-info').on({
        click: function(e){
            if(modal.ready == true) {
                modal.showDetailModal($('.desktop-info .view-button-area a').index(this));
                $(modal.el.gallery).data('beforeFocus', e.currentTarget);
            }
        }
    }, '.viewArModalOpen');
    /*LGEGMC-1632*/
    $('.desktop-info').on({
        click: function(e){
            if(modal.ready == true) {
                modal.showDetailModal($('.desktop-info .view-button-area a').index(this));
                $(modal.el.gallery).data('beforeFocus', e.currentTarget);
            }
        }
    }, '.view3603DModalOpen');
    //PJTOBSB2E-5 SUNGIL
    function siteTimeInit(days) {
        
        var $elPreOrderArea = $('[data-pre-order-area]');
        
        if($elPreOrderArea.length == 0){
            return;
        }
        var remainDayText = '';
        var $elTargetTimer = $('[data-target-timer]'); 
        //var obsPreOrderValidDateFlag = $elPreOrderArea.data('obsPreOrderValidDateFlag');
        var siteTimeUrl = '/{locale}/mkt/ajax/product/siteTime'.replace('{locale}',COUNTRY_CODE);
        var $elPreOrderRemainday = $('[data-message-pre-order-remaindays]');
        var obsPreOrderRemaindaysText = $elPreOrderRemainday.attr('data-message-pre-order-remaindays');
        var obsPreOrderRemaindaysText1 = $elPreOrderRemainday.attr('data-message-pre-order-remaindays1');
        var obsPreOrderRemaindaysText0 = $elPreOrderRemainday.attr('data-message-pre-order-remaindays0');
        var endDt = $elPreOrderArea.data('obsPreOrderEndDate');
        var obsPreOrderInventoryFlag = $elPreOrderArea.data('obsPreOrderInventoryFlag');
        
        if(days == 0){
            remainDayText = obsPreOrderRemaindaysText0;
        }else if(days == 1){
            remainDayText = obsPreOrderRemaindaysText1.replace('{0}',days);
        }else if(days < 4){
            remainDayText = obsPreOrderRemaindaysText.replace('{0}',days);
        }
        
        $elPreOrderRemainday.text(remainDayText);
                
    };
    

    var fixPdp = {
        init : function(){      
            // in국가만 적용
            if($('html').attr('data-countrycode') == 'in'){ 
                $("#mobile_summary_gallery").contents().wrapAll('<div class="inner"></div>');
                $(window).on('load resize scroll', function(){
                    fixPdp.fixed();
                })
                console.log('in pdp fixed')
            }
        },
        fixed : function(){
            var delay = 0;
            var timer = null;
            var $winW = $(window).width();
            var $winH = $(window).height();
            var $winTop = $(window).scrollTop();
            var $conH = $(".pdp-summary-area").height();
            clearTimeout(timer);
            timer = setTimeout(function(){      
                if ( $winW > 991 && $winH + 600 < $conH) {
                    var $visualPc_pos = $("#desktop_summary_gallery").offset().top;
                    var $visualPc_width = $("#desktop_summary_gallery").width();
                    var $visualPc_h = $("#desktop_summary_gallery .pdp-visual").innerHeight();
                    var $visualPcDesk_h = $(".desktop-info").innerHeight();
                    var $visualPcDesk_pos = $(".desktop-info").offset().top;
                    if($winTop > $visualPc_pos == true && $winTop + $visualPc_h > $visualPcDesk_h + $visualPcDesk_pos !== true && $winTop + $visualPc_h < $visualPcDesk_h + $visualPcDesk_pos == true){
                        $("#desktop_summary_gallery .pdp-visual").addClass('fixPdp');
                        $("#desktop_summary_gallery .pdp-visual").css({
                            'width': $visualPc_width,
                            top : '0'
                        });
                        setTimeout(function() {
                            $("#desktop_summary_gallery .pdp-visual").addClass('not-ani');
                        }, 100);
                    } else if($winTop > $visualPc_pos == true && $winTop + $visualPc_h > $visualPcDesk_h + $visualPcDesk_pos == true && $winTop + $visualPc_h < $visualPcDesk_h + $visualPcDesk_pos !== true){
                        $("#desktop_summary_gallery .pdp-visual").removeClass('fixPdp');
                        $("#desktop_summary_gallery .pdp-visual").css({
                            position : 'absolute',
                            top : $visualPcDesk_h - $visualPc_h
                        })
                    } else if($winTop > $visualPc_pos !== true && $winTop + $visualPc_h > $visualPcDesk_h + $visualPcDesk_pos !== true && $winTop + $visualPc_h < $visualPcDesk_h + $visualPcDesk_pos == true){         
                        $("#desktop_summary_gallery .pdp-visual").removeClass('fixPdp');
                        $("#desktop_summary_gallery .pdp-visual").css({
                            position : 'static',
                            width : 'auto'
                        });
                        $("#desktop_summary_gallery .pdp-visual").removeClass('not-ani');
                    }
                } else{
                    if ($winW > 767 && $winH < $conH){      
                        var $m_visualPc_pos = $("#mobile_summary_gallery").offset().top;
                        var $m_visualPc_width = $("#mobile_summary_gallery").width();
                        var $m_visualPc_h = $("#mobile_summary_gallery .inner").innerHeight();
                        var $m_visualPcDesk_h = $(".desktop-info").innerHeight();
                        var $m_visualPcDesk_pos = $(".desktop-info").offset().top;
                        if($winTop > $m_visualPc_pos == true && $winTop + $m_visualPc_h > $m_visualPcDesk_h + $m_visualPcDesk_pos !== true && $winTop + $m_visualPc_h < $m_visualPcDesk_h + $m_visualPcDesk_pos == true){
                            $("#mobile_summary_gallery .inner").addClass('fixPdp');
                            $("#mobile_summary_gallery .inner").css({
                                width : $m_visualPc_width,
                                top : '0'
                            });
                            setTimeout(function() {
                                $("#mobile_summary_gallery .inner").addClass('not-ani');
                            }, 100);
                        } else if($winTop > $m_visualPc_pos == true && $winTop + $m_visualPc_h > $m_visualPcDesk_h + $m_visualPcDesk_pos == true && $winTop + $m_visualPc_h < $m_visualPcDesk_h + $m_visualPcDesk_pos !== true){
                            $("#mobile_summary_gallery .inner").removeClass('fixPdp');
                            $("#mobile_summary_gallery .inner").css({
                                position : 'absolute',
                                top : $m_visualPcDesk_h - $m_visualPc_h - 35
                            })
                        } else if($winTop > $m_visualPc_pos !== true && $winTop + $m_visualPc_h > $m_visualPcDesk_h + $m_visualPcDesk_pos !== true && $winTop + $m_visualPc_h < $m_visualPcDesk_h + $m_visualPcDesk_pos == true){
                            $("#mobile_summary_gallery .inner").removeClass('fixPdp');
                            $("#mobile_summary_gallery .inner").css({
                                position : 'static',
                                width : 'auto'
                            })
                            $("#mobile_summary_gallery .inner").removeClass('not-ani');
                        }               
                    }
                }
            }, delay);
        }
    }
    fixPdp.init();
    
    /* LGEPL-489 Start */
    $obj.on('mouseover', '.member-price a', function() {
        $(this).find('span').addClass("member-link");
    });
    $obj.on('mouseleave', '.member-price a', function() {
        $(this).find('span').removeClass("member-link");
    });
    /* LGEPL-489 End */

    /* PJTEXTENDEDWTY-5-3nd */
    $('.GPC0009').on('click', 'li.care-select > a', function(e) {
        e.preventDefault();
        /* LGEMS-491 start */
        var currencySymbol   = $(this).data('currency-symbol');
        var currencyPosition = $(this).data('currency-position');
        /* LGEMS-491 end */
        if(info.price==null){
            info.price = $('.GPC0009 .pdp-info').find(".purchase-price .number").first().text();
        }
        if(info.productPrice==null){
            if($('.GPC0009 .pdp-info').find(".product-price .number").length > 0){
                info.productPrice = $('.GPC0009 .pdp-info').find(".product-price .number").first().text();
            }
        }
        if(info.memberPrice==null){
            if($('.GPC0009 .pdp-info').find(".member-price span").length > 0){
                info.memberPrice = $('.GPC0009 .pdp-info').find(".member-price span").first().text();
            }
        }
        if($(this).hasClass('act')){
            $(this).removeClass('act');
            //$('.GPC0009 .pdp-info').find(".purchase-price .number").text(info.price);				//	LGEMS-491 annotated
            /* LGEMS-491 start */
            if(currencyPosition=='L'){
            	$('.price-total-box.act .total-price-num strong').text(currencySymbol + info.price);
            } else {
            	$('.price-total-box.act .total-price-num strong').text(info.price + currencySymbol);
            }
            $('.GPC0009.improve').find(".warranty-price").hide();
            $('.GPC0009 .pdp-info').find(".warranty-price").hide();
            $('.GPC0009 .pdp-info').find(".warranty-price .price-d").text(); 
            /* LGEMS-491 end */
            if(info.productPrice != null){
                $('.GPC0009 .pdp-info').find(".product-price .number").text(info.productPrice);
            }
            if(info.memberPrice != null){
                $('.GPC0009 .pdp-info').find(".member-price span").text(info.memberPrice);
            }
        } else{
        	if(!$('.price-pdp-area').hasClass('d-none')){							//	LGEMS-491 add
	            $("li.care-select > a").attr('aria-selected', false).removeClass('act');
	            $(this).attr('aria-selected', true).addClass('act');
	            // 화면상 ew price 가져와서 국가별 가격 규칙으로 변환하고 product price 를 더해서 화면에 뿌려주길 원함.
	            var ewPrice = $(this).find('.care-pay .number').text()? $(this).find('.care-pay .number').text():0;
	            //$('.GPC0009 .pdp-info').find(".purchase-price .number").text(ewSumPrice($(this),ewPrice,info.price));	//	LGEMS-491 annotated
	            /* LGEMS-491 start */
	            if(currencyPosition=='L'){
	            	$('.GPC0009.improve').find(".warranty-price .price-d").text(currencySymbol + ewPrice);
	            	$('.GPC0009 .pdp-info').find(".warranty-price .price-d").text(currencySymbol + ewPrice);
	            	$('.price-total-box.act .total-price-num strong').text(currencySymbol + ewSumPrice($(this),ewPrice,info.price));
	            } else {
	            	$('.GPC0009.improve').find(".warranty-price .price-d").text(ewPrice + currencySymbol);
	            	$('.GPC0009 .pdp-info').find(".warranty-price .price-d").text(ewPrice + currencySymbol);
	            	$('.price-total-box.act .total-price-num strong').text(ewSumPrice($(this),ewPrice,info.price) + currencySymbol);
	            }
	            $('.GPC0009.improve').find(".warranty-price").show();
	            $('.GPC0009 .pdp-info').find(".warranty-price").show();
	            /* LGEMS-491 end */
	            if(info.productPrice != null){
	                $('.GPC0009 .pdp-info').find(".product-price .number").text(ewSumPrice($(this),ewPrice,info.productPrice));
	            }
	            if(info.memberPrice != null){
	            	//var currencySymbol = $(this).data('currency-symbol');			//	LGEMS-491 annotated
	                //var currencyPosition = $(this).data('currency-position');		//	LGEMS-491 annotated
	                var memberPrice = info.memberPrice.replace(currencySymbol,'');
	                var memberSumPrice = ewSumPrice($(this),ewPrice,memberPrice);
	                if(currencyPosition=='L'){
	                    memberSumPrice = currencySymbol+memberSumPrice;
	                }else{
	                    memberSumPrice = memberSumPrice+currencySymbol;
	                }
	                $('.GPC0009 .pdp-info').find(".member-price span").text(memberSumPrice);
	            }
	        }
        }
    });
    var ewSumPrice = function(el, ewPrice, price){
        var currencyDot = el.data('currency-dot');
        var sumPrice = '';
        var parseEwPrice = '';
        var digitCnt = 0;	// LGCOMMS-146 add
        if(ewPrice.indexOf(currencyDot)!= -1){
        	digitCnt = 2;	// LGCOMMS-146 add
            ewPriceArr = ewPrice.split(currencyDot);
            parseEwPrice = ewPriceArr[0].replace(' ','').replace('.','').replace(',','') +'.'+ ewPriceArr[1];
        }else{
            parseEwPrice = ewPrice.replace(' ','').replace('.','').replace(',','');		//	LGEMS-491 add replace
        }
        console.log('parseEwPrice:',parseEwPrice);
        
        var parseProductPrice = '';
        if(price.indexOf(currencyDot)!= -1){
        	digitCnt = 2;	// LGCOMMS-146 add
            productPriceArr = price.split(currencyDot);
            parseProductPrice = productPriceArr[0].replace(' ','').replace('.','').replace(',','') +'.'+ productPriceArr[1];
        }else{
            parseProductPrice = price.replace(' ','').replace('.','').replace(',','');		//	LGEMS-491 add replace
        }
        console.log('parseProductPrice:',parseProductPrice);
        
        var sumPriceTxt = (parseFloat(parseProductPrice)+parseFloat(parseEwPrice)).toFixed(digitCnt).toString();	// LGCOMMS-146 add toFixed()
        if(sumPriceTxt.indexOf('.')>0){
            sumPrice = changeFormatFullPrice(sumPriceTxt.split(".")[0],sumPriceTxt.split(".")[1])
        }else{
            sumPrice = changeFormatFullPrice(sumPriceTxt,'00')
        }
        
        return sumPrice;
    }
    $('.GPC0009').on('click', 'button.btn-care', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).toggleClass('act');
        if($(this).hasClass('act')) {
            $(this).parent().find('.care-more').stop().slideDown(150);
            $(this).parent().find('.care-more').attr('aria-expanded', true);
        } else{
            $(this).parent().find('.care-more').stop().slideUp(150);
            $(this).parent().find('.care-more').attr('aria-expanded', false);
        }
    });
    /* PJTEXTENDEDWTY-5-3nd */
    var rePdslider = {
        recommendedPriceTemplate : null,
        notLazyCheckVip : $('.GPC0009').attr('data-is-vip'),
        init : function(){
            $('#recommendedPd').on('shown.bs.modal', function (e) {
                console.log('base slick stard')
                if (!!rePdslider.notLazyCheckVip && rePdslider.notLazyCheckVip == 'false') { //LGCOMSPEED-6(5th), LGEPL-697
                    rePdslider.getPriceSync();
                }
                rePdslider.popSlick();
            });
            $('#recommendedPd').on('hidden.bs.modal', function (e) {
                console.log('base slick end');
                rePdslider.unpopSilck();
            });
            $(window).on('resize', function(){
                rePdslider.resize();
            });
            this.recommendedPriceTemplate = $('#priceSyncRecommendedTemplate').clone().html();
            $('#priceSyncRecommendedTemplate').remove();
        },
        getPriceSync: function(){
            var recommendedPd = $('#recommendedPd');
            var modelIdArr = new Array();
            var bizTypeArr = new Array();
            var modelStatusCodeArr = new Array();
            recommendedPd.find('input[name=recommendedModelId]').each(function(idx){
                modelIdArr[idx] = $(this).val();
                bizTypeArr[idx] = recommendedPd.find('input[name=recommendedBizType]').eq(idx).val();
                modelStatusCodeArr[idx] = recommendedPd.find('input[name=recommendedModelStatusCode]').eq(idx).val();
            });
            
            var _this = this,
                url = $('.GPC0009').find('.pdp-summary-area').data('recom-price-sync-url'),
                param = {
                    modelId: modelIdArr.join(),
                    bizType: bizTypeArr[0],
                    modelStatusCode: modelStatusCodeArr[0]
                };

            ajax.noCacheCall(url, param, 'json', function(data){
                if(data.status == 'success' && data.data){
                    for(var i=0; i<data.data[0].recommendedProducts.length; i++){
                        var p = data.data[0].recommendedProducts[i],
                            priceSyncRecommendedHtml = _this.recommendedPriceTemplate;
                        p.obsInstallmentPriceDisableLink = data.data[0].obsInstallmentPriceDisableLink;	// LGETW-651 add
                        
                        if (priceSyncRecommendedHtml) {
                            $template = _this.makePriceSyncHtml(p, priceSyncRecommendedHtml);
                            var scop = $('.recommendedModelList[data-recommended-model-id='+p.recommendedModelId+']').find('.products-info');
                            scop.find('.price-vip-Installment, .dx-price-area, .member-text').remove(); // LGCOMMON-54
                            scop.find('.pd-model').after($template);
                        }
                    }
                }
            });
        },
        makePriceSyncHtml : function(p, template){
            if (template) {
                //replace
                var emiMsgFlag = p.recommendedObsEmiMsgFlag;
                var afterPay = p.recommendedAfterPay;
                
                template = template.replace(/\*recommendedModelId\*/g, p.recommendedModelId)
                .replace(/\*recommendedMembershipPrice\*/g, !!p.recommendedMembershipPriceCent ? changeFormatFullPriceSync(p.recommendedMembershipPrice, p.recommendedMembershipPriceCent) : (!!p.recommendedMembershipPrice ? changeFormatPriceSync(p.recommendedMembershipPrice) : ''))
                .replace(/\*recommendedSalesModelCode\*/g, !!p.recommendedSalesSuffixCode ? p.recommendedSalesModelCode+'.'+p.recommendedSalesSuffixCode : p.recommendedSalesModelCode)
                .replace(/\*recommendedEmiMsg\*/g, p.recommendedEmiMsg)
                .replace(/\*display\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 3000) ? '' : 'style="display:none;"')
                .replace(/\*zipdisplay\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 10000) ? '' : 'style="display:none;"') /* OBSLGEAU-749 (5000 -> 10000) */
                .replace(/\*orZipPay\*/g, emiMsgFlag == 'Y' && (afterPay > 0 && afterPay <= 3000) ? 'or ' : '');
            
                //jquery set
                var $html = $(template);
                
                //rPrice, rPromoPrice
                var recommendedRPrice = '';
                var recommendedRPromoPrice = '';

                if (!!p.recommendedRPromoPriceCent) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPromoPrice, p.recommendedRPromoPriceCent);
                    recommendedRPromoPrice = changeFormatFullPriceSync(p.recommendedRPrice, p.recommendedRPriceCent);
                } else if (!!p.recommendedRPromoPrice) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPromoPrice);
                    recommendedRPromoPrice = changeFormatFullPriceSync(p.recommendedRPrice);
                } else if (!!p.recommendedRPriceCent) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPrice, p.recommendedRPriceCent);
                } else if (!!p.recommendedRPrice) {
                    recommendedRPrice = changeFormatFullPriceSync(p.recommendedRPrice);
                }
                
                $html.find('.purchase-price .number').text(recommendedRPrice);
                $html.find('.product-price .number').text(recommendedRPromoPrice);
                $html.find('.dx-price-area .legal').text(p.recommendedDiscountMsg);
                
                //type
                if(p.recommendedRetailerPricingFlag1 == 'Y'){
                    $html.find('.dx-price-area').addClass('type-text');
                }else if(!!p.recommendedRPromoPrice){
                    $html.find('.dx-price-area').addClass('type-promotion');
                }else if(p.recommendedBizType == 'B2B' && $html.data('obs-login-flag') != 'Y' && !!p.recommendedRPrice){
                    $html.find('.dx-price-area').addClass('type-msrp');
                }else if(!!p.recommendedRPrice){
                    $html.find('.dx-price-area').addClass('type-default');
                }else{
                    $html.find('.dx-price-area').addClass('type-none');
                }
                
                //membership
                if(p.recommendedMembershipDisplayFlag != 'Y'){
                    $html.find('.member-text').remove();
                }
                
                //price-vip
                if(p.recommendedLimitSaleUseFlag == 'Y' && p.recommendedObsLimitSale == 'Y'){
                    $html.find('.price-vip-Installment .price-vip').text($html.find('.price-vip-Installment .price-vip').data('limit-sale-title'));
                }
                
                if(!!!p.recommendedEmiMsg){
                    $html.find('.price-installment').remove();
                }
                
                /* LGETW-651 start */
				if(!!p.obsInstallmentPriceDisableLink && p.obsInstallmentPriceDisableLink == 'Y'){
					$html.find('.price-installment').addClass('no-link').attr('tabindex','-1');
				}
				/* LGETW-651 end */
                
                return $html.html();
            }
        },
        popSlick : function(){
            $('.re-pd-slider ul.slider').slick({
                listStyle: false, 
                autoplay: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                accessibility: false,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },{
                        breakpoint: 640,
                        settings: "unslick"
                    }
                ]
            });
            console.log('base slick load')
        },
        unpopSilck : function(){
            if($('.re-pd-slider ul.slider').hasClass('slick-initialized') == true){
                var $slick = $('.re-pd-slider ul.slider').slick('unslick');
            } else{
                return false
            }
        },
        resize : function(){
            var delay = 500;
            var timer = null;
            var $winW = $(window).width(); 
            clearTimeout(timer);
            timer = setTimeout(function(){              
                if ( $winW >= 640 && $("#recommendedPd").hasClass('show')) {
                    if($('.re-pd-slider ul.slider').hasClass('slick-initialized') !== true){
                        rePdslider.popSlick();
                    }
                } else{
                    console.log("unsilck")
                    rePdslider.unpopSilck();
                }
            }, delay);
        }
    }
    rePdslider.init();
    var sampleObj = {   
    };
    var select_parts = 1;
    var selected_texture = '';
    var selected_panel_style= {};   
    //PJTOBJET-5-3 ADD
    //clickedSaveBtn : Panel 선택 팝업 닫을 시 저장 후 닫는지 저장 없이 닫는지 구분하는 Flag
    var clickedSaveBtn = false;
    var objetUi = {
        load : function(){
            objetUi.select_Obj();
            objetUi.select_Color();
            objetUi.select_Texture();
            objetUi.select_Banner();
            objetUi.save_Obj();
            objetUi.resize_scroll();
            /** 20220608 한성희 */
            objetUi.data_init();
            /** 재질 변경, 선택정보 초기화 */
            objetUi.change_material();
            /** 팝업 진입 버튼 판별 위해(본품 포함인지, 패널만인지); 
              * 배너이외 버튼을 통해서도 팝업 에 유입되어 구매 타입의 구분이 필요하여 추가함*/
            objetUi.popup_open_type_save();
            /** 구매타입 변경 ( 1. 본품포함구매,2. 패널만 구매) */
            objetUi.change_product_add_type();      
        },
        select_Banner : function(){
            $('#modal-pdp-objet').on('show.bs.modal', function (e) {
                var button = $(e.relatedTarget) // 배너 버튼
                var recipient = button.data('whatever') // 배너 유형 가져오기 full && 단품
                var modal = $(this)
                setTimeout(function(){
                    $('#objPartBody li a.select').focus();
                },300);         
            })
        },
        select_Texture : function(){            
            //재질 선택
            var target_custom = $(".pdp-parts-step").find("button");
            $(target_custom).on('click', function(e){
                e.preventDefault();
                var _this = $(this);
                target_custom.removeClass("act").attr('aria-checked', false);
                _this.addClass("act").attr('aria-checked', true);
                
                $(".pdp-parts-choice").removeClass("active");
                $(".pdp-objet-inner").addClass("active");
                /** 20220608 한성희 */
                objetUi.material_init();
                /** 20220610 한성희 세이브 버튼 노출 처리 */
                objetUi.save_btn_visibility();
                /** 20220613 한성희 컬러버튼 노출 처리 */
                var objPartColor = $('.select').parent().attr('default-color');
                objetUi.color_btn_area_init(objPartColor);          
            })
        },
        select_Obj : function(){
            var target_el = $(".obj-part-body");
            $(target_el).find(".obj-part > a").on('focus', function(e){
                var _this = $(this);
                var _thisColor = _this.attr("data-color");
                /** 20220613 한성희 컬러버튼 이름 중복 가능성 있음. 패널 모델 아이디 조건 추가  */
                var _thisId = _this.attr("data-panel-model-id");
                var _thispart = _this.attr("data-part")
                var _defaultColor = $(this).parent().attr('default-color');
                console.log("foucs" , _thisColor)
                if(_this.hasClass("check")){
                    $(".obj-choice-color").find("li button").removeClass('act')
                    $(".obj-choice-color").find('li button[data-obj-color="'+ _thisColor +'"][data-panel-model-id="'+_thisId+'"][data-panel-name="'+ _thispart +'"]').addClass("act");              
                } else{
                    $(".obj-choice-color").find("li button").removeClass('act')
                }
                /** 20220613 한성희 패널 위치에 따른 버튼 처리(패널 위치마다 패널 컬러를 각자 다르게 등록할 수 있다고 함.) */
                objetUi.color_btn_area_init(_defaultColor);
            });
            $(target_el).find(".obj-part > a").on('click', function(e){
                e.preventDefault();
                var _this = $(this);
                select_parts = _this.attr('data-part');
                $(target_el).find(".obj-part > a").removeClass("select");
                _this.addClass("select");
                $(".obj-choice-color li:eq(0) button").focus();
                /** 20220613 한성희 패널 위치에 따른 버튼 처리 */
                var _defaultColor = $(this).parent().attr('default-color');
                objetUi.color_btn_area_init(_defaultColor);
            });
        },
        select_Color : function(){
            var target_el = $(".objet-palette")     
            $(target_el).find(".obj-choice-color li > button").on('click', function(e){
                e.preventDefault();
                var _this = $(this);
                var texture_this = $(".parts-btn-inner").find("button.act").attr("data-texture")
                var color_this = _this.attr('data-obj-color');
                var id_this = _this.attr('data-panel-model-id');

                var filterItem = sampleObj['part' + select_parts].filter(function (part) {
                    /*return part.dataTexture === Number(texture_this) && part.color === color_this;*/
                    /**20220609 한성희 수정  */
                    return part.dataTexture == texture_this && part.color === color_this && part.id == id_this;
                });
                // loading ajax show
                //$(".objet-position .select-obj").trigger('ajaxLoadBefore');
                if(_this.hasClass('act')){
                    _this.removeClass('act');
                    if(filterItem.length > 0){
                        $(".objet-position .select-obj").find('#'+'part'+select_parts).remove();
                        $('.obj-part > a[data-part="'+ select_parts +'"]').removeClass("check");
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-color' : ''
                        }); 
                        /**20220613 한성희 패널 모델 아이디도 초기화  */
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-panel-model-id':''
                        });
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-sales-model-code':''
                        });
                        $(".obj-part > a.select").focus();
                    }
                } else{
                    target_el.find(".obj-choice-color li > button").removeClass('act');
                    _this.addClass('act');      
                    if(filterItem.length > 0){
                        if($(".objet-position .select-obj").find('#'+'part'+select_parts).length > 0){
                            //part 있을때 교채
                            $(".objet-position .select-obj").find('#'+'part'+select_parts).attr({
                                'src' : filterItem[0].img ,
                                'data-texture' : filterItem[0].dataTexture,
                                'data-color' : filterItem[0].color,
                                /** 20220610 한성희 선택 파트 저장위해 추가 */
                                'data-part': select_parts,
                                'data-price' : filterItem[0].price,
                                'data-sales-model-code': filterItem[0].salesModelCode,
                                'data-panel-model-id': filterItem[0].id
                            });
                        } else{
                            //part 없을때 추가
                            $(".objet-position .select-obj").append('<img id='+ 'part' + select_parts +' src='+ filterItem[0].img +' data-texture='+ filterItem[0].dataTexture +' data-color='+ filterItem[0].color +' data-part='+ select_parts +' data-price='+ filterItem[0].price + ' data-panel-model-id=' + filterItem[0].id +' data-sales-model-code=' + filterItem[0].salesModelCode +' />');
                        }
                        $('.obj-part > a[data-part="'+ select_parts +'"]').addClass("check");
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-color' : filterItem[0].color
                        });
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-panel-model-id' : filterItem[0].id
                        });
                        $('.obj-part > a[data-part="'+ select_parts +'"]').attr({
                            'data-sales-model-code' : filterItem[0].salesModelCode
                        });

                        $('.obj-part > a[data-part='+ select_parts +']').focus();
                    }
                }
                // loading ajax hide
                //$(".objet-position .select-obj").trigger('ajaxLoadEnd');
                /**20220609 한성희 저장버튼 활성화 여부 판단  */
                objetUi.save_btn_visibility();
            })
        },
        save_Obj : function(){
            var saveObj = $(".btn-saveObj");        
            $(saveObj).on('click', function(e){
                var texture_this = $(".parts-btn-inner").find("button.act").attr("data-texture");
                var model_material_id = $('.pdp-objet-inner').attr('data-material-id');
                var productPopup = $(".pdp-parts-choice").hasClass('product');
                if(null!=model_material_id && model_material_id!=texture_this&& productPopup==true){
                    if($('.obj-part-body .obj-part a').not('.disable').not('.check').length != 0){
                        $("#model-obj-other-material").css('z-index', '25002');
                        $("#model-obj-other-material").modal('show');
                        return;
                    }
                }
                e.preventDefault();
                /**20220609 한성희 저장버튼 클릭 후 데이터 처리과정 */
                objetUi.save_data();
                /** //20220609 */
                var $objBody = $(".objet-position").find(".select-obj").clone(true, true);
                $("#objetPdp .select-objClone").children().remove();
                $objBody.appendTo('.select-objClone'); //pdp에 복사
                //PJTOBJET-5-3 ADD
                //저장 후에 닫기 때문에 Flag를 true
                clickedSaveBtn = true;
                $("#modal-pdp-objet").modal('hide');
                /**20220609 한성희 저장버튼 클릭 후 화면 처리과정 */
                //objetUi.after_popup_close_ui();
            })
        },
        resize_scroll : function(){     
            var ks_scr = $(".kang-scroll");
            $(window).on('load resize orientationchange', function() {
                var winW = $(window).width();
                var delay = 500;
                var timer = null;
                setTimeout(function() {
                    clearTimeout(timer);
                    $(".kang-scroll").each(function(){
                        if (winW > 992) {
                            $(this).mCustomScrollbar("destroy");
                            $(this).mCustomScrollbar({
                                axis:"y"
                            });
                        } else {
                            $(this).mCustomScrollbar("destroy");
                            $(this).mCustomScrollbar({
                                axis:"x",
                                advanced:{autoExpandHorizontalScroll:true} 
                            });
                        }
                    });
                }, delay);
                
                var winW = $(window).width();
                var bg_objet_pc = ($(".objet-img").attr("data-bg-pc"))?$(".objet-img").attr("data-bg-pc"):'';
                var bg_objet_mo = ($(".objet-img").attr("data-bg-mo"))?$(".objet-img").attr("data-bg-mo"):'';

                if(winW <= 480){
                    $(".objet-img").css("background-image", 'url('+bg_objet_mo+')')
                } else{
                    $(".objet-img").css("background-image", 'url('+bg_objet_pc+')')
                }
            });
        },
        /** 20220608 한성희 재질 선택 후 화면 초기화*/
        material_init: function(){
            var texture_this = $(".parts-btn-inner").find("button.act").attr("data-texture")
            selected_texture = texture_this;
            $(".texture-box").hide();
            $(".cont"+selected_texture).show();
            if($(".obj-part a").hasClass("select")){
                select_parts = $(".obj-part a.select").attr("data-part");
            }else{
                $('#objPartBody a').not('.disable').eq(0).addClass('select');
                select_parts = $(".obj-part a.select").attr("data-part");
            }   
        },
        /** 20220608 한성희 재질 + 컬러 데이터 셋팅 *마크업 sampleObj 하드코딩 대체*/
        data_init :function(){
            sampleObj = {}
           $("#colorList li").each(function () {
                var data_el = $(this).find('button');
                var texture_name = $(data_el).attr('data-texture');
                var part_name = $(data_el).attr('data-panel-name');
                var image_url = $(data_el).attr('data-image');
                var color = $(data_el).attr('data-obj-color');
                var price = $(data_el).attr('data-price');
                var panel_model_id = $(data_el).attr('data-panel-model-id');
                var sales_model_code = $(data_el).attr('data-sales-model-code');
                if(!sampleObj['part'+part_name]){
                    sampleObj['part'+part_name] = [];
                }               
                var obj ={}
                obj['img'] = image_url;
                obj['color'] = color;
                obj['dataTexture'] = texture_name;
                obj['price'] = price;
                obj['id'] = panel_model_id;
                obj['salesModelCode'] = sales_model_code;
                sampleObj['part'+part_name].push(obj)
            });
            objetUi.panel_init();
        },
        /** 20220608 한성희 재질&컬러칩 데이터 없을때 해당 패널 선택 버튼 disable*/
        panel_init : function(){
            $("#objPartBody li").each(function (index, item) {
                var length = $("#objPartBody li").length;
                var data_el = $(this).find('a');
                var part_name = $(data_el).attr('data-part');
                if(!sampleObj['part'+part_name]){
                    $(data_el).addClass('disable')
                }
                if(index == length -1){
                    $('#objPartBody a').not('.disable').eq(0).addClass('select');
                }
            }); 
        },
        /** 20220613 한성희 /패널타입이 재질 & 컬러 수만큼 별도 모델 아이디로 생성 된다. */
        color_btn_area_init: function(paenlDefaultColorId){ 
            var texture_this = $(".parts-btn-inner").find("button.act").attr("data-texture")
            var select_panel = $("#objPartBody .obj-part a.select").attr('data-part');
            var defaultMaterial = document.querySelector('.pdp-objet-inner').getAttribute('data-material-id');
            //재질 & 패널 위치 가 동일한 컬러 버튼을 노출한다.
            var equalMaterialAndColor = false;
            var enableBtnLength = $("#colorList .btn"+ texture_this + ' [data-panel-name="'+select_panel+ '"]:enabled').length;
            $("#colorList li").each(function(index,item){
                var btn_panel_type =  $(this).find('button').attr('data-panel-name');
                var panelColorId =  $(this).find('button').attr('data-color-id');
                var panelMaterialId =  $(this).find('button').attr('data-texture');
                var disabledBtn = $(this).find('button').is(":disabled");
                if($(this).hasClass("btn"+texture_this) && btn_panel_type == select_panel){
                    if($(".pdp-parts-choice").hasClass('product')){
                        
                        if((defaultMaterial != panelMaterialId || paenlDefaultColorId != panelColorId) && disabledBtn == false){
                            $(this).show();
                        } 
                        else {
                            if(!disabledBtn && (defaultMaterial == panelMaterialId && paenlDefaultColorId == panelColorId)){ //버튼비활성화
                                equalMaterialAndColor = true;
                                //$(this).find('button').attr('disabled', true);
                                $(this).hide();
                            } else if((defaultMaterial != panelMaterialId || paenlDefaultColorId != panelColorId) && disabledBtn == true){
                                if(equalMaterialAndColor == false && enableBtnLength > 0){
                                    $(this).show();
                                } else {
                                    $(this).hide();
                                }
                            } else  {
                                $(this).hide();
                            }
                            
                        }
                    } else {
                        $(this).show();
                    }
                } else {
                    $(this).hide();
                }
            });

            var btnlength = $("#colorList .btn"+ texture_this + ' [data-panel-name="'+select_panel+ '"]:enabled').length;
            //선택한 재질&패널에 해당하는 컬러버튼이 없을경우, 선택할 수 있는 컬러 버튼이 없음을 알려주는 문구 노출
            if(btnlength < 1){ //활성버튼 0
                $("#colorList li").css('display','none');
                $("#noneColor").show();
            } else{// 활성버튼 1이상
                if(equalMaterialAndColor ){
                    if(btnlength > 1){
                        $("#noneColor").hide();
                    }else {
                        $("#colorList li").css('display','none');
                        $("#noneColor").show();
                    }
                } else {
                    $("#noneColor").hide();
                }
            }
        },
        /**20220609 한성희 재질 변경 */
        change_material : function(){
            $("#changeMaterial").on('click', function(e){
            /** TODO 기획서 Type 3. Object Customizing 팝업 - 패널선택 
             *  CHANGE MATERIAL 버튼 클릭시 선택한 패널 정보를 초기화 하기 전
             *  토스트 팝업으로 초기화 됨 을 안내 한다고 되어있으며 4page 참고 로되어있음
             *  4page 에 해당하는 페이지에 해당 내용 없음
             *  20220610 해당 기획 내용 제외 하는것으로 결정 되었으나, 추후에 초기화 안내 팝업이 추가 될 경우를 위해 
             *  스크립트 위치 안내를 위한 히스토리를 남김
             *  */
                $(".pdp-parts-choice").addClass("active");
                $(".pdp-objet-inner").removeClass("active");
                $(".objet-pdp").removeClass('save');
                objetUi.reset();
            });
        },
        /** 20220609 한성희 선택 값 전체 리셋 */
        reset:function(){
            
            objetUi.panel_select_reset();
            objetUi.color_button_select_reset();
            objetUi.material_select_reset();        
        },
        /** 20220609 한성희 선택된 버튼 스타일 리셋 */
        color_button_select_reset: function(){
            $("#colorList").find('button').removeClass("act");
        },
        /** 20220609 한성희 선택된 패널 스타일 리셋 */
        panel_select_reset:function(){      
            $('.select-obj').children().remove();
            $('#objPartBody a').attr('data-color','')
            $('#objPartBody a').removeClass('select');
            $('#objPartBody a').removeClass('check');
            $('#objPartBody a').not('.disable').eq(0).addClass('select');
        },
        /** 20220609 한성희 선택된 재질 스타일 리셋 */
        material_select_reset:function(){
            var target_custom = $(".pdp-parts-step").find("button");
            target_custom.removeClass("act").attr('aria-checked', false);
        },
        /** 20220609 한성희 선택한 패널, 컬러 를 저장 상태로 변경 후 
         *  해당정보를 커스터 마이즈 패널 목록 에 노출 */
        save_data:function(){
            var saveDataLength =$('#pdpPopup .select-obj img').length; //선택한 패널 이미지 목록
            if(saveDataLength > 0){
                $(".objet-pdp").addClass('save');//세이브 여부 구분 클래스 추가
                $('.objet-select-part').hide();//패널 목록 전체 숨김
            }else{
                $(".objet-pdp").removeClass('save');
                return;
            }
            /**   !!************주의*********!! 
             *    서버에서는 소팅 시킨 데이터를 내려주고 있으며
             *    내려온 데이터 순으로 리스트를 그린다.
             *    패널 컬러를 선택하여 저장 할 경우 저장한 패널 정보를 엘리먼트에 적용 후(컬러값등)
             *    숨김 처리 상태인 패널 정보를 노출상태로 변경하며, 
             *    선택 하지 않은 패널을 비노출 처리한다. 
             *    이후 패널을 추가로 선택 후 저장 하거나 제거 작업을 무한으로 반복 하여도 소팅 작업이 필요 없다.
             *    퍼블 에서 엘리먼트를 리무브 시킬 것을 다시 유도 할 경우에 
             *    개발에선 엘리먼트를 추가,제거를 위한 스크립트의 추가 뿐아니라
             *    소팅 스크립트 또한 추가 되어야 하며, 패널의 제거&추가 액션마다 소팅 스크립트가
             *    호출 되어야 함을 인지 해야 한다.
             * */
            $('#pdpPopup .select-obj img').each(function () {
                var panel = $(this).attr('data-part');
                var materialId = $(this).attr('data-texture');
                var color = $(this).attr('data-color');
                var price = $(this).attr('data-price');
                var panel_id = $(this).attr('data-panel-model-id');
                var sales_model_code = $(this).attr('data-sales-model-code');
                
                $('.objet-selectPart-list #'+panel).attr('data-color', color);
                $('.objet-selectPart-list #'+panel).attr('data-texture', materialId);
                $('.objet-selectPart-list #'+panel).attr('data-panel-model-id',panel_id);
                $('.objet-selectPart-list #'+panel).attr('data-part',panel);
                $('.objet-selectPart-list #'+panel).attr('data-sales-model-code',sales_model_code);
                $('.objet-selectPart-list .'+ panel).show();//선택후 세이브한 패널 노출
                $('.objet-selectPart-list #'+panel).find('.part-color').html('')
                $('.objet-selectPart-list #'+panel).find('.part-color').append(color);
                $('.objet-selectPart-list #'+panel).find('.part-pay').html('')
                $('.objet-selectPart-list #'+panel).find('.part-pay').append(price);
            })
        },
        /** 20220609 한성희 저장버튼 노출 여부 판단 
         * ( 패널 만 구매할 경우엔 최소 1개의 패널 컬러가 적용 되었을 때 저장 버튼 노출, 본체 포함일 경우 저장 버튼 항상 노출) */
        save_btn_visibility:function(){
            var count = 0;
            var productPopup = $(".pdp-parts-choice").hasClass('product');
            if(productPopup){
                /** 본품포함 구매 일 경우 저장버튼 항상 활성화 */
                $(".btn-saveObj").show();
            }else{
                /** 패널만 구매할 경우 1개이상의 패널 스타일 적용시 저장 버튼 활성화 */
                $("#objPartBody a").each(function (index,item) {
                    var length = $("#objPartBody a").length;
                    var color = $(this).attr('data-color');
                    if(color){
                        ++count;
                    }
                    if(index == length -1){
                        if(count > 0){
                            $(".btn-saveObj").show();
                        }else{
                            $(".btn-saveObj").hide();
                        }
                    }
                })
            }   
        },
        /** 20220610 한성희 팝업 클로즈후 세이브 데이터 가 있을경우 선택 패널 정보 노출, 없으면 버튼 배너 영역 노출  */
        after_popup_close_ui:function(clickedSaveBtn){
            var saveData = $(".objet-pdp").hasClass('save');//세이브된 패널 정보 있는지 확인
            var thumb1 = $(".pdp-thumbnail-nav li.thumbnail").eq(0);//갤러리 썸네일 버튼 첫번째
            //PJTOBJET-5-3 START
            var isAddingModel = $('.pdp-parts-choice').hasClass('productAdd'); // 본품 함께 구매 버튼 클릭 했는지 flag
            var isPanelOnly = $('.pdp-parts-choice').hasClass('panelOnly'); // 패널만 구매 버튼 클릭 했는지 flag
            var isProduct = $('.pdp-parts-choice').hasClass('product'); // 본품 함께 구매 페이지인지 flag
            //PJTOBJET-5-3 END          
            if(saveData ){
                //1. 세이브된 패널 정보가 있을때
                $(".objet-choice-banner ").removeClass('active'); //커스텀 선택 버튼,배너 영역 숨김
                $(".objet-selectPart").removeClass('active').addClass('active');//선택 배너 목록 영역 노출
                var product = $(".pdp-parts-choice").hasClass('product');//상품 포함 패널 선택 인지 확인
                if(product){
                    //PJTOBJET-5-3 START
                    //저장을 했을 때만 버튼 노출 변경.
                    if(clickedSaveBtn){
                        $(".changePanelOnlyBtn").show();//패널만 커스텀 버튼 노출
                        $(".changeProductAddBtn").hide();//본품 포함하여 커스텀 버튼 비노출
                        $(".objet-selectPart .selectPart-tit").hide();//본품 제외 문구 비노출                        
                    }
                    //PJTOBJET-5-3 END
                }else{      
                    //PJTOBJET-5-3 START
                    //저장을 했을 때만 버튼 노출 변경.   
                    if(clickedSaveBtn){
                        $(".changeProductAddBtn").show()
                        $(".changePanelOnlyBtn").hide();
                        $(".objet-selectPart .selectPart-tit").show();              
                    }
                    //PJTOBJET-5-3 END
                }
                var objetThumb = $(".pdp-other-info ul li.view_objet");//오브제 썸네일 버튼
                $(".pdp-other-info li").removeClass('active');
                $(".pdp-visual-area .pdp-visual,.pdp-visual-area .pdp-visual-m").removeClass("objet-kang").addClass("objet-kang");
                $(objetThumb).show();//오브제 버튼 썸네일 노출
                $(objetThumb).addClass('active');
                $(objetThumb).trigger("click");//갤러리에 오브제 이미지 노출
                //PJTOBJET-5-3 START
                //저장 없이 팝업창을 닫을 시
                if(!clickedSaveBtn){
                    //.pdp-parts-choiced에 productAdd 클래스가 있는 경우 => 패널만 구매할 수 있는 페이지에서 "제품 + 패널" 함께 구매 버튼 클릭 시 
                    // 저장 없이 닫을 때 "제품 + 패널" 함께 구매를 취소한거기 때문에 product, productAdd 클래스를 둘 다 지워준다.
                    if(isAddingModel){
                        if(isProduct){
                            $('.pdp-parts-choice').removeClass('product');
                        }
                        $('.pdp-parts-choice').removeClass('productAdd');
                    }
                    //.pdp-parts-choiced에 panelOnly 클래스가 있는 경우 => "제품 + 패널" 함께 구매 페이지에서 패널만 구매 버튼 클릭 시 
                    // 저장 없이 닫을 때 패널만 구매를 취소한거기 때문에 panelOnly 클래스를 지워주고 product 클래스를 추가해준다.
                    if(isPanelOnly){
                        $('.pdp-parts-choice').removeClass('panelOnly');
                        $('.pdp-parts-choice').removeClass('product').addClass('product');
                    }   
                //저장을 눌러 팝업창을 닫을 시          
                }else{
                    //.pdp-parts-choiced에 productAdd 클래스가 있는 경우  저장을 했기 때문에 product 클래스는 놔두고 productAdd 클래스는 삭제
                    if(isAddingModel){
                        $('.pdp-parts-choice').removeClass('productAdd');
                    }   
                    //.pdp-parts-choiced에 panelOnly 클래스가 있는 경우 저장을 했기 때문에 panelOnly 클래스 삭제
                    if(isPanelOnly){
                        $('.pdp-parts-choice').removeClass('panelOnly');
                    }               
                }
                //PJTOBJET-5-3 END
            }else{
                //2. 세이브된 패널정보가 없을때
                objetUi.reset();//저장하지 않은 선택 정보 전체 리셋
                /**선택확인 스타일 항목들 제거 */
                $(".objet-selectPart").removeClass('active');
                $(".objet-choice-banner").removeClass('active').addClass('active');
                $(".objet-pdp").removeClass('save');
                $(".pdp-other-info ul li.view_objet").hide(); //오브제 썸네일 버튼 숨김
                $(".pdp-visual-area .pdp-visual,.pdp-visual-area .pdp-visual-m").removeClass("objet-kang");
                $(".pdp-other-info ul li.view_objet").removeClass('active');
                $(".objet-selectPart .selectPart-tit").hide();
                $(".objet-price .price-d").html("");
                $(".objet-price").addClass("d-none");
                
                $(thumb1).addClass('active');
                $(thumb1).trigger("click");
            }
        },
        /** 20220610 상품포함 인지, 패널만 선택했는지 구분위함*/
        popup_open_type_save:function(){
            $(".choiceProduct").on('click', function(e){
                $(".pdp-parts-choice").removeClass('product').addClass('product');
            });
            $(".choicePanelOnly").on('click', function(e){
                $(".pdp-parts-choice").removeClass('product')
            })
        },
        /** 20220614 세이브한 정보 대로 화면을 다시 초기화함.*/
        popup_reselect_saved:function(){
            $('.obj-choice-color li > button').removeClass('act');
            $('#objPartBody li a').removeClass('check');
            $("#pdpPopup .select-obj").children().remove();
            $('.objet-selectPart-list li').each(function(i,l){          
                var length = $('.objet-selectPart-list li').length
                if($(l).is(':visible')){
                    var el = $(l).find('.part-info')
                    var texture = el.attr('data-texture');
                    var select_parts = el.attr('data-part');
                    var modelID = el.attr('data-panel-model-id');
                    var color = el.attr('data-color');
                    var sales_model_code = el.attr('data-sales-model-code');
                    $('#objPartBody li a').removeClass('select')
                    $('#objPartBody li.'+select_parts+ " a").addClass('select')
                    $('#objPartBody li.'+select_parts+ " a").addClass("check");
                    $('#objPartBody li.'+select_parts+ " a").attr("data-color",color);
                    $('#objPartBody li.'+select_parts+ " a").attr("data-panel-model-id",modelID);
                    $('#objPartBody li.'+select_parts+ " a").attr("data-sales-model-code",sales_model_code);
                    var filterItem = sampleObj['part' + select_parts].filter(function (part) {
                        return part.dataTexture == texture && part.color === color && part.id == modelID;
                    }); 
                    $(".objet-position .select-obj").append('<img id='+ 'part' + select_parts 
                        +' src='+ filterItem[0].img
                        +' data-texture='+ filterItem[0].dataTexture 
                        +' data-color='+ filterItem[0].color 
                        +' data-part='+ select_parts 
                        +' data-price='+ filterItem[0].price 
                        +' data-sales-model-code='+ filterItem[0].salesModelCode 
                        +' data-panel-model-id=' + filterItem[0].id +' />');
                }
                if(i == length -1){
                    $('#objPartBody li a.select').trigger('click');
                }
            })
        },
        /** 20220615 한성희 구매 타입 변경 (1.본품 포함 구매, 2.패널만 구매) */
        change_product_add_type:function(){
            /**패널만 구매 버튼 클릭*/
            $(".changePanelOnlyBtn").on('click', function(e){
                //PJTOBJET-5-3 START
                //패널만 구매 버튼 클릭 시 productAdd 클래스는 삭제하고 panelOnly 클래스는 추가한다.
                $(".pdp-parts-choice").removeClass('productAdd');
                $(".pdp-parts-choice").removeClass('panelOnly').addClass('panelOnly');
                //PJTOBJET-5-3 END
                $(".pdp-parts-choice").removeClass('product');
                /** TODO 패널 가격만 보이도록 가격 정보 변경*/
                /**
                $(".changeProductAddBtn").show();//본품 포함 커스텀 버튼 노출
                $(".changePanelOnlyBtn").hide();//패널만 커스텀 버튼 숨감
                $(".objet-selectPart .selectPart-tit").show();//본품 제외 문구 노출
                objetUi.save_btn_visibility();  
                priceInfo.setPrice();
                **/
                /** TODO modal 창 오픈*/
                //PJTOBJET-5-3 ADD
                $('#modal-pdp-objet').modal('show');
            });
            /**본품 포함 구매 버튼 클릭*/
            $(".changeProductAddBtn").on('click', function(e){
                //PJTOBJET-5-3 START
                //본품 포함 구매 버튼 클릭 시 productAdd 클래스는 추가하고 panelOnly 클래스는 삭제한다.
                $(".pdp-parts-choice").removeClass('productAdd').addClass('productAdd');
                $(".pdp-parts-choice").removeClass('panelOnly');
                //PJTOBJET-5-3 END
                $(".pdp-parts-choice").removeClass('product').addClass('product');
                /** TODO 본품 포함하여 가격이 보이도록 가격 정보 변경 */
                /**
                $(".objet-selectPart .selectPart-tit").hide();
                $(".changeProductAddBtn").hide();
                $(".changePanelOnlyBtn").show();
                objetUi.save_btn_visibility();  
                priceInfo.setPrice();
                **/
                /** TODO modal 창 오픈*/
                //PJTOBJET-5-3 ADD
                $('#modal-pdp-objet').modal('show');
            });
        }   
    }
    objetUi.load();
    
    $('#modal-pdp-objet').on('hidden.bs.modal', function (e) {
        /** 20220610 한성희 세이브된 데이터가 없으면 팝업 선택 ui 초기화 */
        objetUi.after_popup_close_ui(clickedSaveBtn);
        //팝업 닫길때 공통사항
        var saveData = $(".objet-pdp").hasClass('save');
        if(!saveData){
            //세이브 데이터가 없으면 패널 컬러 선택 팝업 숨김, 재질 선택 팝업 노출
            $(".pdp-parts-choice").addClass("active");
            $(".pdp-objet-inner").removeClass("active");
        }else{
            objetUi.popup_reselect_saved();
        }       
        priceInfo.setPrice();
        //PJTOBJET-5-3 ADD
        //무조건 파업을 닫으면 false로 초기화
        clickedSaveBtn = false;
    })
    //PJTSUMMARY-4 Start
    /*
    * 기존 버전일 때와 개선 버전일 때 price 노출 태그가 다르기 때문에 구분 필요 
    * GPC0009에 before 클래스가 있는 경우 : 기존 버전
    * GPC0009에 improve 클래스가 있는 경우 : 개선 버전
    */
    var priceInfo = {
        originPrice : null,
        promoPrice : null,
        memberPrice : null,
        discountedMsg : null,   
        //PJTSUMMARY-4 START
        isBefore: $('div.component.GPC0009').hasClass('before'),
        objetPrice: this.isBefore ? '0' : $('#improvePrice .price-won').filter(':visible').text().replace(/[^0-9]/g, ''),
        currencyDot : this.isBefore ? $('.GPC0009 .relation-area .price-area').data('currency-dot') : $('.GPC0009 #currencyDot').val(),
        currencySymbol : this.isBefore ? $('.GPC0009 .relation-area .price-area').data('currency-symbol') : $('.GPC0009 #currencyText').val(),
        discountMsg : this.isBefore ? $('.GPC0009 .relation-area .price-area').data('discount-msg') : $('.GPC0009 .discount-msg-legal').text(),
        useReStockAlert : this.isBefore ? $(".GPC0009 .relation-area .re-stock-alert").is(':visible') : $(".GPC0009 .re-stock-alert").is(':visible'),
        useOutOfStock : this.isBefore ? $(".GPC0009 .relation-area .stock-area.out-of-stock").is(':visible') : $(".GPC0009 .stock-area.out-of-stock").is(':visible'),
        discountPrice : null,
        //PJTSUMMARY-4 END
        hasWtbOnly : $('.GPC0011 .pdp-tab').hasClass('has-wtb'),
        init : function(){
            
        },
        setPrice:function(){
            //PJTSUMMARY-4 START
            priceInfo.currencySymbol = priceInfo.isBefore ? $('.GPC0009 .relation-area .price-area').attr('data-currency-symbol') : $('.GPC0009 #currencyText').val();
            var promoPriceArea = null;
            var originPriceArea = null;
            var memberPriceArea = null;
            var discountedMsgArea = null;
            var viewArea = $(".mobile-bottom-info").is(":visible") ? '.mobile-bottom-info' : '.desktop-info';//PJTSUMMARY-4 ADD 
            var disMemberPrice = 0;
            var priceNumRegex = /[^0-9]/g;
            
            if(priceInfo.isBefore){
                promoPriceArea = $('.GPC0009 .pdp-summary-area .purchase-price .price .number');
                originPriceArea = $('.GPC0009 .pdp-summary-area .product-price .price .number');
                memberPriceArea = $('.GPC0009 .pdp-summary-area .member-price span');
                discountedMsgArea = $('.GPC0009 .pdp-summary-area .product-price .legal');
                if(!priceInfo.promoPrice && $(promoPriceArea).length>0){
                    priceInfo.promoPrice = priceInfo.parsePrice($(promoPriceArea).filter(':visible').text());
                }
                if(!priceInfo.originPrice && $(originPriceArea).length>0){
                    priceInfo.originPrice = priceInfo.parsePrice($(originPriceArea).filter(':visible').text());
                }
                if(!priceInfo.memberPrice && $(memberPriceArea).length>0){
                    priceInfo.memberPrice = priceInfo.parsePrice($(memberPriceArea).filter(':visible').text());
                }
                if(!priceInfo.discountedMsg && $(discountedMsgArea).length>0){
                    priceInfo.discountedMsg = $(discountedMsgArea).filter(':visible').text();
                }
            } else {
                disMemberPrice = $(viewArea + ' #improveMembershipPrice .price-num').filter(':visible').text().replace(priceNumRegex, '');
                priceInfo.promoPrice = $('.component-rPromoPrice').val();
                priceInfo.originPrice = $('.component-rPrice').val();
                priceInfo.memberPrice =  priceInfo.originPrice - disMemberPrice;
                priceInfo.discountPrice = $(viewArea + ' #improveDiscountedPrice .price-num').filter(':visible').text().replace(priceNumRegex, '');
                priceInfo.discountedMsg = $('.GPC0009 .discount-msg-legal').filter(':visible').text();
                if(priceInfo.discountPrice == '') priceInfo.discountPrice = 0;
                if(priceInfo.promoPrice == '') priceInfo.promoPrice = 0;
            }
            
            //PJTSUMMARY-4 END  
    
            var sumPromoPrice = priceInfo.isBefore ? priceInfo.promoPrice : priceInfo.promoPrice - priceInfo.discountPrice;
            var sumOriginPrice = priceInfo.originPrice;
            var sumMemberPrice = priceInfo.memberPrice;
            var sumDiscountedMsg = priceInfo.discountedMsg;
            var product = $(".pdp-parts-choice").hasClass('product');//상품 포함 패널 선택 인지 확인
            
            if(!product && $(viewArea + ' .objet-selectPart-list li:visible').length>0){
                sumPromoPrice = '0';
                sumOriginPrice = '0';
                sumMemberPrice = '0';
                sumDiscountedMsg = '0';
                //PJTSUMMARY-4 START
                if(priceInfo.isBefore){
                    $('.GPC0009 .pdp-summary-area .price-area .product-price').hide();
                    $('.GPC0009 .pdp-summary-area .price-area .member-price').hide();
                }
                //PJTSUMMARY-4 END
                $('.product-stickytab .product-selling-price .product-price').removeClass('active');
                //PJTSUMMARY-4 START
                if(priceInfo.useOutOfStock && priceInfo.isBefore){
                    $(".GPC0009 .relation-area .stock-area.out-of-stock").hide();
                } else if(priceInfo.useOutOfStock && !priceInfo.isBefore){
                    $(".GPC0009 .stock-area.out-of-stock").hide();
                }
                //PJTSUMMARY-4 END
            }else{
                //PJTSUMMARY-4 START
                if(priceInfo.isBefore){
                    $('.GPC0009 .pdp-summary-area .price-area .product-price').show();
                    $('.GPC0009 .pdp-summary-area .price-area .member-price').show();
                    if($(originPriceArea).length>0){
                        $('.product-stickytab .product-selling-price .product-price').addClass('active');
                    }
                    if(priceInfo.useOutOfStock){
                        $('.GPC0009 .pdp-summary-area .relation-area .stock-area.out-of-stock').show();
                    }
                } else {
                    if(priceInfo.useOutOfStock){
                        $('.GPC0009 .pdp-summary-area .stock-area.out-of-stock').show();
                    }
                }
                //PJTSUMMARY-4 END
            }
    
            //PJTSUMMARY-4 START
            let panelTotalPrice = 0;
            let selectPanel = null;
            if(priceInfo.isBefore){
                sumMemberPrice = sumMemberPrice.replace(this.currencySymbol, '');
            } else {
                panelTotalPrice = 0;
                selectPanel = $('.objet-selectPart').hasClass('active');
            }
            //PJTSUMMARY-4 END
    
            if($(viewArea + ' .objet-selectPart-list li')){
                $(viewArea + ' .objet-selectPart-list li').each(function(i,l){
                    if($(l).is(':visible')){
                        var selectPartPrice = $(l).find('.part-pay').text();
                        //PJTSUMMARY-4 START
                        if(priceInfo.isBefore){
                            sumPromoPrice = (parseFloat(sumPromoPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            if($(originPriceArea).length>0){
                                sumOriginPrice = (parseFloat(sumOriginPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            }
                            if($(memberPriceArea).length>0){
                                sumMemberPrice = (parseFloat(sumMemberPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            }
                        } else {
                            sumPromoPrice = (parseFloat(sumPromoPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            sumOriginPrice = (parseFloat(sumOriginPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            sumMemberPrice = (parseFloat(sumMemberPrice)+parseFloat(priceInfo.parsePrice(selectPartPrice)))+'';
                            panelTotalPrice += parseFloat(priceInfo.parsePrice(selectPartPrice));
                        }
                        //PJTSUMMARY-4 END
                    }
                });
                //PJTSUMMARY-4 START
                if(priceInfo.isBefore){
                    if(sumOriginPrice && sumPromoPrice && discountedMsgArea && priceInfo.discountMsg){
                        sumDiscountedMsg = Math.floor(((parseFloat(sumOriginPrice) - parseFloat(sumPromoPrice))/parseFloat(sumOriginPrice)) *100);
                        sumDiscountedMsg = priceInfo.discountMsg.replace('{1}',sumDiscountedMsg);
                    }
                }
                //PJTSUMMARY-4 END
            }
            //PJTSUMMARY-4 START
            if(priceInfo.isBefore){
                promoPriceArea.html('');
                promoPriceArea.append(changeFormatFullPrice(sumPromoPrice));
                $('.product-stickytab .product-selling-price>.price .number').html(sumPromoPrice);
                if($(originPriceArea).length>0){
                    originPriceArea.html('');
                    originPriceArea.append(changeFormatFullPrice(sumOriginPrice));
                    $('.product-stickytab .product-selling-price .product-price .price .number').html(sumOriginPrice);
                }
                if($(memberPriceArea).length>0){
                    memberPriceArea.html('');
                    memberPriceArea.append(priceInfo.currencySymbol+changeFormatFullPrice(sumMemberPrice));
                }
                if($(discountedMsgArea).length>0){
                    discountedMsgArea.html('');
                    discountedMsgArea.append(sumDiscountedMsg);
                    $('.product-stickytab .product-selling-price .product-price .legal').html(sumDiscountedMsg);
                }
            } else {
                let totalPriceArea = null;
                let totalPrice = 0;
                let objetPanelPriceArea = null;
                totalPriceArea = $('.price-total-box.act .total-price-num strong');
                objetPanelPriceArea = $('.objet-price .price-d');
                if (selectPanel && product) {
                	$('.base-price').show();
                    $('.price-pdp-area .price-pdp-inner .objet-price').removeClass('d-none');
                    //$('#improveObjet').addClass('act');
                    objetPanelPriceArea.text(priceInfo.currencySymbol + panelTotalPrice + '');
    
                    if ($('#improveMembershipPrice').hasClass('dis')) {//멤버십할인 체크
                        if(sumPromoPrice == 0 || sumPromoPrice == panelTotalPrice){
                            totalPrice = priceInfo.currencySymbol + changeFormatFullPrice(sumOriginPrice);
                        } else {
                            totalPrice = priceInfo.currencySymbol + changeFormatFullPrice(sumPromoPrice);
                        }
                    } else {
                        totalPrice = priceInfo.currencySymbol + changeFormatFullPrice(sumMemberPrice);
                    }
    
                    totalPriceArea.html('');
                    totalPriceArea.append(totalPrice);
                    $('.product-stickytab .product-selling-price .price').html(totalPrice);
                    if(viewArea == '.mobile-bottom-info') {
                        $('.simple-price-area').find('.purchase-price .price .number').text(sumPromoPrice.replace(priceInfo.currencySymbol, ''));
                        $('.simple-price-area').find('.member-price').show();
                        $('.simple-price-area').find('.member-price p span').text(sumMemberPrice.replace(priceInfo.currencySymbol, ''));
                    }
    
                } else if (!product && selectPanel) { //패널만 구매
                    //$('#improveObjet').removeClass('act');
                	$('.base-price').hide();
                    $('.price-pdp-area .price-pdp-inner .objet-price').removeClass('d-none');
                    $('.price-pdp-area .price-pdp-inner .objet-price .price-box').show();
                    objetPanelPriceArea.text(priceInfo.currencySymbol + panelTotalPrice + '');
                    totalPriceArea.html('');
                    totalPriceArea.text(priceInfo.currencySymbol + panelTotalPrice + '');
                    $('.product-stickytab .product-selling-price .price').html( priceInfo.currencySymbol +panelTotalPrice + '');
                    if(viewArea == '.mobile-bottom-info') {
                        $('.simple-price-area').find('.purchase-price .price .number').text(priceInfo.currencySymbol + panelTotalPrice + '');
                        $('.simple-price-area').find('.member-price').hide();
                    }
    
                } else {
                	$('.price-pdp-area .price-pdp-inner .objet-price').addClass('d-none');
                    $('.price-pdp-area .price-pdp-inner .base-price').show();
                    priceInfo.discountPrice = $(viewArea + ' #improveDiscountedPrice .price-num').filter(':visible').text().replace(priceNumRegex, '');
                    if(priceInfo.discountPrice == '') priceInfo.discountPrice = 0;

                    totalPriceArea.html('');
                    if ($('#improveMembershipPrice').hasClass('dis')) {
                        totalPriceArea.append(priceInfo.currencySymbol + changeFormatFullPrice(priceInfo.originPrice - priceInfo.discountPrice));
                    } else {
                        totalPriceArea.append(priceInfo.currencySymbol + changeFormatFullPrice(priceInfo.originPrice - disMemberPrice));
                    }
                    $('.product-stickytab .product-selling-price .price').html(priceInfo.currencySymbol + changeFormatFullPrice(priceInfo.originPrice - priceInfo.discountPrice));
                    if(viewArea == '.mobile-bottom-info') {
                        $('.simple-price-area').find('.purchase-price .price .number').text(priceInfo.originPrice);
                        $('.simple-price-area').find('.member-price').show();
                        $('.simple-price-area').find('.member-price p span').text(priceInfo.originPrice - disMemberPrice);
                    }
    
                }
    
                // 본품 STATUS - DISCONTINUED인지 확인
                var isOnlyPanel = $('.price-pdp-area').hasClass('objet-only-panel');
                if(selectPanel && isOnlyPanel){
                    $('.price-pdp-area').show();
                } else if(!selectPanel && isOnlyPanel){
                    $('.price-pdp-area').hide();
                }
    
                priceInfo.promoPrice = 0;
                priceInfo.memberPrice = 0;
                priceInfo.originPrice = 0;
                
            }
            //PJTSUMMARY-4 END
            priceInfo.buttonControl();
        },
        parsePrice:function(price){
            var parsePrice,priceArr;
            if(price.indexOf(priceInfo.currencySymbol)!= -1){
                price= price.replace(priceInfo.currencySymbol,'');
            }
            if(price.indexOf(priceInfo.currencyDot)!= -1){
                priceArr = price.split(priceInfo.currencyDot);
                parsePrice = priceArr[0].replace(' ','').replace('.','').replace(',','') +'.'+ priceArr[1];
            }else{
                parsePrice = price;
            }
            return parsePrice;
        },
        buttonControl:function(){
            var viewArea = $(".mobile-bottom-info").is(":visible") ? '.mobile-bottom-info' : '.desktop-info';
            var product = $(".pdp-parts-choice").hasClass('product');//상품 포함 패널 선택 인지 확인
            //PJTSUMMARY-4 START
            if(priceInfo.isBefore){

                if(!product && $(viewArea + ' .objet-selectPart-list li:visible').length>0){
                    $('.GPC0009 .pdp-summary-area .relation-area .objet-panel-btn').show().siblings('.re-stock-alert, .add-to-cart').hide();
                    $('.GPC0011 .extra-area .button .objet-panel-btn').show().siblings('a').hide();
                    if(priceInfo.hasWtbOnly){
                        $('.GPC0011 .pdp-tab').removeClass('has-wtb');
                        if($('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy') && $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').attr('no-red-btn') == 'true'){
                            if($('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').hasClass('imp-hide')){
                                $('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').removeClass('imp-hide');
                            }
                            $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').show();
                        }
                    }
                }else{
                    $('.GPC0009 .pdp-summary-area .relation-area .objet-panel-btn').hide().siblings('.re-stock-alert, .add-to-cart').show();
                    $('.GPC0011 .extra-area .button .objet-panel-btn').hide().siblings('a').attr('style', '');
                    if(priceInfo.hasWtbOnly){
                        $('.GPC0011 .pdp-tab').addClass('has-wtb');
                        if($('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy') && $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').attr('no-red-btn') == 'true'){
                            $('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').addClass('imp-hide');
                            $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').hide();
                        }
                    }
                }
            } else {
                if (!product && $(viewArea + ' .objet-selectPart-list li:visible').length > 0) {
                    $('.GPC0009 .pdp-summary-area .objet-panel-btn').show().siblings('.re-stock-alert, .add-to-cart').hide();
                    $('.GPC0011 .extra-area .button .objet-panel-btn').show().siblings('a').hide();
                    if (priceInfo.hasWtbOnly) {
                        $('.GPC0011 .pdp-tab').removeClass('has-wtb');
                        if ($('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy') && $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').attr('no-red-btn') == 'true') {
                            if ($('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').hasClass('imp-hide')) {
                                $('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').removeClass('imp-hide');
                            }
                            $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').show();
                        }
                    }
                } else {
                    $('.GPC0009 .pdp-summary-area .objet-panel-btn').hide().siblings('.re-stock-alert, .add-to-cart').show();
                    $('.GPC0011 .extra-area .button .objet-panel-btn').hide().siblings('a').attr('style', '');
                    if (priceInfo.hasWtbOnly) {
                        $('.GPC0011 .pdp-tab').addClass('has-wtb');
                        if ($('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy') && $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').attr('no-red-btn') == 'true') {
                            $('.GPC0011 > .pdp-tab > .inner > .contents-menu-list').find('a[href="#pdp_where"]').closest('li').addClass('imp-hide');
                            $('.GPC0009').find('.mobile-bottom-info').find('.button a.where-to-buy').hide();
                        }
                    }
                }
            }
            //PJTSUMMARY-4 END
        }
    }
    
    //LGEGMCGA-28 Start : youreko DataLayer 추가
    $(document).on('mouseup','.youreko-container-new-border', function(e){
    	var price = "";
    	price = $(this).closest('.GPC0009').find('.js-compare').attr('data-price');
    	if(price == '.' || price == '.00' || price == '0.0' || price== '0'){
    		price = "";
    	} 
    	var msrp = "";
    	msrp = $(this).closest('.GPC0009').find('.js-compare').attr('data-msrp');
    	if(msrp == '.' || msrp == '.00' || msrp == '0.0' || msrp == '0'){
    		msrp = "";
    	} 
    	var modelYear = $(this).closest('.GPC0009').find('.js-compare').attr('data-model-year');
    	 window.dataLayer.push({
    		 	event: 'energy_saving_label_click',
    		    bu: $(this).closest('.GPC0009').find('.js-compare').attr('data-bu'),
    		    superCategory: $(this).closest('.GPC0009').find('.js-compare').attr('data-super-category-name'),
    		    category: $(this).closest('.GPC0009').find('.js-compare').attr('data-category-name'), 
    		    subcategory : $(this).closest('.GPC0009').find('.js-compare').attr('data-sub-category-name'), 
    		    modelYear : modelYear, 
    		    modelName : $(this).closest('.GPC0009').find('.js-compare').attr('data-model-name'), 
    		    modelCode: $(this).closest('.GPC0009').find('.js-compare').attr('data-model-id'), 
    		    salesModelCode: $(this).closest('.GPC0009').find('.js-compare').attr('data-model-salesmodelcode'), 
    		    sku: $(this).closest('.GPC0009').find('.js-compare').attr('data-sku'),
    		    suffix: $(this).closest('.GPC0009').find('.js-compare').attr('data-model-suffixcode'),
    		    price: price,
    		    currencyCode: $('.currency-code').val()
    		 });
    });
    // LGEGMCGA-28 End
    
    /* LGEBR-1361 Start */
    if(COUNTRY_CODE.toLowerCase() == 'br') {

        // masking
    	$(document).on('masking', function() {
    		var $maskingTargets = $("[data-masked-type]");

    		if ($maskingTargets.length) {
    			if (!$.mask) {
    				$.cachedScript( '/lg5-common-gp/library/jquery.maskedinput.min.js' ).done(function( script, textStatus ) {
    					applyMaskInput($maskingTargets);
    				});
    			} else {
    				applyMaskInput($maskingTargets);
    			}
    		}

    		/* LGEPL-342 20210315 add 
    		** masking holder _ (언더바) string으로 인해 focus 시 커서가 맨 뒤에 위치하는 이슈 개선
    		** 입력 완료했을 시엔 맨 뒤에 위치하는 게 맞음으로 last string validation 추가
    		*/
    		$('input[data-masked-type]').on('focus click', function(e){
    			var postCodelValue = $(this).val(),
    				lastIdx = parseInt(postCodelValue.length) - 1;
    			if(postCodelValue.charAt(lastIdx) == '_') $(this)[0].setSelectionRange(0, 0);
    		});
    		/* //LGEPL-342 20210315 add */
    		
    		function applyMaskInput( $target ) {
    			$target.each(function() {
    				var type = $(this).attr("data-masked-type");
    				switch (type) {
    				case "BRMobile":
    					// 20200406 START 구유정 || BRMobile mask 시점 click → focus 변경
    					$(this).one("focus", function() {
    					// 20200406 END 구유정 || BRMobile mask 시점 click → focus 변경
    						$(this).mask("(99)99999-9999");
    					}),
    					$(this).attr("inputmode") == "numeric" && $(this).attr("type", "tel");
    					break;
    				case "AAA AAA":
    					var postType = this.getAttribute('data-postcode-type');
    					if ( postType == 'ca_en' || postType == 'ca_fr'){
    						$(this).mask("AAA AAA");
    					}				
    					break;
    				default:
    					var r = $(this)[0].hasAttribute("masked-holder") ? $(this).attr("masked-holder") : type.replace(/0|9|A|\*/g, "_");
    					$(this).mask(type, {
    						placeholder: r
    					});
    				}
    			});
    		}
    	});
    	
    	$(document).trigger('masking');
    	
    	$("#check-pincode").on("keyup", function(e){
    		if(e.keyCode == 13){
    			$(this).closest('.chkStBox').find('a.btn-sm').trigger('click');
            }
         });
    	
    }
    /* LGEBR-1361 End */
    
});

/* LGEITF-604, LGCOMSPEED-6 Start */
var priceSyncGPC0009 = {
	el: document.querySelector('.pdp-summary-area'),
	priceTemplate: null,
	priceSyncInstallmentTemplate: null,
	/* PJTSUMMARY-4 START */
	mobilePriceTemplate : null,
	mobileTopPriceSyncInstallmentTemplate : null,
	/* PJTSUMMARY END */
	/* PJTSUMMARY-4 ADD 이전버전인지 구분 변수 추가 */
	isBeforeGpc0009: $('div.component.GPC0009').hasClass('before'),
	init: function(){
		var _this = this;
		
		/* PJTSUMMARY-4 START */
		/*
		 * 기존 버전일 때와 개선 버전일 때 price 노출 태그가 다르기 때문에 구분 필요 
		 * GPC0009에 before 클래스가 있는 경우 : 기존 버전
		 * GPC0009에 improve 클래스가 있는 경우 : 개선 버전
		 */
		if(_this.isBeforeGpc0009){
			_this.priceTemplate = $('#priceSyncTemplateGPC0009').clone();
			_this.priceSyncInstallmentTemplate = $('#priceSyncInstallmentTemplate').clone();
			$('#priceSyncTemplateGPC0009').remove();
			$('#priceSyncInstallmentTemplate').remove();
		}else{
			_this.priceTemplate = $('#priceSyncTemplateGPC0009Improve').clone();
			$('#priceSyncTemplateGPC0009Improve').remove();
			_this.totalPriceTemplate = $('#totalPriceSyncTemplateGPC0009Improve').clone();
			$('#totalPriceSyncTemplateGPC0009Improve').remove();
			_this.mobilePriceTemplate = $('#priceSyncTemplateGPC0009').clone();
			$('#priceSyncTemplateGPC0009').remove();
			_this.mobileTopPriceSyncInstallmentTemplate = $('#priceSyncInstallmentTemplate').clone();
			$('#priceSyncInstallmentTemplate').remove();
		}
		/* PJTSUMMARY-4 END */
		
		_this.getPrice();
		
	},
	getPrice: function(){			
		var originalModelId = $('.GPC0009').attr('data-product-id');
		// PJTSUMMARY-4 ADD
		var loginGroup = this.el.getAttribute('data-login-group');
		var _this = this,
			url = _this.el.getAttribute('data-price-sync-url'),
			param = {
				modelId: originalModelId,
				// PJTSUMMARY-4 ADD
				loginGroup : loginGroup
			};
			param['v'] = $('#v').val();

		ajax.call(url, param, 'json', function(data){
			if(data.status == 'success' && data.data){
				var p = data.data[0];
				html = priceSyncGPC0009.priceTemplate.clone().html();
				
				//PJTSUMMARY-4 ADD(이전 버전인지 개선 버전인지 구분 조건 추가)
				if(_this.isBeforeGpc0009){	
					priceInstallmentHtml = priceSyncGPC0009.priceSyncInstallmentTemplate.clone().html();				
					if (!!p.rPromoPrice || !!p.rPrice){
						if (priceInstallmentHtml) {
							priceInstallmentHtml = priceInstallmentHtml.replace(/\*emiMsg\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')
								.replace(/\*inventoryFlag\*/g, p.obsInventoryFlag == 'Y' ? 'imp' : 'zero')
								.replace(/\*obsProductCount\*/g, nvl(p.obsProductCount, '0'))
								.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode)
								.replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')
								.replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEGMC-3167 add, OBSLGEAU-749 (5000 -> 10000) */
								.replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')/* LGEGMC-3167 add */
								;
							if(!!$(priceSyncGPC0009.el).find('.hidden-xs .price-pdp-Installment').length){
								$(priceSyncGPC0009.el).find('.hidden-xs .price-pdp-Installment').html('').removeClass('d-none').append(xssfilter($(priceInstallmentHtml).find('.hidden-xs').html(), true));
							}
							if(!!$(priceSyncGPC0009.el).find('.visible-xs .price-pdp-Installment').length){
								$(priceSyncGPC0009.el).find('.visible-xs .price-pdp-Installment').html('').removeClass('d-none').append(xssfilter($(priceInstallmentHtml).find('.visible-xs').html(), true));
							}
						}
						
						if(html) {
							html = html.replace(/\*discountMsg\*/g, p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'))
								.replace(/\*rPriceRU\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : (p.rPrice ? changeFormatPriceSync(p.rPrice) : '') )
								;
							
							if(!!p.rPromoPriceCent){
								html = html.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : '')
								.replace(/\*rPricerPromoPrice\*/g, p.rPromoPrice ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : '');
							}

							if(!!p.rPriceCent){
								html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : '')
								.replace(/\*rPricerPromoPrice\*/g, p.rPrice ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : '');
							}
							if(!!p.rMembershipPriceCent){
								html = html.replace(/\*membershipPrice\*/g, p.rMembershipPrice ? changeFormatFullPriceSync(p.rMembershipPrice, p.rMembershipPriceCent) : '');
							}
							if(!!p.rObsCheaperPriceCent){
								html = html.replace(/\*cheaperPrice\*/g, p.rObsCheaperPrice ? changeFormatFullPriceSync(p.rObsCheaperPrice, p.rObsCheaperPriceCent) : '');
							}
							
							html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatPriceSync(p.rPrice) : '')
							.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : '')
							.replace(/\*membershipPrice\*/g, p.rMembershipPrice ? changeFormatPriceSync(p.rMembershipPrice) : '')
							.replace(/\*cheaperPrice\*/g, p.rObsCheaperPrice ? changeFormatPriceSync(p.rObsCheaperPrice) : '')
							.replace(/\*rPricerPromoPrice\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : p.rPrice ? changeFormatPriceSync(p.rPrice) : '')
							;
													
							var title = $("#openTarget").val();
							p.obsMembershipLinkTarget == '_blank' ? title : title = "";
							var obsMemberShipLinkStartHtml = "";
							var obsMemberShipLinkEndHtml = "";
							if(p.obsMembershipLinkUrl != "" && p.obsMembershipLinkUrl != null && p.membershipDisplayFlag == 'Y'){
								obsMemberShipLinkStartHtml = "<a href='"+ p.obsMembershipLinkUrl +"' target='"+ p.obsMembershipLinkTarget +"' title='" +title+ "'>";
								obsMemberShipLinkEndHtml = "</a>"
							} 
							html = html.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml);
							html = html.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml);			
	
							var $html = $(html);
							
							// price setting
							var $price,
								$membership = $html.find('.obsMembershipAreaTemplate').clone(),
								$obsCheaperPrice = $html.find('.obsCheaperPriceTemplate').clone();
							
							if(p.modelStatusCode=='DISCONTINUED') {
								return false;
							}else if(p.retailerPricingFlag=="Y") {
								$price = $html.find('.retailer').clone();
							}else if(COUNTRY_CODE.toLowerCase() == 'ru') {
								$price = $html;
							}else if(p.rPrice && p.rPrice != null) {
								if(p.bizType.toUpperCase() =='B2C') {								
									if(p.rPromoPrice != null && p.rPromoPrice != '') {
										$price = $html.find('.rPromoPrice').clone();
									}else {
										$price = $html.find('.rPrice').clone();
									}
								}else if(p.bizType.toUpperCase() =='B2B') {
									if(p.obsLoginFlag == "Y"){
										if(p.rPromoPrice != null && p.rPromoPrice != '') {
											$price = $html.find('.rPromoPrice').clone();
										}else {
											$price = $html.find('.rPrice').clone();
										}
									}else{
										$price = $html.find('.msrp').clone();
									}
								}								
								/* LGETW-651 start */
								if(!!p.obsInstallmentPriceDisableLink && p.obsInstallmentPriceDisableLink == 'Y'){
									$html.find('.price-installment').addClass('no-link').attr('tabindex','-1');
								}
								/* LGETW-651 end */
							}else {
								$price = $html.find('.rPrice').clone();
								$price.html('');
							}
							
							$html.html($price.html());
							
							if(p.membershipDisplayFlag == 'Y'){
								$html.append($membership.html());
							}
							
							if(p.obsCheaperPriceFlag == 'Y'){
								$html.append($obsCheaperPrice.html());
							}

							if(!!$(priceSyncGPC0009.el).find('.price-area:not(.ru-ver)').length){
								$(priceSyncGPC0009.el).find('.price-area:not(.ru-ver)').html('').removeClass('d-none').append(xssfilter($html.html(), true));
							}else{
								$html = $html.get(0).outerHTML
								$(priceSyncGPC0009.el).find('.downFiles').before(xssfilter($html, true));
							}
							tooltipActive()
						}
					}	
				//PJTSUMMARY-4 START
				}else{
					if(!!p.rPrice || !!p.rPromoPrice){
						var totalPriceHtml = priceSyncGPC0009.totalPriceTemplate.clone().html();	
						var rPrice ='',
						rPromoPrice='',
						rMemberPrice='',
						rMembershipPrice='',
						rDiscountedPrice='',
						discountedMembershipPrice='';
						rWelcomePrice = ''; //LGCOMITF-69
						if (!!p.rPrice){
							var $price;
							if(html) {
								var totalPrice = 0.00;
								
								//html(template) replace 를 위한 변수값 세팅 (B2C 일경우만 로직 처리 - 로그인시 membership 영역 출력)
								// 일반 모델
								if (!!p.rPromoPrice){
									rPrice = changeFormatFullPriceSync(p.rPrice, p.rPriceCent);
									rPromoPrice = changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent);

									if(!!p.rDiscountedPrice)
										rDiscountedPrice = changeFormatFullPriceSync(p.rDiscountedPrice, p.rDiscountedPriceCent);
								}
								else
									rPromoPrice = changeFormatFullPriceSync(p.rPrice, p.rPriceCent);

								// membership 모델
								if (!!p.rMembershipPrice){
									rMemberPrice = changeFormatFullPriceSync(p.rPrice, p.rPriceCent);
									rMembershipPrice = changeFormatFullPriceSync(p.rMembershipPrice, p.rMembershipPriceCent);
									if(!!p.discountedMembershipPrice){
										discountedMembershipPrice = changeFormatFullPriceSync(p.discountedMembershipPrice, p.discountedMembershipPriceCent);
									}
								}else{
									//rMembershipPrice = changeFormatFullPriceSync(p.rPrice, p.rPriceCent);
								}
								
								html = html.replace(/\*quantity\*/g, p.obsProductCount ? p.obsProductCount : '');
								html = html.replace(/\*inventoryFlag\*/g, p.obsInventoryFlag == 'Y' ? '' : 'zero') // LGECZ-400
								html = html.replace(/\*rPriceRU\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : (p.rPrice ? changeFormatPriceSync(p.rPrice) : '') );
								
								html = html.replace(/\*rPrice\*/g, rPrice ? rPrice : '');
								html = html.replace(/\*rPromoPrice\*/g, rPromoPrice ? rPromoPrice : '');
								html = html.replace(/\*discountPrice\*/g, rDiscountedPrice ? rDiscountedPrice : '');
								html = html.replace(/\*rMemberPrice\*/g, rMemberPrice ? rMemberPrice :  '');
								html = html.replace(/\*rMembershipPrice\*/g, rMembershipPrice ? rMembershipPrice : (rPromoPrice ? rPromoPrice : '') );
								html = html.replace(/\*discountedMembershipPrice\*/g, rMembershipPrice ? discountedMembershipPrice : (rPromoPrice ? rDiscountedPrice : '') );
                                // html = html.replace(/\*discountMsg\*/g, p.discountMsg ? p.discountMsg : '');    // LGEIS-1213
                                html = html.replace(/\*discountPDPMsg\*/g, p.discountPDPMsg ? p.discountPDPMsg : '');    // LGEIS-1213
                                
                                //LGCOMITF-69 Start
                                if(!!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag && !!p.obsWelcomePrice) {
                                	
									rWelcomePrice = changeFormatFullPriceSync(p.obsWelcomePrice, p.obsWelcomePriceCent);
									
                                	html = html.replace(/\*rWelcomePrice\*/g, rWelcomePrice ? rWelcomePrice : '');
                               		html = html.replace(/\*rWelcomePriceDescription\*/g, p.obsWelcomePriceDescription ? p.obsWelcomePriceDescription : '');
                                	html = html.replace(/\*rWelcomePriceTooltip\*/g, p.obsWelcomePriceTooltip ? p.obsWelcomePriceTooltip : '');
								}
                                //LGCOMITF-69 End
                                
								//price-payments setting
								var improveCalculatorSalesCode = ""; 
								if((p.salesModelCode != 'null' && p.salesModelCode != "") && (p.salesSuffixCode != 'null' && p.salesSuffixCode != "")){ 
									improveCalculatorSalesCode = p.salesModelCode + "." + p.salesSuffixCode; 
								}else{ 
									improveCalculatorSalesCode = p.salesModelCode; 
								} 
								html = html.replace(/\*improveCalculatorSalesCode\*/g, improveCalculatorSalesCode ? improveCalculatorSalesCode: ""); 
								html = html.replace(/\*improveEmiMsg\*/g, (SIGN_IN_STATUS == 'Y' && p.obsEmiMsgFlag == 'Y' && p.emiMemberMsg != null && p.emiMemberMsg != '')?p.emiMemberMsg: p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : ''); 
								html = html.replace(/\*improveAfterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;'); 
								html = html.replace(/\*improveZipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;'); /* OBSLGEAU-749 (5000 -> 10000) */ 
								html = html.replace(/\*improveOrZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : ''); 
								
								//PJTPPDPAOB-1, LGEBR-1568 start
								var cheaperUseFlag = $('#cheaperUseFlag').val();
								if(totalPriceHtml){
									if(p.addOnBundleUseFlag == 'Y' ){
										totalPriceHtml = totalPriceHtml.replace(/\*improveTotalPrice\*/g, (SIGN_IN_STATUS == 'Y') ? ((rMembershipPrice)?rMembershipPrice:rPromoPrice) : rPromoPrice)
														.replace(/\*rPrice\*/g, rPrice ? rPrice : '')
														.replace(/\*discountPrice\*/g, rDiscountedPrice ? rDiscountedPrice : '')
														.replace(/\*totalPrice\*/g, (SIGN_IN_STATUS == 'Y') ? ((rMembershipPrice)? p.rMembershipPrice:p.rPrice) : p.rPrice)
														.replace(/\*totalPriceCent\*/g, (SIGN_IN_STATUS == 'Y') ? ((rMembershipPrice)?p.rMembershipPriceCent:p.rPriceCent) : p.rPriceCent);
										
									}else{
										if(COUNTRY_CODE.toLowerCase() == 'br' && cheaperUseFlag == 'Y'){
											totalPriceHtml = totalPriceHtml.replace(/\*improveTotalPrice\*/g, (SIGN_IN_STATUS == 'Y') ? ((rMembershipPrice)?rMembershipPrice:(p.rObsCheaperPrice ? changeFormatFullPriceSync(p.rObsCheaperPrice, p.rObsCheaperPriceCent):rPromoPrice)) : (p.rObsCheaperPrice ? changeFormatFullPriceSync(p.rObsCheaperPrice, p.rObsCheaperPriceCent):rPromoPrice));
										} else {
											totalPriceHtml = totalPriceHtml.replace(/\*improveTotalPrice\*/g, (SIGN_IN_STATUS == 'Y') ? ((rMembershipPrice)?rMembershipPrice:rPromoPrice) : rPromoPrice);
										}
									}
								} 
								//PJTPPDPAOB-1, LGEBR-1568 end
								
									
								if(!!p.rObsCheaperPriceCent){
									html = html.replace(/\*cheaperPrice\*/g, p.rObsCheaperPrice ? changeFormatFullPriceSync(p.rObsCheaperPrice, p.rObsCheaperPriceCent) : '');
								}
								
								// price setting 후 화면에 출력할 영역 보여주기
								//var $html = $(html);	
								var $totalPriceHtml = $(totalPriceHtml);
								var $pricePdparea = $('.GPC0009.improve').find('.price-pdp-area');
								if(p.modelStatusCode=='DISCONTINUED') {
									$pricePdparea.addClass('d-none');
									//추가 작업 상항 : 오브제는 패널만 구매할 수 있기 때문에 단순 삭제가 아니라 관련 처리 필요
									return false;
								}else{
									//$html = $html.outerHTML;
									$totalPriceHtml = $totalPriceHtml.get(0).outerHTML;
									$pricePdparea.find('.price-pdp-inner').html(xssfilter(html, true));
									
									//PJTPPDPAOB-1 start
									if(p.addOnBundleUseFlag == 'Y'){
										$pricePdparea.find('.price-and-info').prepend(xssfilter($totalPriceHtml, true));
										if(null!=rPrice && rPrice!=''){
												$pricePdparea.find('.price-and-info .price-total-box').addClass('add-detail');
										}
									}else{
										$pricePdparea.find('.price-box-outer').after(xssfilter($totalPriceHtml, true));
									}
									//PJTPPDPAOB-1 end
									
									if(p.retailerPricingFlag=="Y") {
										$pricePdparea.addClass('add-retailer');
									}else if(COUNTRY_CODE.toLowerCase() == 'ru') {
										if(p.obsLimitSale == "Y" && p.limitSaleUseFlag == "Y"){
											if(!$pricePdparea.find('#improveLimitedQty').hasClass('act')){
												$pricePdparea.find('#improveLimitedQty').addClass('act');
											}
											if(0 >= parseInt(p.obsProductCount)){
												$pricePdparea.find('#improveLimitedQty').find('.limited-ea').addClass('zero');
											}
										}
										$pricePdparea.find('#improveRecommendedPrice').removeClass('d-none');
									}else{
										if(p.obsLimitSale == "Y" && p.limitSaleUseFlag == "Y"){
											if(!$pricePdparea.find('#improveLimitedQty').hasClass('act')){
												$pricePdparea.find('#improveLimitedQty').addClass('act');
											}
											if(0 >= parseInt(p.obsProductCount)){
												$pricePdparea.find('#improveLimitedQty').find('.limited-ea').addClass('zero');
											}
										}
										
										//비로그인 유저
										if(SIGN_IN_STATUS == 'Y' && p.rMembershipPrice!='' && null!=p.rMembershipPrice){
											//로그인 유저
											$pricePdparea.find('#improveMemberPrice').removeClass('d-none');
											$pricePdparea.find('#improveMemberPrice .price-d .price-won').removeClass('d-none');
											var membershipPriceEl = $pricePdparea.find('#improveMemberPrice .price-d .price-del').text();
											if(null!=membershipPriceEl && membershipPriceEl!=''){
												$pricePdparea.find('#improveMemberPrice .price-d .price-del').removeClass('d-none');
											}else{ //LGCOMIN-451
												if($pricePdparea.find('#improveMemberPrice .price-d .mrp-text').length>0){
													$pricePdparea.find('#improveMemberPrice .price-d .mrp-text').removeClass('ver-obs');
												}
											}
											var membershipDiscountPriceEl = $pricePdparea.find('#improveMemberPrice .price-d .sub-d').text();
											if(null!=membershipDiscountPriceEl && membershipDiscountPriceEl!=''){
												$pricePdparea.find('#improveMemberPrice .price-d .sub-d').removeClass('d-none');
												//LGEDE-1151
												if($pricePdparea.find('#improveMemberPrice .price-d .has-uvp').length>0) {
													$pricePdparea.find('#improveMemberPrice .price-d .has-uvp').removeClass('d-none');
												};
												//LGEDE-1151
											}
											// 로그인 유저중 rPrice 와 memberprice 가 같으면 payment 키고
											// 가격이 다르면 member instalment 값 확인후 오픈
											if((p.rPrice==p.rMembershipPrice&&p.rMembershipPrice)||(p.rMembershipPrice&&p.obsEmiMsgFlag == 'Y' && p.emiMemberMsg != null && p.emiMemberMsg != '')){
												
												//PJTPPDPAOB-1 start
												if(p.addOnBundleUseFlag == 'Y'){
													$pricePdparea.find('.price-and-info').addClass('add-payments');
												}else{
													$pricePdparea.find('.base-price').addClass('add-payments');
												}
												//PJTPPDPAOB-1 end
											}
										}else{
											$pricePdparea.find('#improvePrice').removeClass('d-none');
											$pricePdparea.find('#improvePrice .price-d .price-won').removeClass('d-none');
											if(null!=rPrice && rPrice!=''){
												$pricePdparea.find('#improvePrice .price-d .price-del').removeClass('d-none');
											}else{ //LGCOMIN-451
												if($pricePdparea.find('#improvePrice .price-d .mrp-text').length>0){
													$pricePdparea.find('#improvePrice .price-d .mrp-text').removeClass('ver-obs');
												}
											}
											if(null!=rDiscountedPrice && rDiscountedPrice!=''){
												$pricePdparea.find('#improvePrice .price-d .sub-d').removeClass('d-none');
												//LGEDE-1151
												if($pricePdparea.find('#improvePrice .price-d .has-uvp').length>0) {
													$pricePdparea.find('#improvePrice .price-d .has-uvp').removeClass('d-none');
												};
												//LGEDE-1151
											}
											//PJTPPDPAOB-1 start
											if(p.addOnBundleUseFlag != 'Y'){
											//PJTPPDPAOB-1 end
											if(p.membershipDisplayFlag=='Y'){
												$pricePdparea.find('.base-price').addClass('add-member');
											}
											//PJTPPDPAOB-1 start
											}
											//PJTPPDPAOB-1 end
											if(p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != ''){
												
												//PJTPPDPAOB-1 start
												if(p.addOnBundleUseFlag == 'Y'){
													$pricePdparea.find('.price-and-info').addClass('add-payments');
												}else{
													$pricePdparea.find('.base-price').addClass('add-payments');
												}
												//PJTPPDPAOB-1 end
											}
										}
									}
									
									// LGCOMMON-54, LGCOMPL-216 Start
									if(p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice) {
										if( $pricePdparea.find('.lowest-price-mark').length ) $pricePdparea.find('.lowest-price-mark').removeClass('d-none');
										if( $pricePdparea.find('.lowest-price-box').length ) $pricePdparea.find('.lowest-price-box').removeClass('d-none');
									} else {
										if( $pricePdparea.find('.lowest-price-mark').length ) $pricePdparea.find('.lowest-price-mark').html('');
										if( $pricePdparea.find('.lowest-price-box').length ) $pricePdparea.find('.lowest-price-box').html('');
									}
									// LGCOMMON-54, LGCOMPL-216 End
									
									//PJTPPDPAOB-1 start 
									if(p.addOnBundleUseFlag != 'Y'){
									//PJTPPDPAOB-1 end

									if(p.obsCheaperPriceFlag == 'Y'){
										$pricePdparea.find('.other-price-box').removeClass('d-none');
									}
									//PJTPPDPAOB-1 start 
									}else{
										if(p.obsCheaperPriceFlag == 'Y'){
											$pricePdparea.find('.other-p').removeClass('d-none');
										}
									}
									//PJTPPDPAOB-1 end
									if(p.bizType.toUpperCase() =='B2B' && (!!p.rPrice && p.rPrice != null && p.rPrice != '0')){
										if(!$('.GPC0009.improve').find('.price-total-box').find('.total-price-num').hasClass('msrp')){
											$('.GPC0009.improve').find('.price-total-box').find('.total-price-num').addClass('msrp');
										}
									}else{
										$('.GPC0009.improve').find('.price-total-box').find('.total-price-num').removeClass('msrp');
									}
									
									if(p.obsEmiMsgFlag == 'Y'){
										if(!$pricePdparea.find('.base-price').hasClass('add-payments')){
											//PJTPPDPAOB-1 start 
											if(p.addOnBundleUseFlag != 'Y'){
												$pricePdparea.find('.base-price').addClass('add-payments');
											}
											//PJTPPDPAOB-1 end
										}
										if(COUNTRY_CODE.toLowerCase() == 'au'){
											$('.price-installment').hide();
										}else if(p.obsCalculatorUseFlag == 'Y'){
											$('.price-installment.no-calculator').hide();
											$('.price-afterpay').hide();
											$('.price-zippay').hide();
										}else{
											$('.price-installment.calculator').hide();
											$('.price-afterpay').hide();
											$('.price-zippay').hide();										
										}
									}else{
										$('.payments').removeClass('act');
									}
									
									//LGCOMITF-69 Start
	                                if(!!p.obsWelcomePriceUseFlag && 'Y' == p.obsWelcomePriceUseFlag && !!p.obsWelcomePrice) {
	                                	if(!!$pricePdparea.find('#improveWelcomePrice')){
											if($pricePdparea.find('#improveWelcomePrice').css('display') == 'none') {
												$pricePdparea.find('#improveWelcomePrice').show();
											}
										}
	                                } else {
										if(!!$pricePdparea.find('#improveWelcomePrice')){
											$pricePdparea.find('#improveWelcomePrice').hide();
										}
									}
	                                //LGCOMITF-69 End
									
								}
								/* LGETW-651 start */
								if(!!p.obsInstallmentPriceDisableLink && p.obsInstallmentPriceDisableLink == 'Y'){
									$('.price-installment').addClass('no-link').attr('tabindex','-1');
								}
								/* LGETW-651 end */
								
								/* LGCOMPA-44 start */
								if(  SIGN_IN_STATUS=='N'
								  && !!p.guestPriceMessageUseFlag
								  &&   p.guestPriceMessageUseFlag == 'Y'
								  && !!p.guestPriceMessage ){
									$pricePdparea.find('.price-box.member-box').html('').append(p.guestPriceMessage);
								}
								/* LGCOMPA-44 end */
								
								tooltipActive()
							}
						}
	
						html = priceSyncGPC0009.mobilePriceTemplate.clone().html();
						priceInstallmentHtml = priceSyncGPC0009.mobileTopPriceSyncInstallmentTemplate.clone().html();				
						if (!!p.rPromoPrice || !!p.rPrice){
							if (priceInstallmentHtml) {
								priceInstallmentHtml = priceInstallmentHtml.replace(/\*emiMsg\*/g, (SIGN_IN_STATUS == 'Y' && p.obsEmiMsgFlag == 'Y' && p.emiMemberMsg != null && p.emiMemberMsg != '')?p.emiMemberMsg: p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' ? p.emiMsg : '')
									.replace(/\*inventoryFlag\*/g, p.obsInventoryFlag == 'Y' ? 'imp' : 'zero')
									.replace(/\*obsProductCount\*/g, nvl(p.obsProductCount, '0'))
									.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode)
									.replace(/\*afterPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && p.emiMsg != null && p.emiMsg != '' && (p.afterPay <= 3000 && p.afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')
									.replace(/\*zipPayInstallMent\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')/* LGEGMC-3167 add, OBSLGEAU-749 (5000 -> 10000) */
									.replace(/\*orZipPay\*/g, p.obsEmiMsgFlag == 'Y' && (p.afterPay > 0 && p.afterPay <= 3000) ? 'or ' : '')/* LGEGMC-3167 add */
									;
								if(!!$(priceSyncGPC0009.el).find('.hidden-xs .price-pdp-Installment').length){
									$(priceSyncGPC0009.el).find('.hidden-xs .price-pdp-Installment').html('').removeClass('d-none').append(xssfilter($(priceInstallmentHtml).find('.hidden-xs').html(), true));
								}
								if(!!$(priceSyncGPC0009.el).find('.visible-xs .price-pdp-Installment').length){
									$(priceSyncGPC0009.el).find('.visible-xs .price-pdp-Installment').html('').removeClass('d-none').append(xssfilter($(priceInstallmentHtml).find('.visible-xs').html(), true));
								}
							}
							
							if(html) {
								html = html.replace(/\*discountMsg\*/g, p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'))
									.replace(/\*rPriceRU\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : (p.rPrice ? changeFormatPriceSync(p.rPrice) : '') )
									;

								if(!!p.rPromoPriceCent){
									html = html.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : '')
									.replace(/\*rPricerPromoPrice\*/g, p.rPromoPrice ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : '');
								}
								if(!!p.rPriceCent){
									html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : '')
									.replace(/\*rPricerPromoPrice\*/g, p.rPrice ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : '');
								}
								if(!!p.rMembershipPriceCent){
									html = html.replace(/\*membershipPrice\*/g, p.rMembershipPrice ? changeFormatFullPriceSync(p.rMembershipPrice, p.rMembershipPriceCent) : '');
								}
								if(!!p.rObsCheaperPriceCent){
									html = html.replace(/\*cheaperPrice\*/g, p.rObsCheaperPrice ? changeFormatFullPriceSync(p.rObsCheaperPrice, p.rObsCheaperPriceCent) : '');
								}
								
								html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatPriceSync(p.rPrice) : '')
								.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : '')
								.replace(/\*membershipPrice\*/g, p.rMembershipPrice ? changeFormatPriceSync(p.rMembershipPrice) : '')
								.replace(/\*cheaperPrice\*/g, p.rObsCheaperPrice ? changeFormatPriceSync(p.rObsCheaperPrice) : '')
								.replace(/\*rPricerPromoPrice\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : p.rPrice ? changeFormatPriceSync(p.rPrice) : '')
                                ;
														
								var title = $("#openTarget").val();
								p.obsMembershipLinkTarget == '_blank' ? title : title = "";
								var obsMemberShipLinkStartHtml = "";
								var obsMemberShipLinkEndHtml = "";
								if(p.obsMembershipLinkUrl != "" && p.obsMembershipLinkUrl != null && p.membershipDisplayFlag == 'Y'){
									obsMemberShipLinkStartHtml = "<a href='"+ p.obsMembershipLinkUrl +"' target='"+ p.obsMembershipLinkTarget +"' title='" +title+ "'>";
									obsMemberShipLinkEndHtml = "</a>"
								} 
								html = html.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml);
								html = html.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml);			
								
								var $html = $(html);
								
								// price setting
								var $price,
									$membership = $html.find('.obsMembershipAreaTemplate').clone(),
									$obsCheaperPrice = $html.find('.obsCheaperPriceTemplate').clone(),
									$obsLowestPriceMsg = $html.find('.obsLowestPriceAreaTemplate').clone();
								
								if(p.modelStatusCode=='DISCONTINUED') {
									return false;
								}else if(p.retailerPricingFlag=="Y") {
									$price = $html.find('.retailer').clone();
								}else if(COUNTRY_CODE.toLowerCase() == 'ru') {
									$price = $html;
								}else if(p.rPrice && p.rPrice != null) {
									if(p.bizType.toUpperCase() =='B2C') {								
										if(p.rPromoPrice != null && p.rPromoPrice != '') {
											$price = $html.find('.rPromoPrice').clone();
										}else {
											$price = $html.find('.rPrice').clone();
										}
									}else if(p.bizType.toUpperCase() =='B2B') {
										if(p.obsLoginFlag == "Y"){
											if(p.rPromoPrice != null && p.rPromoPrice != '') {
												$price = $html.find('.rPromoPrice').clone();
											}else {
												$price = $html.find('.rPrice').clone();
											}
										}else{
											$price = $html.find('.msrp').clone();
										}
									}
								}else {
									$price = $html.find('.rPrice').clone();
									$price.html('');
								}
								
								$html.html($price.html());
								
								if(p.membershipDisplayFlag == 'Y'){
									$html.append($membership.html());
								}
								
								if(p.obsCheaperPriceFlag == 'Y'){
									$html.append($obsCheaperPrice.html());
								}
								
								
								if(!!$(priceSyncGPC0009.el).find('.price-area:not(.ru-ver)').length){
									$(priceSyncGPC0009.el).find('.mobile-bottom-info').find('.price-area:not(.ru-ver)').html('').removeClass('d-none').append(xssfilter($html.html(), true));
								}else{
									$html = $html.get(0).outerHTML
									$(priceSyncGPC0009.el).find('.mobile-bottom-info').find('.downFiles').before(xssfilter($html, true));
								}
								tooltipActive()
							}
						} else {
							if (p.modelStatusCode == 'DISCONTINUED') {
								const objetArea = $('.objet-area');
								const priceArea = $('.GPC0009.improve').find('.price-pdp-area.objet-only-panel');
								if (objetArea) {
									priceArea.hide();
								}
							}
	                    }	
						$(".GPC0009.improve .fixed-price-inner .fix-expand .price-box-area").find('div.parts-box,div.price-box-outer').wrapAll('<div class="fix-toggle-box"></div>');
						$('.GPC0009.improve').find('.price-pdp-area').removeClass('d-none');
						if($(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){
							$('.GPC0009.improve').find('.fixed-price').removeClass('d-none');
                            if($(".price-pdp-area").hasClass('add-retailer')){
                                $(".btn-expand").addClass('d-none');
                            }
						}
					}else{
						$('.GPC0009.improve').find('.price-pdp-area').addClass('d-none');
					}		
					//PJTSUMMARY-4 END
				}
				var $stickyBar = $('.GPC0011');
				if($stickyBar.get(0)) {
					priceSyncGPC0011(p);
				}

				// LGCOMSPEED-6, LGEITF-853(LGECZ-424) Start :: PJTSUMMARY-4 소스 함께 적용
				const directFromGpc0102 = $('.GPC0102').find('.directFrom .price-area');
				if(directFromGpc0102.length){
					// LGECZ-429, LGCOMMON-54 Start
					directFromGpc0102
					.append($(priceSyncGPC0009.el).find('.price-area').html())
					.after($obsLowestPriceMsg.html()).after(directFromGpc0102.find('.member-price'));	//LGCOMPL-218
					//LGCOMPL-218 start
					if(p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice) {
						if( directFromGpc0102.find('.lowest-price-mark').length ) directFromGpc0102.find('.lowest-price-mark').removeClass('d-none');
					}
					//LGCOMPL-218 END
					// LGECZ-429, LGCOMMON-54 End
				}
				// LGCOMSPEED-6, LGEITF-853(LGECZ-424) End
				
				//PJTPPDPAOB-1 START addon 번들
				if(p.addOnBundleUseFlag == 'Y' && (p.addToCartFlag == 'Y' || p.obsPreOrderFlag == 'Y')){
					if(p.addOnModelInfoList.length > 0){
						var addOnBundleListHtm = '';
						priceTotalBoxAtiveFlag = $('.price-total-box').hasClass('add-detail') == true ? 'Y':'N' ;
						for(var i=0 ; i<p.addOnModelInfoList.length ; i++){
							
							var rPrice = p.addOnModelInfoList[i].rPrice;
							var rPriceCent = p.addOnModelInfoList[i].rPriceCent;
							var rPromoPrice =  p.addOnModelInfoList[i].rPromoPrice;
							var rPromoPriceCent = p.addOnModelInfoList[i].rPromoPriceCent;
							var rDiscountedPrice = p.addOnModelInfoList[i].rDiscountedPrice; 
							var rDiscountedPriceCent = p.addOnModelInfoList[i].rDiscountedPriceCent;
							var rDiscountPrice = p.addOnModelInfoList[i].rDiscountedPrice;
							var rDiscountPriceCent = p.addOnModelInfoList[i].rDiscountedPriceCent;
							var disCountPrice = '';
							
							var onlySellPriceFlag = 'N';
							
							if(null == rPromoPrice && null == rPromoPriceCent){ //할인될 금액이 0 , 원가와 판매가가 같을때
								rPromoPrice = rPrice;
								rPromoPriceCent = rPriceCent;
								rPrice = '0';
								rPriceCent = '0';
								rDiscountedPrice = '0';
								rDiscountedPriceCent = '0';
								onlySellPriceFlag = 'Y';
							}else{
								disCountPrice = changeFormatFullPriceSync(rDiscountPrice,rDiscountPriceCent);
							}
							
							var oriPrice = changeFormatFullPriceSync(rPrice,rPriceCent);
							var disCountedSellingPrice = changeFormatFullPriceSync(rPromoPrice,rPromoPriceCent);
							
							var html = $('#addOnBundleTemplate').clone().html();
							
							html = html.replace(/\*rPrice\*/g, rPrice)
												.replace(/\*modelId\*/g, p.addOnModelInfoList[i].modelId)
							 					.replace(/\*rPriceCent\*/g, rPriceCent)
							 					.replace(/\*rPromoPrice\*/g, rPromoPrice)
							 					.replace(/\*rPromoPriceCent\*/g, rPromoPriceCent)
							 					.replace(/\*rDiscountedPrice\*/g, rDiscountedPrice)
							 					.replace(/\*rDiscountedPriceCent\*/g, rDiscountedPriceCent)
							 					.replace(/\*imgAddr\*/g, p.addOnModelInfoList[i].pdpMainImageAddr)
							 					.replace(/\*modelName\*/g, p.addOnModelInfoList[i].modelName)
							 					.replace(/\*userFriendlyName\*/g, p.addOnModelInfoList[i].userFriendlyName)
							 					.replace(/\*oriPrice\*/g, oriPrice)
							 					.replace(/\*discountedPrice\*/g, disCountedSellingPrice)
							 					.replace(/\*discountPrice\*/g,  disCountPrice)
							 					.replace(/\*onlyPrice\*/g,  onlySellPriceFlag)
							 					//.replace(/\*modelName\*/g,  p.modelName)
							addOnBundleListHtm += html;							 					
							 
						}
						$('.add-bundle-area .bundle-list ul').empty();
						$('.add-bundle-area .bundle-list ul').append(addOnBundleListHtm);
						$('.add-bundle-area .bundle-list ul li').each(function(){
							if(this.getAttribute('data-onlyPrice') == 'Y'){
								$(this).find('.bundle-del,.bundle-save').empty();
							}
						});
						
						$('.add-bundle-area').removeClass('d-none');
					}else{
						$('.price-box-outer .added-price').remove();
					}
				}
				//PJTPPDPAOB-1 END addon 번들
				
				/* LGEMS-491 start */
	            $('.GPC0009 .pdp-info').find(".warranty-price").hide();
	            $('.GPC0009.improve').find(".warranty-price").hide();
	            /* LGEMS-491 end */
			}
		});
	}
	
}
    function priceSyncGPC0011(productInfo){
        var _target = $('.GPC0011'),
            price,
            orgPrice,
            discountMsg;
        var p = productInfo;
        
        if( !document.querySelector('#priceSyncTemplateGPC0011') ) return false; // LGCOMMON-54

        var html = $('#priceSyncTemplateGPC0011').clone().html();
        $('#priceSyncTemplateGPC0011').remove();
        
        if(html) {
            html = html.replace(/\*discountMsg\*/g, p.discountMsg == null ? '' : p.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'));
        
            if(!!p.rPromoPriceCent){
                html = html.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : 'null');
            }
            if(!!p.rPriceCent){
                html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : 'null');
            }
            
            html = html.replace(/\*rPrice\*/g, p.rPrice ? changeFormatPriceSync(p.rPrice) : 'null')
            .replace(/\*rPromoPrice\*/g, p.rPromoPrice ? changeFormatPriceSync(p.rPromoPrice) : 'null');
            
            var $html = $(html);
            
            // price setting
            var $price;
            
            if(p.modelStatusCode=='DISCONTINUED') {
                $price = $html.find('.rPrice').clone();
                $price.html('');
                return false;
            }else if(p.retailerPricingFlag=="Y") {
                $price = $html.find('.retailer').clone();
            }else if(p.rPrice && p.rPrice != null) {
                if(p.bizType.toUpperCase() =='B2C') {
                    if(p.rPromoPrice != null && p.rPromoPrice != '') {
                        $price = $html.find('.rPromoPrice').clone();
                    }else {
                        $price = $html.find('.rPrice').clone();
                    }
                }else if(p.bizType.toUpperCase() =='B2B') {
                    if(p.obsLoginFlag == "Y"){
                        if(p.rPromoPrice != null && p.rPromoPrice != '') {
                            console.log('B2B rPromoPrice');
                            $price = $html.find('.rPromoPrice').clone();
                        }else {
                            console.log('B2B rPrice');
                            $price = $html.find('.rPrice').clone();
                        }
                    }else{
                        $price = $html.find('.rPrice').clone();
                    }
                }
            }else {
                $price = $html.find('.rPrice').clone();
                $price.html('');
            }
            
            $html.html($price.html());
            $(_target).find('.product-selling-price').html('').removeClass('d-none').append(xssfilter($html.html(), true));
        }
    }
    /* LGCOMSPEED-6 End */

/* LGCOMSPEED-6, LGCOMSPEED-6(gallery) Start */
window.addEventListener("load", function(event) {
	/* LGCOMSPEED-10 Start */
	$(modal.el.gallery).find('img[data-lazy]').each(function() {
        $(this).attr('src', $(this).attr('data-lazy')).removeAttr('data-lazy');
    });
	/* LGCOMSPEED-10 End */
    lazyloadJs3D(event);
}, true);

window.addEventListener("resize", function(event) {
    lazyloadJs3D(event);
}, true);

let timer3D = null;
function lazyloadJs3D(event) {
    if (modal === undefined) {
        timer3D = setTimeout(lazyloadJs3D, 100); 
    } else {
        if(timer3D !== null) clearTimeout(timer3D);
        
        if (availableGPU) {
            if($('#desktop_summary_gallery').is(':visible')){ //desktop
                var ifameArea = $(modal.el.gallery).find('.iframe-area[data-type="3603D"]');
                if( !!ifameArea.length && !ifameArea.find('iframe').length && !!!ifameArea.html()){
                    if(event.type == 'load') modal.slick.init({type:'shown'});
                    $(modal.el.gallery).addClass('loaded-iframe');
                    
                    ifameArea = $(modal.el.gallery).find('.iframe-area[data-type="3603D"]');
                    
                    html = modal.iframe.get360viewCode(ifameArea[0]);
                    ifameArea.html(html);
                }
                $(modal.el.gallery).removeClass('invisible');
            }
            
            if($('#mobile_summary_gallery').is(':visible')){ //mobile
                let ifameArea = $('#modal3603D').find('.iframe-area[data-type="3603D"]');
                if( !!ifameArea.length && !ifameArea.find('iframe').length && !!!ifameArea.html()){
                    html = modal.iframe.get360viewCode(ifameArea[0]);
                    ifameArea.html(html);
                }
            }
        }
    }
}
/* LGCOMSPEED-6, LGCOMSPEED-6(gallery) End */
/* LGCOMSPEED-6 End */
/* PJTSUMMARY-4_krchoi START */
if($('.GPC0009').hasClass('improve')){
var pdp_improve = {
	load : function(){
		pdp_improve.recommenBanner(); // recommenBanner load
		pdp_improve.pdpNav(); // pdpNav load
		pdp_improve.modalType(); // modalType load
		pdp_improve.expandBtn(); // expandBtn load 
		pdp_improve.galleryBtn(); // galleryBtn load
		pdp_improve.btnFixPrice(); // btnFixPrice load
		pdp_improve.clearFixLayer(); // btnFixPrice load
		pdp_improve.clearFixPdp(); // clearFixPdp load
		//LGEITF-947-2 Start
//		pdp_improve.changeVideo(); //PJTSUMMARY-4(최경래) ADD - > 동영상 iframe 변경으로 인한 추가
		//LGEITF-947-2 End
        $('#imageLists .slider-for ul').on('init', function(event, slick){
            $(this).addClass("hover-slider")
        });	
        $('#videoLists .slider-for ul').on('init', function(event, slick){
            $(this).addClass("hover-slider")
        });
	},
	expandBtn : function(){
		$(".btn-moreBox").on('click', function(e){
			$(this).parents('.expand-box').toggleClass('show');
			if($(this).parents('.expand-box').hasClass('show')){
				$(this).parents('.expand-box').find('.expand-layer').stop().slideDown(300)
				$(this).parents('.expand-box').find('.expand-layer').attr('aria-expanded','true')
			} else{
				$(this).parents('.expand-box').find('.expand-layer').stop().slideUp(300)
				$(this).parents('.expand-box').find('.expand-layer').attr('aria-expanded','false')
			}
		});
	},
	btnFixPrice : function(){
		$(".btn-expand").on('click', function(e){
			$(this).toggleClass('show');
			if($(this).hasClass('show')){
				$(this).parents('.fix-expand').find('.fix-toggle-box').stop().slideDown(300)
				$(this).parents('.fix-expand').find('.fix-toggle-box').attr('aria-expanded','true')
			} else{
				$(this).parents('.fix-expand').find('.fix-toggle-box').stop().slideUp(300)
				$(this).parents('.fix-expand').find('.fix-toggle-box').attr('aria-expanded','false')
			}
		});
	},
	clearFixLayer : function(){
		$(window).on('load scroll', function(){
			if($(".desktop-info .clear-fixLayer").length>0){
				var clearFixLayer = $(".desktop-info .clear-fixLayer").offset().top;
				var clearFixLayer_h = $(".desktop-info .clear-fixLayer").height(); 
				var winSrT = $(window).scrollTop();
				var winH = $(window).height();
				if(clearFixLayer < winSrT + winH && $(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){
					$(".fixed-price").removeClass('show');
				} else if(clearFixLayer > winSrT + winH && $(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){
					$(".fixed-price").addClass('show');
				}
			}
		});
	},
	clearFixPdp : function(){
		$(window).on('resize load scroll', function(){
			var winW = $(window).outerWidth();
			var winSrT = $(window).scrollTop();
			var winH = $(window).height();
			if ( winW > 991) {
				var winW = $(window).outerWidth();
				var visualPc_pos = $("#desktop_summary_gallery").offset().top;
				var visualPc_width = $("#desktop_summary_gallery").width();
				var visualPc_h = $("#desktop_summary_gallery .pdp-visual").innerHeight();
				var visualPcDesk_h = $(".desktop-info").innerHeight();
				var visualPcDesk_pos = $(".desktop-info").offset().top;
				if(winSrT > visualPc_pos == true && winSrT - visualPcDesk_pos > visualPcDesk_h - visualPc_h !== true && winH < visualPcDesk_h == true){
					$("#desktop_summary_gallery").addClass('fixPdp');
					$("#desktop_summary_gallery").removeClass('end');
					$("#desktop_summary_gallery .pdp-visual").css('width', visualPc_width);
				} else if(winSrT > visualPc_pos == true && winSrT - visualPcDesk_pos > visualPcDesk_h - visualPc_h == true && winH < visualPcDesk_h == true){
					$("#desktop_summary_gallery .pdp-visual").css('width', visualPc_width);
					$("#desktop_summary_gallery").addClass('end');
				} else{
					$("#desktop_summary_gallery .pdp-visual").css('width', 'auto');
					$("#desktop_summary_gallery").removeClass('fixPdp');
					$("#desktop_summary_gallery").removeClass('end');
				}
			} else if(winW > 767){				
				var winW = $(window).outerWidth();				
				var m_visualPc_pos = $("#mobile_summary_gallery").offset().top;
				var m_visualPc_width = $("#mobile_summary_gallery").width();
				var m_visualPc_h = $("#mobile_summary_gallery .pdp-visual-m").innerHeight();
				var m_visualPcDesk_h = $(".desktop-info").innerHeight();
				var m_visualPcDesk_pos = $(".desktop-info").offset().top;
				if(winSrT > m_visualPc_pos == true && winSrT - m_visualPcDesk_pos > m_visualPcDesk_h - m_visualPc_h !== true && winH < m_visualPcDesk_h == true){
					$("#mobile_summary_gallery").addClass('fixPdp');
					$("#mobile_summary_gallery").removeClass('m-end');
					$("#mobile_summary_gallery .pdp-visual-m").css('width', m_visualPc_width);
				}else if(winSrT > m_visualPc_pos == true && winSrT - m_visualPcDesk_pos > m_visualPcDesk_h - m_visualPc_h == true && winH < m_visualPcDesk_h == true){
					$("#mobile_summary_gallery .pdp-visual-m").css('width', m_visualPc_width);
					$("#mobile_summary_gallery").addClass('m-end');
				} else{
					$("#mobile_summary_gallery .pdp-visual-m").css('width', 'auto');
					$("#mobile_summary_gallery").removeClass('fixPdp');
					$("#mobile_summary_gallery").removeClass('m-end');
				}
			} else{
				$("#mobile_summary_gallery .pdp-visual-m").css('width', 'auto');
			}
		});
	},
	recommenBanner : function(){
		if($('.recommend-banner ul').hasClass('slick-initialized') !== true){
			$('.recommend-banner ul').slick({
				arrows: false, 
				dots: true,
				adaptiveHeight: true,
				infinite : false,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: carouselOptions.squarePrev,
				nextArrow: carouselOptions.squareNext, 
			});
		}
	},
	pdpNav : function(){
		if($('.pdp-thumbnail-nav ul').hasClass('slick-initialized') !== true){
			$('.pdp-thumbnail-nav ul').slick({
				arrows: true, 
				adaptiveHeight: true,
				infinite : false,
				slidesToShow: 6,
				slidesToScroll: 1,
				prevArrow: carouselOptions.squarePrev,
				nextArrow: carouselOptions.squareNext, 
				draggable : false,
				touchMove : false,
				responsive: [
					{
						breakpoint: 1500,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1,
						}
					}
				]
			});
		}
	},
	modalType : function(){
		$('#modal_pdp_detail_gallery_improve').off('show.bs.modal').on('show.bs.modal', function (e) {
			var button = $(e.relatedTarget) // 배너 버튼
			var recipient = button.data('whatever') // 배너 유형 가져오기 full && 단품
			var modal = $(this)
			$(".gallery-view-etc").find("li a").removeClass("active");
			$('#modal_pdp_detail_gallery_improve').find(".tab-area").removeClass("active");
            if(recipient == "tab_imgList"){ // 이미지 리스트
				$(".gallery-view-etc").find("li a.image-list").addClass("active");
				$("#imageLists").addClass("active");
				setTimeout(function(){
					pdp_improve.imageListSl()
				},300);
				$(".control").show()
			} else if(recipient == "tab_360_view"){ //360 v2 
				$(".gallery-view-etc").find("li a.view360_v2").addClass("active");
				$("#view360_v2").addClass("active");
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("view360_v2");	
				},300);
			} else if(recipient == "tab_Ar"){ // Ar
				$(".gallery-view-etc").find("li a.viewAr").addClass("active");
				$("#viewAr").addClass("active");
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("viewAr");	
				},300);
			} else if(recipient == "tab_Vr"){ // Vr
				$(".gallery-view-etc").find("li a.viewVr").addClass("active");
				$("#viewVr").addClass("active");
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("viewVr");	
				},300);
			} else if(recipient == "tab_360"){ //360
				$(".gallery-view-etc").find("li a.view360").addClass("active");
				$("#view360").addClass("active");
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("view360");
				},300);
			} else if(recipient == "tab_videoList"){ // 비디오 리스트
				$(".gallery-view-etc").find("li a.video-list").addClass("active");
				$("#videoLists").addClass("active");
				setTimeout(function(){
					pdp_improve.videoListSl();
					//LGEITF-947-2 Start
					//PJTSUMMARY-4(최경래) ADD - > 동영상 iframe 생성으로 인한 추가
//					pdp_improve.show_iframe("videoLists");
//					pdp_improve.changeVideo();
					//LGEITF-947-2 End
				},300);
			}
		})
		$('#modal_pdp_detail_gallery_improve').off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
			$(".control").hide()
			//LGEITF-947 Start
			$("#videoPlayerCode").remove();
			//LGEITF-947 End
			if($('#imageLists .slider-for ul').hasClass('slick-initialized') == true){
				$("#imageLists .slider-for ul").slick('unslick');
				$("#imageLists .slider-nav ul").slick('unslick');
			}
			if($('#videoLists .slider-for ul').hasClass('slick-initialized') == true){
				$("#videoLists .slider-for ul").slick('unslick');
				$("#videoLists .slider-nav ul").slick('unslick');
			}
			$('#videoLists .slider-for ul').find('.iframe-area').children().remove();
			
			//LGEITF-947-2 Start
			videoIdxGPC0009 = 0;
			//LGEITF-947-2 End
		});
	},
	imageListSl : function(){		
		var $sliderfor = $("#imageLists .slider-for ul");
		var $slidernav = $("#imageLists .slider-nav ul");				
		$sliderfor.slick({
			swipe: false,
			dots: false,
			infinite: false,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 300,
			arrows: true,
			fade: true,
			asNavFor: $("#imageLists .slider-nav ul"),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						swipe: true,
                        arrows: true,
					}
				}
			]
		});
		$slidernav.slick({
			asNavFor: $("#imageLists .slider-for ul"),
			lazyLoad: 'progressive',
			infinite: false,
			slidesToShow: 8,
			speed: 300,
			slidesToScroll: 1,
			dots: false,
			swipeToSlide : true,
			arrows: true,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 6,
					}
				},
				{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        arrows: false,
                    }
                },
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						arrows: false,
					}
				},
			]
		});	
	},
	videoListSl : function(){	
		var $sliderfor = $("#videoLists .slider-for ul");
		var $slidernav = $("#videoLists .slider-nav ul");				
		$sliderfor.slick({
			swipe: false,
			dots: false,
			infinite: false,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 300,
			arrows: true,
			fade: true,
			asNavFor: $("#videoLists .slider-nav ul"),
			//LGEITF-947-2 Start
			initialSlide : videoIdxGPC0009,
			//LGEITF-947-2 End
			responsive: [
				{
					breakpoint: 768,
					settings: {
						swipe: true
					}
				}
			]
		});
		$slidernav.slick({
			asNavFor: $("#videoLists .slider-for ul"),
			lazyLoad: 'progressive',
			infinite: false,
			slidesToShow: 8,
			slidesToScroll: 1,
			speed: 300,
			dots: false,
			swipeToSlide : true,
			arrows: true,
			focusOnSelect: true,
			//LGEITF-947-2 Start
			initialSlide : videoIdxGPC0009,
			//LGEITF-947-2 End
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 6,
					}
				},
				{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        arrows: false,
                    }
                },
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						arrows: false,
					}
				},
			]
		});
	},
	galleryBtn : function(){
		$(".gallery-view-etc").find("li a").on('click', function(){
			if($(".image-list").hasClass("active")){
				setTimeout(function(){
					if($('#imageLists .slider-for ul').hasClass('slick-initialized') !== true){
						pdp_improve.imageListSl()
					}
				},300);
				$(".control").show()
			} else{
				$(".control").hide()
			}
			if($(".video-list").hasClass("active")){
				setTimeout(function(){
					if($('#videoLists .slider-for ul').hasClass('slick-initialized') !== true){
						pdp_improve.videoListSl();
					}
					$('#videoLists .slider-for ul').find('.iframe-area').children().remove();
					$("#videoLists .slider-nav ul").find('li.slick-slide').eq(0).click();
					//LGEITF-947-2 Start
//					pdp_improve.show_iframe("videoLists");
//					pdp_improve.changeVideo();
					//LGEITF-947-2 End
				},300);
			}else{
				$('#videoLists .slider-for ul').find('.iframe-area').children().remove();
			}
			if($(".view360_v2").hasClass("active")){
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("view360_v2");	
				},300);
			}
			if($(".viewAr").hasClass("active")){
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("viewAr");	
				},300);
			}
			if($(".viewVr").hasClass("active")){
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("viewVr");	
				},300);
			}
			if($(".view360").hasClass("active")){
				//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
				setTimeout(function(){
					pdp_improve.show_iframe("view360");	
				},300);
			}
		})
	},
	//PJTSUMMARY-4(최경래) ADD - > 동영상 iframe 변경으로 인한 추가
	afterChangeVideo : function(currentSlide){
		var $this = $("#videoLists .slider-for ul").find('li.slick-slide').eq(currentSlide);
		$('#videoLists .slider-for ul').find('.iframe-area').children().remove();
		var _iframe = $this.find('.iframe-area')[0];
		if(_iframe){
			var i = $(_iframe).data(),
				html;
			if(i.type == '360' || i.type == 'vr' || i.type == 'ar') {  LGCOMSPEED-6 
				html = modal.iframe.get360viewCode(_iframe);
				$(_iframe).html(html);
			}else if(i.type == '3603D'){
				_iframe = $this.find('.iframe-area[data-type=3603D]')[0];
				if(!!!$(_iframe).html()){ 
					html = modal.iframe.get360viewCode(_iframe);
					$(_iframe).html(html);
				}
				$(_iframe).find('iframe').removeClass('d-none');
			}else if(i.type == 'youtube'){
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					$(_iframe).html('<div id="videoPlayerCode"></div>');
					setTimeout(function() {
						let timerVideo = null;
						
						function lazyloadJsVideo() {
							if(typeof YT == 'undefined') {
								console.log('undefined!!!!');
								timerVideo = setTimeout(lazyloadJsVideo, 100);
							} else {
								console.log('load!!!!');
								console.log(YT);
								if(typeof YT.Player == 'undefined') setTimeout(lazyloadJsVideo, 100);
								if(timerVideo !== null) clearTimeout(timerVideo);
						var player = new YT.Player('videoPlayerCode', {
							height: '360',
							width: '640',
							videoId: _iframe.getAttribute('data-href').split('watch?v=')[1],
							host: 'https://www.youtube.com',
							events: {
								'onReady': onPlayerReady,
								'onStateChange': onPlayerStateChange
							}
						});

						function onPlayerReady(event) {
							event.target.playVideo();
						}
						function onPlayerStateChange(event) {
							if (event.data == YT.PlayerState.PLAYING) {
								console.log('adobe-video', video.getTitle('youtube', player), 'play');
								adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'play'});
							}
							if (event.data == YT.PlayerState.PAUSED) {
								console.log('adobe-video', video.getTitle('youtube', player), 'pause');
								adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'pause'});
							}
						}
						
						var videoStatus = [0, 0, 0, 0];
						videoInterval = setInterval(function() {
							if(typeof player == 'object' && typeof player.getDuration == 'function') {
								var a = player.getDuration();
								var c = player.getCurrentTime();
								var p = parseInt((c*100)/a);
								for(var i=1;i<=4;i++) {
									if(p>=(25*i) && videoStatus[i-1]==0) {
										videoStatus[i-1] = 1;
										console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*i));
										adobeSatellite('video_track',{name:video.getTitle('youtube', player), event:'ratio_'+(25*i)});
									}
								}
								if(p>=99 && videoStatus[3]==0) {
									videoStatus[3]=1;
									console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*4));
									adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'ratio_'+(25*4)});
								}
							}
						}, 2000);
							}
						}
						lazyloadJsVideo();
					}, 10);
				} else {
					ePrivacyCookies.view('load', 'small', $(_iframe));
				}
			}else if(i.type == 'brightcove'){
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				$(_iframe).html('<div id="videoPlayerCode"></div>');
					var myPlayer,
						playerHTML,
						playerData = {
							accountId: _iframe.getAttribute('data-account'),
							playerId: _iframe.getAttribute('data-player'),
							videoId: _iframe.getAttribute('data-video-id')
						};

					playerHTML = '<video-js id="brightCovePlayer" data-video-id="' +playerData.videoId +'"  data-account="' +playerData.accountId +'" data-player="' +playerData.playerId +'" data-embed="default" data-application-id autoplay class="video-js" controls></video-js>';
					setTimeout(function() {
						
						document.getElementById("videoPlayerCode").innerHTML = playerHTML;
						var s = document.createElement("script");
						s.src = "https://players.brightcove.net/" + playerData.accountId + "/" + playerData.playerId + "_default/index.min.js"; 
						document.body.appendChild(s);
						s.onload = callback;
						function callback() {
							if($('#brightCovePlayer').length>0) {
								myPlayer = bc(document.getElementById('brightCovePlayer'));
								myPlayer.on("loadedmetadata", function() {
									myPlayer.muted(false);
									myPlayer.play();
								});
								myPlayer.on("pause", function() {
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'pause');
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'pause'});
								});
								myPlayer.on("play", function() {
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'play');
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'play'});
								});
							}
						}
						
						/* LGCOMSPEED-6(4th) Start */
						let timerVideo = null;
						
						function lazyloadJsVideo() {
							if(typeof video == 'undefined') {
								console.log('undefined!!!!');
								timerVideo = setTimeout(lazyloadJsVideo, 100);
							} else {
								console.log('load!!!!');
								console.log(video);
								if(timerVideo !== null) clearTimeout(timerVideo);
						/* LGCOMSPEED-6(4th) End */		
						var videoStatus = [0, 0, 0, 0];
						videoInterval = setInterval(function() {
							//console.log(myPlayer.mediainfo.name);
							if($('#brightCovePlayer').length>0) {
								var a = myPlayer.mediainfo.duration;
								var c = myPlayer.currentTime();
								var p = parseInt((c*100)/a);
								for(var j=1;j<=4;j++) {
									if(p>=(25*j) && videoStatus[j-1]==0) {
										videoStatus[j-1] = 1;
										console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*j));
										adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*j)});
									}
								}
								if(p>=99 && videoStatus[3]==0) {
									videoStatus[3]=1;
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*4));
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*4)});
								}
							}
						}, 2000);
						/* LGCOMSPEED-6(4th) Start */
							}
						}
						lazyloadJsVideo();
						/* LGCOMSPEED-6(4th) End */
					}, 10);
				} else {
					ePrivacyCookies.view('load', 'small', $(_iframe));
				}
			}
		}
		
	},
	//PJTSUMMARY-4(최경래) ADD - > 동영상 iframe 변경으로 인한 추가
	changeVideo : function(){
		$("#videoLists .slider-nav ul").find('li.slick-slide').on('click', function(){
			pdp_improve.afterChangeVideo($(this).data('slick-index'));
		});
	},
	//PJTSUMMARY-4(최경래) ADD - > iframe 생성으로 인한 추가
	show_iframe : function(tab_id){
		var _iframe = $('#' + tab_id).find('.iframe-area')[0];
		if(_iframe){
			var i = $(_iframe).data(),
				html;
			if(i.type == '360' || i.type == 'vr' || i.type == 'ar') {
				html = modal.iframe.get360viewCode(_iframe);
				$(_iframe).html(html);
			}else if(i.type == '3603D'){
				_iframe = $this.find('.iframe-area[data-type=3603D]')[0];
				if(!!!$(_iframe).html()){ 
					html = modal.iframe.get360viewCode(_iframe);
					$(_iframe).html(html);
				}
				$(_iframe).find('iframe').removeClass('d-none');
			
			}else if(i.type == 'youtube'){
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					$(_iframe).html('<div id="videoPlayerCode"></div>');
					setTimeout(function() {
						let timerVideo = null;
						
						function lazyloadJsVideo() {
							if(typeof YT == 'undefined') {
								console.log('undefined!!!!');
								timerVideo = setTimeout(lazyloadJsVideo, 100);
							} else {
								console.log('load!!!!');
								console.log(YT);
								if(typeof YT.Player == 'undefined') setTimeout(lazyloadJsVideo, 100);
								if(timerVideo !== null) clearTimeout(timerVideo);
						var player = new YT.Player('videoPlayerCode', {
							height: '360',
							width: '640',
							videoId: _iframe.getAttribute('data-href').split('watch?v=')[1],
							host: 'https://www.youtube.com',
							events: {
								'onReady': onPlayerReady,
								'onStateChange': onPlayerStateChange
							}
						});

						function onPlayerReady(event) {
							event.target.playVideo();
						}
						function onPlayerStateChange(event) {
							if (event.data == YT.PlayerState.PLAYING) {
								console.log('adobe-video', video.getTitle('youtube', player), 'play');
								adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'play'});
							}
							if (event.data == YT.PlayerState.PAUSED) {
								console.log('adobe-video', video.getTitle('youtube', player), 'pause');
								adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'pause'});
							}
						}
						
						var videoStatus = [0, 0, 0, 0];
						videoInterval = setInterval(function() {
							if(typeof player == 'object' && typeof player.getDuration == 'function') {
								var a = player.getDuration();
								var c = player.getCurrentTime();
								var p = parseInt((c*100)/a);
								for(var i=1;i<=4;i++) {
									if(p>=(25*i) && videoStatus[i-1]==0) {
										videoStatus[i-1] = 1;
										console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*i));
										adobeSatellite('video_track',{name:video.getTitle('youtube', player), event:'ratio_'+(25*i)});
									}
								}
								if(p>=99 && videoStatus[3]==0) {
									videoStatus[3]=1;
									console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*4));
									adobeSatellite('video_track',{name:video.getTitle('youtube', player),event:'ratio_'+(25*4)});
								}
							}
						}, 2000);
							}
						}
						lazyloadJsVideo();
					}, 10);
				} else {
					ePrivacyCookies.view('load', 'small', $(_iframe));
				}
			}else if(i.type == 'brightcove'){
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				$(_iframe).html('<div id="videoPlayerCode"></div>');
					var myPlayer,
						playerHTML,
						playerData = {
							accountId: _iframe.getAttribute('data-account'),
							playerId: _iframe.getAttribute('data-player'),
							videoId: _iframe.getAttribute('data-video-id')
						};

					playerHTML = '<video-js id="brightCovePlayer" data-video-id="' +playerData.videoId +'"  data-account="' +playerData.accountId +'" data-player="' +playerData.playerId +'" data-embed="default" data-application-id autoplay class="video-js" controls></video-js>';
					setTimeout(function() {
						document.getElementById("videoPlayerCode").innerHTML = playerHTML;
						var s = document.createElement("script");
						s.src = "https://players.brightcove.net/" + playerData.accountId + "/" + playerData.playerId + "_default/index.min.js"; 
						document.body.appendChild(s);
						s.onload = callback;
						function callback() {
							if($('#brightCovePlayer').length>0) {
								myPlayer = bc(document.getElementById('brightCovePlayer'));
								myPlayer.on("loadedmetadata", function() {
									myPlayer.muted(false);
									myPlayer.play();
								});
								myPlayer.on("pause", function() {
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'pause');
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'pause'});
								});
								myPlayer.on("play", function() {
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'play');
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'play'});
								});
							}
						}
						/* LGCOMSPEED-6(4th) Start */
						let timerVideo = null;
						function lazyloadJsVideo() {
							if(typeof video == 'undefined') {
								console.log('undefined!!!!');
								timerVideo = setTimeout(lazyloadJsVideo, 100);
							} else {
								console.log('load!!!!');
								console.log(video);
								if(timerVideo !== null) clearTimeout(timerVideo);
						/* LGCOMSPEED-6(4th) End */		
						var videoStatus = [0, 0, 0, 0];
						videoInterval = setInterval(function() {
							//console.log(myPlayer.mediainfo.name);
							if($('#brightCovePlayer').length>0) {
								var a = myPlayer.mediainfo.duration;
								var c = myPlayer.currentTime();
								var p = parseInt((c*100)/a);
								for(var j=1;j<=4;j++) {
									if(p>=(25*j) && videoStatus[j-1]==0) {
										videoStatus[j-1] = 1;
										console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*j));
										adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*j)});
									}
								}
								if(p>=99 && videoStatus[3]==0) {
									videoStatus[3]=1;
									console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*4));
									adobeSatellite('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*4)});
								}
							}
						}, 2000);
						/* LGCOMSPEED-6(4th) Start */
							}
						}
						lazyloadJsVideo();
						/* LGCOMSPEED-6(4th) End */
					}, 10);
				} else {
					ePrivacyCookies.view('load', 'small', $(_iframe));
				}
			}
		}
	}
}
pdp_improve.load();


/* PJTSUMMARY-4 price-with add-to-cart 버튼이 있을때만 show start */
/*if($(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){
	$('.price-with').show();
}*/
/* PJTSUMMARY-4 price-with add-to-cart 버튼이 있을때만 show end */


/* payment_methods 하드코딩넣어서 일단 주석처리 */
var payment_methods = {
	load : function(){
		payment_methods.get_payment_methods();
	},
	get_payment_methods : function(){
		var obsPaymentMethodUrl = $('#obsPaymentMethodUrl').val();
		var url = '/' + COUNTRY_CODE + obsPaymentMethodUrl; 
		var html_str = '';
		if('' != obsPaymentMethodUrl&& $(".GPC0009.improve").find('.button > a').hasClass('add-to-cart')== true){		
			$.ajax({
				type:"get",
				url: url,
				dataType: "json",
				success: function(data) {
					if(null!=data.main_content){
						var main_content = data.main_content;
						var obsPaymentMethodModal = data.modal;
						var $get_price_with_div = $("<div>", {id: "get-price-with"});
						$("body").append($get_price_with_div);
						$('div#get-price-with').html(main_content);
						$('div#get-price-with .cart-payment-row style').remove();
						var price_with_str = $('div#get-price-with').find('.cart-payment-toolbar').parent('div').html() + "";
						// LGEGMCOBS-61 Start
						const isModalWithpay = !Array.isArray(obsPaymentMethodModal);
						const $modalTitleMsg = $('.cart-payment-blank', '#get-price-with');
						const modalTitleText = isModalWithpay && $modalTitleMsg.length ? $modalTitleMsg.text().replace(/\r?\n|\r/g, "").trim() : '';
						// LGEGMCOBS-61 End
						$('div#get-price-with').remove();

						// LGEGMCOBS-61 Start
						const MODAL_WITHPAY = '#modal-withpay';

						if(isModalWithpay)
							html_str = html_str + '<a href="' + MODAL_WITHPAY + '" role="button" data-toggle="modal">';

						html_str = html_str + price_with_str;

						if(isModalWithpay){
							html_str = html_str + '</a>';

							let modal_close_str = $('#ajaxModalClose', MODAL_WITHPAY).length ? $('#ajaxModalClose', MODAL_WITHPAY).html() : '';
							let modal_head_str = $('#ajaxModalHeader', MODAL_WITHPAY).length ? $('#ajaxModalHeader', MODAL_WITHPAY).html() : '';
							let modal_footer_str = $('#ajaxModalFooter', MODAL_WITHPAY).length ? $('#ajaxModalFooter', MODAL_WITHPAY).html() : '';

							modal_head_str = modal_head_str.replace(/\*titleText\*/g, modalTitleText);
							$('template', MODAL_WITHPAY).remove();
							
							let modal_withpay_str = modal_close_str + modal_head_str; // append close button + head title

							const $cart_payment_blank_div = $("<div>", {id: "cart-payment-blank"});
							$("body").append($cart_payment_blank_div);
							$('div#cart-payment-blank').html(data.modal['.cart-payment-blank']);
							modal_withpay_str = modal_withpay_str + $('div#cart-payment-blank').find('.cartBlank-content').parent('div').html() + modal_footer_str; // append obs pay list + footer
							$('div#cart-payment-blank').remove();

							$(MODAL_WITHPAY).find('.modal-content').html(modal_withpay_str);
						}

						nvlFtlMsgCode(MODAL_WITHPAY);
						// LGEGMCOBS-61 End
	 					$('.price-with').each(function(){
	 						$(this).html(html_str);
	 						$(this).show();
	 					})
					}
				},
				error: function(request,status,error) {
					console.log("error : " +error);
				}
			});
		}else{
			$('.price-with').each(function(){
				$(this).hide();
			});
		}
	}
}
payment_methods.load();

$("#imageLists .slider-nav ul").on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $("#imageLists .slider-nav").find('item').removeClass('slick-current')
    $("#imageLists .pagingInfo").text(i + '/' + slick.slideCount);
    var $sliderfor = $("#imageLists .slider-for ul");
    var $slidernav = $("#imageLists .slider-nav ul");   
    var $div = $slidernav.find(".item");
    $div.off("click").on("click", function (e) {         
        e.stopPropagation();
        var idx = $(this).attr("data-slick-index");
        setTimeout(function(){
            $sliderfor.slick("slickGoTo", idx);             
        },300);
    });

});

$("#videoLists .slider-nav ul").on('init afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    //LGEITF-947-2 Start
//    var i = (currentSlide ? currentSlide : 0) + 1;
    var i = 0;
    if (typeof currentSlide == "undefined") {
        i = videoIdxGPC0009 + 1;
    } else {
        i = currentSlide + 1;
    }
    //LGEITF-947-2 End
    $("#videoLists .slider-nav").find('item').removeClass('slick-current')
    $("#videoLists .pagingInfo").text(i + '/' + slick.slideCount);
    var $sliderfor = $("#videoLists .slider-for ul");
    var $slidernav = $("#videoLists .slider-nav ul");   
    var $div = $slidernav.find(".item");
    if(slick.$list[0].offsetWidth > slick.$slideTrack[0].offsetWidth){
        $("#videoLists .slick-track").addClass('trans_fixed')
    } else{
        $("#videoLists .slick-track").removeClass('trans_fixed')
    }
    
    //LGEITF-947 Start
    setTimeout(function(){
        pdp_improve.afterChangeVideo((typeof currentSlide == "undefined") ? videoIdxGPC0009 : currentSlide);
        $slidernav.find(".slick-slide").removeClass("slick-current");
        $slidernav.find(".slick-slide").eq((typeof currentSlide == "undefined") ? videoIdxGPC0009 : currentSlide).addClass("slick-current");
    },300);
    //LGEITF-947 End
    
    $div.on("click", function (e) {         
        e.stopPropagation();
        var idx = $(this).attr("data-slick-index");
        setTimeout(function(){
            $sliderfor.slick("slickGoTo", idx);             
        },300);
    });
});

$("#btn-features .more").on('click', function(){
	$(".feature-move").removeClass("d-none");
});

$("#btn-features .less").on('click', function(){
	$(".feature-move").addClass("d-none");
});
}
/* PJTSUMMARY-4_krchoi END */

/* LGCOMSPEED-8 Start */
$(window).on('load', function() {
    $('.GPC0009.improve #desktop_summary_gallery .pdp-visual-image').css('aspect-ratio', 'auto');
    $('.GPC0009.improve #mobile_summary_gallery .pdp-visual').css('min-height', 'auto');
    $('.GPC0009.before .pdp-visual-area.hidden-sm .pdp-visual-image').css('aspect-ratio', 'auto');
    $('.GPC0009.before .pdp-visual-area.visible-sm .pdp-visual').css('aspect-ratio', 'auto');
    $('.GPC0009.before .pdp-visual-area.visible-sm .pdp-visual').css('min-height', 'auto');
});
/* LGCOMSPEED-8 End */

/* PJTPPDPAOB-1 start */
var totalOriginSellPrice = ''; //변동되기전 토탈금액 (타 기능에 의하여 계산되는 곳이 있으므로 addonbundle은 토탈 영역값을 기준으로 변동시킴)
var totalOriginPrice = '';
var totalOriginSavePrice = '';
function calculateBundleAndTotalPrice(ea){
	
	var viewArea = $(".mobile-bottom-info").is(":visible") ? '.mobile-bottom-info' : '.desktop-info';
	var currencyText = $('.GPC0009.improve').find('#currencyText').val();
	var currencyPosition = $('.GPC0009.improve').find('#currencyPosition').val();
	var currencyDot = $('.GPC0009.improve').find('#currencyDot').val();
	var mainModelIds = $('.GPC0009').attr('data-model-id');
	var bundleModel = '';
	var rPrice = '';
	var rPriceCent = '';
	var rPromoPrice =  '';
	var rPromoPriceCent = '';
	var rDiscountedPrice = ''; 
	var rDiscountedPriceCent = '';
	
	
	$('.price-box-area .added-price .price-box.added').remove();
	var bundlePriceTotal = '';  //최종가
	var bundleOriginPriceTotal = ''; //할인전
	var bundleDiscountPriceTotal = ''; //디스카운트
	$(viewArea).find('.bundle-select').each(function(i){
		if($(this).find('.act').length > 0){
			
			bundleModel += ','+$(this).attr('data-modelId');
			var html = $('#addOnBundleAttachTemplate').clone().html();
			
			rPrice = $(this).attr('data-rPrice');
			rPriceCent = $(this).attr('data-rPriceCent');
			rPromoPrice =  $(this).attr('data-rPromoPrice');
			rPromoPriceCent = $(this).attr('data-rPromoPriceCent');
			rDiscountedPrice = $(this).attr('data-rDiscountedPrice'); 
			rDiscountedPriceCent = $(this).attr('data-rDiscountedPriceCent');
			
			html =  html.replace(/\*rPrice\*/g, rPrice)
						.replace(/\*modelId\*/g, $(this).attr('data-modelId'))
	 					.replace(/\*rPriceCent\*/g, rPriceCent)
	 					.replace(/\*rPromoPrice\*/g, rPromoPrice)
	 					.replace(/\*rPromoPriceCent\*/g, rPromoPriceCent)
	 					.replace(/\*rDiscountedPrice\*/g, rDiscountedPrice)
	 					.replace(/\*rDiscountedPriceCent\*/g, rDiscountedPriceCent)
	 					.replace(/\*modelName\*/g, $(this).attr('data-modelName'))
	 					.replace(/\*discountedPrice\*/g, changeFormatFullPriceSync(rPromoPrice,rPromoPriceCent)) //최종 판매가
	 					.replace(/\*onlyPrice\*/g,  $(this).attr('data-onlyPrice')) //판매가만 있는 FLAG (price룰 441 : 가격룰 예외 : 정상가 할인가 보다 크지 않으면 제외)
			
			$('.price-box-area .added-price').append(html);
			
			
			var bundlePrice = nvl(rPromoPrice, '0');
			var bundlePriceCent = nvl(rPromoPriceCent, '00');
			var price = bundlePrice+"."+bundlePriceCent;
			bundlePriceTotal = Number(bundlePriceTotal) + Number(price);
			
			var bundleOriginPrice = nvl(rPrice, '0');
			var bundleOriginPriceCent = nvl(rPriceCent, '00');
			var priceOrigin = bundleOriginPrice+"."+bundleOriginPriceCent;

			bundleOriginPriceTotal = Number(bundleOriginPriceTotal) + Number(priceOrigin);
			
			var bundleDiscountPrice = nvl(rDiscountedPrice, '0');
			var bundleDiscountPriceCent = nvl(rDiscountedPriceCent, '00');
			var priceDiscount = bundleDiscountPrice+"."+bundleDiscountPriceCent;

			bundleDiscountPriceTotal = Number(bundleDiscountPriceTotal) + Number(priceDiscount);
		}
	})
	$('.GPC0009 .add-to-cart').data('model-id',mainModelIds+bundleModel).attr('data-model-id',mainModelIds+bundleModel);//LGCOMAU-104 
	$('.GPC0011 .add-to-cart').data('model-id',mainModelIds+bundleModel).attr('data-model-id',mainModelIds+bundleModel);//LGCOMAU-104 
	
	//토탈 영역 금액 + 번들 값 계산
	var discountMsg = $("#msg_disCount").val();
	var totalPrice = $(viewArea).find('.price-total-box .total-price-num strong').text().replace(currencyText,'').trim();
	var totalSumPrice = $(viewArea).find('.total-price-all .total-del del').text().replace(currencyText,'').trim();
	var totalDisCountPrice = $(viewArea).find('.total-price-all .total-save').text().replace(discountMsg,'').replace(currencyText,'').trim();
	
	
	var totalPriceCent = '';
	var arrTotalPrice = '';
	var calcTotalPrice = '';
	
	var totalSumPriceCent = '';
	var arrTotalSumPrice = '';
	var calcTotalSumPrice = '';
	
	var totalDisCountPriceCent = '';
	var arrTotalDisCountPrice = '';
	var calcTotalDisCountPrice = '';
	
	
	//기준 값 셋팅
	if(totalOriginSellPrice == ''){
		totalOriginSellPrice =  totalPrice;
	}
	if(totalOriginPrice == ''){
		totalOriginPrice =  totalSumPrice != '' ? totalSumPrice : totalPrice;
	}
	if(totalOriginSavePrice == ''){
		totalOriginSavePrice =  totalDisCountPrice != '' ? totalDisCountPrice : '0';
	}
	
	
	
	//판매가
	if(totalOriginSellPrice.indexOf(currencyDot)!= -1){
            arrTotalPrice = totalOriginSellPrice.split(currencyDot);
            totalPrice = nvl(arrTotalPrice[0],'0').replace(' ','').replace('.','').replace(',','')
            totalPriceCent = nvl(arrTotalPrice[1],'00');
            calcTotalPrice = Number(totalPrice+'.'+totalPriceCent);
    }else{
		totalPrice = totalOriginSellPrice;
		calcTotalPrice = Number(totalPrice);
	}
	
	//원가 (할인전)
	if(totalOriginPrice.indexOf(currencyDot)!= -1){
            arrTotalSumPrice = totalOriginPrice.split(currencyDot);
            totalSumPrice = nvl(arrTotalSumPrice[0],'0').replace(' ','').replace('.','').replace(',','')
            totalSumPriceCent = nvl(arrTotalSumPrice[1],'00');
            calcTotalSumPrice = Number(totalSumPrice+'.'+totalSumPriceCent);
    }else{
		totalSumPrice = totalOriginPrice;
		calcTotalSumPrice = Number(totalSumPrice);
	}
	//디스카운트
	if(totalOriginSavePrice.indexOf(currencyDot)!= -1){
            arrTotalDisCountPrice = totalOriginSavePrice.split(currencyDot);
            totalDisCountPrice = nvl(arrTotalDisCountPrice[0],'0').replace(' ','').replace('.','').replace(',','')
            totalDisCountPriceCent = nvl(arrTotalDisCountPrice[1],'00');
            calcTotalDisCountPrice = Number(totalDisCountPrice+'.'+totalDisCountPriceCent);
    }else{
		totalDisCountPrice = totalOriginSavePrice;
		calcTotalDisCountPrice = Number(totalDisCountPrice);
	}
	
	
	var digit = 0;
	var rPriceCentLength = '';
	var rPromoPriceCentLength = '';
	
	if(null != rPriceCent && '' != rPriceCent && undefined != rPriceCent){
		rPriceCentLength = rPriceCent.length;
	}
	if(null != rPromoPriceCent && '' != rPromoPriceCent && undefined != rPromoPriceCent){
		rPromoPriceCentLength = rPriceCent.length;
	}
	
	
	if(null != totalPriceCent && '' != totalPriceCent && undefined != totalPriceCent){
			digit = totalPriceCent.length;
	}
	
	if(digit == 0){
		digit = rPriceCentLength > rPromoPriceCentLength ? rPriceCentLength : rPromoPriceCentLength
	}
	 
	var finalPrice = Number(calcTotalPrice) + Number(bundlePriceTotal);
	var arrFinalPrice = Number(finalPrice).toFixed(digit).toString().split('.');
	var totalPriceString  = changeFormatFullPriceSync(arrFinalPrice[0],arrFinalPrice[1]);
	
	var finalSumPrice = Number(calcTotalSumPrice) + Number(bundleOriginPriceTotal);
	var arrFinalSumPrice = Number(finalSumPrice).toFixed(digit).toString().split('.');
	var totalSumPriceString  = changeFormatFullPriceSync(arrFinalSumPrice[0],arrFinalSumPrice[1]);
	
	var finalDiscountPrice = Number(calcTotalDisCountPrice) + Number(bundleDiscountPriceTotal);
	var arrFinalDiscountPrice = Number(finalDiscountPrice).toFixed(digit).toString().split('.');
	var totalDiscountPriceString  = changeFormatFullPriceSync(arrFinalDiscountPrice[0],arrFinalDiscountPrice[1]);
	
	
	if('L' == currencyPosition){
			$('.total-price-num strong').text(currencyText + totalPriceString);
			$('.total-del del').text(currencyText + totalSumPriceString);
			$('.total-save').text(discountMsg+' '+currencyText + totalDiscountPriceString);
	}else{
			$('.total-price-num strong').text(totalPriceString + currencyText);
			$('.total-del del').text(totalSumPriceString + currencyText);
			$('.total-save').text(discountMsg+' '+ totalDiscountPriceString + currencyText);
			
	}
	$('.product-stickytab .product-selling-price .price.active .number').text(totalPriceString);
	$('.product-stickytab .product-selling-price .product-price .number').text(totalSumPriceString);
	
	
	var discountMsgType = $('#discountMsgType').val();
	var msg = '';
	var discountInfo = '';
	if($('.product-stickytab').length > 0){
		if(discountMsgType == 'PERCENT'){
			msg = $('#msg_discount_percent').val();
			discountInfo = 100 - (Number(nvl(finalPrice,0))/Number(nvl(finalSumPrice,0)) * 100).toFixed(0);
			$('.product-stickytab .product-selling-price .product-price .legal').text(msg.replace('{1}',discountInfo));  //할인율 또는 할인가격
			
		}else if(discountMsgType == 'PRICE'){
			msg = $('#msg_discount_price').val();
			discountInfo = Number(nvl(finalSumPrice,0)) - Number(nvl(finalPrice,0)) ;
			var arrDisCountInfo = Number(discountInfo).toFixed(digit).toString().split('.');
			var discountInfoString = changeFormatFullPriceSync(arrDisCountInfo[0],arrDisCountInfo[1]);
			
			$('.product-stickytab .product-selling-price .product-price .legal').text(msg.replace('{2}',discountInfoString));  //할인율 또는 할인가격
		}
	}
	
	
}

var stickyOriginDiscountFlag = $('.product-stickytab .product-selling-price .product-price').hasClass('active');  //gpc0011 할일영역 존재여부
var stickyOriginDiscountText = $('.product-stickytab .product-selling-price .product-price .legal').text();
var priceTotalBoxAtiveFlag = '';
  
function bundleSelect(ea){
    var selectL = $(ea).find("li.bundle-select > a.act").length;
    $(".add-bundle-area .bundle-ea").text(selectL);
    var stickyPriceArea = $('.product-stickytab .product-selling-price .product-price');
    if(selectL > 0){
        $(".add-bundle-area .more-tit, .add-bundle-area .bundle-ea").addClass("after");
        $('.price-box-area .added-price').addClass('act');
        
        if(priceTotalBoxAtiveFlag == 'N' || $('.price-total-box').attr('data-detail') == 'N'){
        	$('.price-total-box').addClass('add-detail');
		}
        
        if(!stickyOriginDiscountFlag){
			stickyPriceArea.addClass('active')	
		}
        
    } else{
        $(".add-bundle-area .more-tit, .add-bundle-area .bundle-ea").removeClass("after")
		$('.price-box-area .added-price').removeClass('act');
		
		if(priceTotalBoxAtiveFlag == 'N' || $('.price-total-box').attr('data-detail') == 'N'){  
        	$('.price-total-box').removeClass('add-detail');
		}
		
		if(stickyOriginDiscountFlag){
			$('.product-stickytab .product-selling-price .product-price .legal').text(stickyOriginDiscountText);
		}else{
			stickyPriceArea.removeClass('active');
			$('.product-stickytab .product-selling-price .product-price .legal').text('');
		}
    }
    calculateBundleAndTotalPrice(ea);
}

$('.GPC0009').on('click', 'li.bundle-select > a', function(e) {
    e.preventDefault();
    var ea = $(this).parents('.add-bundle-area');
    /*LGCOMAU-104 Start*/
    if(COUNTRY_CODE.toLowerCase() == 'au' && typeof ea.data('main-model-flag') !="undefined" && !ea.data('main-model-flag')){
    	if($("#addOnMainModelError").length>0){
    		$("#addOnMainModelError").modal();
    	}
    	return false
    }
    if(COUNTRY_CODE.toLowerCase() == 'au' && !$('.GPC0009').find(".check-good").length>0){
    	if($("#addOnPincodeError").length>0){
    		$("#addOnPincodeError").modal();
    	}
    	return false
    }
    /*LGCOMAU-104 End*/
    var checkList = $(this).closest('li').index() + 1;
    if($(this).hasClass('act')){
        $('li.bundle-select:nth-child('+checkList+')').find('a').attr('aria-selected', false).removeClass('act');
    } else{
        $('li.bundle-select:nth-child('+checkList+')').find('a').attr('aria-selected', true).addClass('act');
    }
    bundleSelect(ea)
    
});

/* PJTPPDPAOB-1 end */